(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.apolloSentryLink = factory());
})(this, (function () { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function getAugmentedNamespace(n) {
	  var f = n.default;
		if (typeof f == "function") {
			var a = function () {
				return f.apply(this, arguments);
			};
			a.prototype = f.prototype;
	  } else a = {};
	  Object.defineProperty(a, '__esModule', {value: true});
		Object.keys(n).forEach(function (k) {
			var d = Object.getOwnPropertyDescriptor(n, k);
			Object.defineProperty(a, k, d.get ? d : {
				enumerable: true,
				get: function () {
					return n[k];
				}
			});
		});
		return a;
	}

	var lib$1 = {};

	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global Reflect, Promise */

	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};

	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}

	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};

	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                t[p[i]] = s[p[i]];
	        }
	    return t;
	}

	function __decorate(decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	}

	function __param(paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	}

	function __metadata(metadataKey, metadataValue) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	}

	function __awaiter(thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	}

	function __generator(thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	}

	function __createBinding(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}

	function __exportStar(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	}

	function __values(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	}

	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}

	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read(arguments[i]));
	    return ar;
	}

	function __spreadArrays() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}
	function __await(v) {
	    return this instanceof __await ? (this.v = v, this) : new __await(v);
	}

	function __asyncGenerator(thisArg, _arguments, generator) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var g = generator.apply(thisArg, _arguments || []), i, q = [];
	    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
	    function fulfill(value) { resume("next", value); }
	    function reject(value) { resume("throw", value); }
	    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	}

	function __asyncDelegator(o) {
	    var i, p;
	    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	}

	function __asyncValues(o) {
	    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	    var m = o[Symbol.asyncIterator], i;
	    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	}

	function __makeTemplateObject(cooked, raw) {
	    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	    return cooked;
	}
	function __importStar(mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	    result.default = mod;
	    return result;
	}

	function __importDefault(mod) {
	    return (mod && mod.__esModule) ? mod : { default: mod };
	}

	function __classPrivateFieldGet(receiver, privateMap) {
	    if (!privateMap.has(receiver)) {
	        throw new TypeError("attempted to get private field on non-instance");
	    }
	    return privateMap.get(receiver);
	}

	function __classPrivateFieldSet(receiver, privateMap, value) {
	    if (!privateMap.has(receiver)) {
	        throw new TypeError("attempted to set private field on non-instance");
	    }
	    privateMap.set(receiver, value);
	    return value;
	}

	var tslib_es6 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		__extends: __extends,
		get __assign () { return __assign; },
		__rest: __rest,
		__decorate: __decorate,
		__param: __param,
		__metadata: __metadata,
		__awaiter: __awaiter,
		__generator: __generator,
		__createBinding: __createBinding,
		__exportStar: __exportStar,
		__values: __values,
		__read: __read,
		__spread: __spread,
		__spreadArrays: __spreadArrays,
		__await: __await,
		__asyncGenerator: __asyncGenerator,
		__asyncDelegator: __asyncDelegator,
		__asyncValues: __asyncValues,
		__makeTemplateObject: __makeTemplateObject,
		__importStar: __importStar,
		__importDefault: __importDefault,
		__classPrivateFieldGet: __classPrivateFieldGet,
		__classPrivateFieldSet: __classPrivateFieldSet
	});

	var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

	var link = {};

	var lib = {};

	var zenObservable$1 = {};

	var Observable = {};

	var hasRequiredObservable;

	function requireObservable () {
		if (hasRequiredObservable) return Observable;
		hasRequiredObservable = 1;

		Object.defineProperty(Observable, "__esModule", {
		  value: true
		});
		Observable.Observable = void 0;

		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

		function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

		function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

		// === Symbol Support ===
		var hasSymbols = function () {
		  return typeof Symbol === 'function';
		};

		var hasSymbol = function (name) {
		  return hasSymbols() && Boolean(Symbol[name]);
		};

		var getSymbol = function (name) {
		  return hasSymbol(name) ? Symbol[name] : '@@' + name;
		};

		if (hasSymbols() && !hasSymbol('observable')) {
		  Symbol.observable = Symbol('observable');
		}

		var SymbolIterator = getSymbol('iterator');
		var SymbolObservable = getSymbol('observable');
		var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

		function getMethod(obj, key) {
		  var value = obj[key];
		  if (value == null) return undefined;
		  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
		  return value;
		}

		function getSpecies(obj) {
		  var ctor = obj.constructor;

		  if (ctor !== undefined) {
		    ctor = ctor[SymbolSpecies];

		    if (ctor === null) {
		      ctor = undefined;
		    }
		  }

		  return ctor !== undefined ? ctor : Observable$1;
		}

		function isObservable(x) {
		  return x instanceof Observable$1; // SPEC: Brand check
		}

		function hostReportError(e) {
		  if (hostReportError.log) {
		    hostReportError.log(e);
		  } else {
		    setTimeout(function () {
		      throw e;
		    });
		  }
		}

		function enqueue(fn) {
		  Promise.resolve().then(function () {
		    try {
		      fn();
		    } catch (e) {
		      hostReportError(e);
		    }
		  });
		}

		function cleanupSubscription(subscription) {
		  var cleanup = subscription._cleanup;
		  if (cleanup === undefined) return;
		  subscription._cleanup = undefined;

		  if (!cleanup) {
		    return;
		  }

		  try {
		    if (typeof cleanup === 'function') {
		      cleanup();
		    } else {
		      var unsubscribe = getMethod(cleanup, 'unsubscribe');

		      if (unsubscribe) {
		        unsubscribe.call(cleanup);
		      }
		    }
		  } catch (e) {
		    hostReportError(e);
		  }
		}

		function closeSubscription(subscription) {
		  subscription._observer = undefined;
		  subscription._queue = undefined;
		  subscription._state = 'closed';
		}

		function flushSubscription(subscription) {
		  var queue = subscription._queue;

		  if (!queue) {
		    return;
		  }

		  subscription._queue = undefined;
		  subscription._state = 'ready';

		  for (var i = 0; i < queue.length; ++i) {
		    notifySubscription(subscription, queue[i].type, queue[i].value);
		    if (subscription._state === 'closed') break;
		  }
		}

		function notifySubscription(subscription, type, value) {
		  subscription._state = 'running';
		  var observer = subscription._observer;

		  try {
		    var m = getMethod(observer, type);

		    switch (type) {
		      case 'next':
		        if (m) m.call(observer, value);
		        break;

		      case 'error':
		        closeSubscription(subscription);
		        if (m) m.call(observer, value);else throw value;
		        break;

		      case 'complete':
		        closeSubscription(subscription);
		        if (m) m.call(observer);
		        break;
		    }
		  } catch (e) {
		    hostReportError(e);
		  }

		  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
		}

		function onNotify(subscription, type, value) {
		  if (subscription._state === 'closed') return;

		  if (subscription._state === 'buffering') {
		    subscription._queue.push({
		      type: type,
		      value: value
		    });

		    return;
		  }

		  if (subscription._state !== 'ready') {
		    subscription._state = 'buffering';
		    subscription._queue = [{
		      type: type,
		      value: value
		    }];
		    enqueue(function () {
		      return flushSubscription(subscription);
		    });
		    return;
		  }

		  notifySubscription(subscription, type, value);
		}

		var Subscription =
		/*#__PURE__*/
		function () {
		  function Subscription(observer, subscriber) {
		    _classCallCheck(this, Subscription);

		    // ASSERT: observer is an object
		    // ASSERT: subscriber is callable
		    this._cleanup = undefined;
		    this._observer = observer;
		    this._queue = undefined;
		    this._state = 'initializing';
		    var subscriptionObserver = new SubscriptionObserver(this);

		    try {
		      this._cleanup = subscriber.call(undefined, subscriptionObserver);
		    } catch (e) {
		      subscriptionObserver.error(e);
		    }

		    if (this._state === 'initializing') this._state = 'ready';
		  }

		  _createClass(Subscription, [{
		    key: "unsubscribe",
		    value: function unsubscribe() {
		      if (this._state !== 'closed') {
		        closeSubscription(this);
		        cleanupSubscription(this);
		      }
		    }
		  }, {
		    key: "closed",
		    get: function () {
		      return this._state === 'closed';
		    }
		  }]);

		  return Subscription;
		}();

		var SubscriptionObserver =
		/*#__PURE__*/
		function () {
		  function SubscriptionObserver(subscription) {
		    _classCallCheck(this, SubscriptionObserver);

		    this._subscription = subscription;
		  }

		  _createClass(SubscriptionObserver, [{
		    key: "next",
		    value: function next(value) {
		      onNotify(this._subscription, 'next', value);
		    }
		  }, {
		    key: "error",
		    value: function error(value) {
		      onNotify(this._subscription, 'error', value);
		    }
		  }, {
		    key: "complete",
		    value: function complete() {
		      onNotify(this._subscription, 'complete');
		    }
		  }, {
		    key: "closed",
		    get: function () {
		      return this._subscription._state === 'closed';
		    }
		  }]);

		  return SubscriptionObserver;
		}();

		var Observable$1 =
		/*#__PURE__*/
		function () {
		  function Observable(subscriber) {
		    _classCallCheck(this, Observable);

		    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
		    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
		    this._subscriber = subscriber;
		  }

		  _createClass(Observable, [{
		    key: "subscribe",
		    value: function subscribe(observer) {
		      if (typeof observer !== 'object' || observer === null) {
		        observer = {
		          next: observer,
		          error: arguments[1],
		          complete: arguments[2]
		        };
		      }

		      return new Subscription(observer, this._subscriber);
		    }
		  }, {
		    key: "forEach",
		    value: function forEach(fn) {
		      var _this = this;

		      return new Promise(function (resolve, reject) {
		        if (typeof fn !== 'function') {
		          reject(new TypeError(fn + ' is not a function'));
		          return;
		        }

		        function done() {
		          subscription.unsubscribe();
		          resolve();
		        }

		        var subscription = _this.subscribe({
		          next: function (value) {
		            try {
		              fn(value, done);
		            } catch (e) {
		              reject(e);
		              subscription.unsubscribe();
		            }
		          },
		          error: reject,
		          complete: resolve
		        });
		      });
		    }
		  }, {
		    key: "map",
		    value: function map(fn) {
		      var _this2 = this;

		      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
		      var C = getSpecies(this);
		      return new C(function (observer) {
		        return _this2.subscribe({
		          next: function (value) {
		            try {
		              value = fn(value);
		            } catch (e) {
		              return observer.error(e);
		            }

		            observer.next(value);
		          },
		          error: function (e) {
		            observer.error(e);
		          },
		          complete: function () {
		            observer.complete();
		          }
		        });
		      });
		    }
		  }, {
		    key: "filter",
		    value: function filter(fn) {
		      var _this3 = this;

		      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
		      var C = getSpecies(this);
		      return new C(function (observer) {
		        return _this3.subscribe({
		          next: function (value) {
		            try {
		              if (!fn(value)) return;
		            } catch (e) {
		              return observer.error(e);
		            }

		            observer.next(value);
		          },
		          error: function (e) {
		            observer.error(e);
		          },
		          complete: function () {
		            observer.complete();
		          }
		        });
		      });
		    }
		  }, {
		    key: "reduce",
		    value: function reduce(fn) {
		      var _this4 = this;

		      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
		      var C = getSpecies(this);
		      var hasSeed = arguments.length > 1;
		      var hasValue = false;
		      var seed = arguments[1];
		      var acc = seed;
		      return new C(function (observer) {
		        return _this4.subscribe({
		          next: function (value) {
		            var first = !hasValue;
		            hasValue = true;

		            if (!first || hasSeed) {
		              try {
		                acc = fn(acc, value);
		              } catch (e) {
		                return observer.error(e);
		              }
		            } else {
		              acc = value;
		            }
		          },
		          error: function (e) {
		            observer.error(e);
		          },
		          complete: function () {
		            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
		            observer.next(acc);
		            observer.complete();
		          }
		        });
		      });
		    }
		  }, {
		    key: "concat",
		    value: function concat() {
		      var _this5 = this;

		      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
		        sources[_key] = arguments[_key];
		      }

		      var C = getSpecies(this);
		      return new C(function (observer) {
		        var subscription;
		        var index = 0;

		        function startNext(next) {
		          subscription = next.subscribe({
		            next: function (v) {
		              observer.next(v);
		            },
		            error: function (e) {
		              observer.error(e);
		            },
		            complete: function () {
		              if (index === sources.length) {
		                subscription = undefined;
		                observer.complete();
		              } else {
		                startNext(C.from(sources[index++]));
		              }
		            }
		          });
		        }

		        startNext(_this5);
		        return function () {
		          if (subscription) {
		            subscription.unsubscribe();
		            subscription = undefined;
		          }
		        };
		      });
		    }
		  }, {
		    key: "flatMap",
		    value: function flatMap(fn) {
		      var _this6 = this;

		      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
		      var C = getSpecies(this);
		      return new C(function (observer) {
		        var subscriptions = [];

		        var outer = _this6.subscribe({
		          next: function (value) {
		            if (fn) {
		              try {
		                value = fn(value);
		              } catch (e) {
		                return observer.error(e);
		              }
		            }

		            var inner = C.from(value).subscribe({
		              next: function (value) {
		                observer.next(value);
		              },
		              error: function (e) {
		                observer.error(e);
		              },
		              complete: function () {
		                var i = subscriptions.indexOf(inner);
		                if (i >= 0) subscriptions.splice(i, 1);
		                completeIfDone();
		              }
		            });
		            subscriptions.push(inner);
		          },
		          error: function (e) {
		            observer.error(e);
		          },
		          complete: function () {
		            completeIfDone();
		          }
		        });

		        function completeIfDone() {
		          if (outer.closed && subscriptions.length === 0) observer.complete();
		        }

		        return function () {
		          subscriptions.forEach(function (s) {
		            return s.unsubscribe();
		          });
		          outer.unsubscribe();
		        };
		      });
		    }
		  }, {
		    key: SymbolObservable,
		    value: function () {
		      return this;
		    }
		  }], [{
		    key: "from",
		    value: function from(x) {
		      var C = typeof this === 'function' ? this : Observable;
		      if (x == null) throw new TypeError(x + ' is not an object');
		      var method = getMethod(x, SymbolObservable);

		      if (method) {
		        var observable = method.call(x);
		        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
		        if (isObservable(observable) && observable.constructor === C) return observable;
		        return new C(function (observer) {
		          return observable.subscribe(observer);
		        });
		      }

		      if (hasSymbol('iterator')) {
		        method = getMethod(x, SymbolIterator);

		        if (method) {
		          return new C(function (observer) {
		            enqueue(function () {
		              if (observer.closed) return;
		              var _iteratorNormalCompletion = true;
		              var _didIteratorError = false;
		              var _iteratorError = undefined;

		              try {
		                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		                  var _item = _step.value;
		                  observer.next(_item);
		                  if (observer.closed) return;
		                }
		              } catch (err) {
		                _didIteratorError = true;
		                _iteratorError = err;
		              } finally {
		                try {
		                  if (!_iteratorNormalCompletion && _iterator.return != null) {
		                    _iterator.return();
		                  }
		                } finally {
		                  if (_didIteratorError) {
		                    throw _iteratorError;
		                  }
		                }
		              }

		              observer.complete();
		            });
		          });
		        }
		      }

		      if (Array.isArray(x)) {
		        return new C(function (observer) {
		          enqueue(function () {
		            if (observer.closed) return;

		            for (var i = 0; i < x.length; ++i) {
		              observer.next(x[i]);
		              if (observer.closed) return;
		            }

		            observer.complete();
		          });
		        });
		      }

		      throw new TypeError(x + ' is not observable');
		    }
		  }, {
		    key: "of",
		    value: function of() {
		      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		        items[_key2] = arguments[_key2];
		      }

		      var C = typeof this === 'function' ? this : Observable;
		      return new C(function (observer) {
		        enqueue(function () {
		          if (observer.closed) return;

		          for (var i = 0; i < items.length; ++i) {
		            observer.next(items[i]);
		            if (observer.closed) return;
		          }

		          observer.complete();
		        });
		      });
		    }
		  }, {
		    key: SymbolSpecies,
		    get: function () {
		      return this;
		    }
		  }]);

		  return Observable;
		}();

		Observable.Observable = Observable$1;

		if (hasSymbols()) {
		  Object.defineProperty(Observable$1, Symbol('extensions'), {
		    value: {
		      symbol: SymbolObservable,
		      hostReportError: hostReportError
		    },
		    configurable: true
		  });
		}
		return Observable;
	}

	var zenObservable;
	var hasRequiredZenObservable$1;

	function requireZenObservable$1 () {
		if (hasRequiredZenObservable$1) return zenObservable;
		hasRequiredZenObservable$1 = 1;
		zenObservable = requireObservable().Observable;
		return zenObservable;
	}

	var hasRequiredZenObservable;

	function requireZenObservable () {
		if (hasRequiredZenObservable) return zenObservable$1;
		hasRequiredZenObservable = 1;
		Object.defineProperty(zenObservable$1, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var zen_observable_1 = tslib_1.__importDefault(requireZenObservable$1());
		zenObservable$1.Observable = zen_observable_1.default;
		
		return zenObservable$1;
	}

	var hasRequiredLib;

	function requireLib () {
		if (hasRequiredLib) return lib;
		hasRequiredLib = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			var tslib_1 = require$$0$1;
			var zenObservable_1 = requireZenObservable();
			tslib_1.__exportStar(requireZenObservable(), exports);
			exports.default = zenObservable_1.Observable;
			
	} (lib));
		return lib;
	}

	var invariant$1 = {};

	var hasRequiredInvariant;

	function requireInvariant () {
		if (hasRequiredInvariant) return invariant$1;
		hasRequiredInvariant = 1;
		(function (exports) {

			Object.defineProperty(exports, '__esModule', { value: true });

			var tslib = require$$0$1;

			var genericMessage = "Invariant Violation";
			var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
			    obj.__proto__ = proto;
			    return obj;
			} : _a;
			var InvariantError = /** @class */ (function (_super) {
			    tslib.__extends(InvariantError, _super);
			    function InvariantError(message) {
			        if (message === void 0) { message = genericMessage; }
			        var _this = _super.call(this, typeof message === "number"
			            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
			            : message) || this;
			        _this.framesToPop = 1;
			        _this.name = genericMessage;
			        setPrototypeOf(_this, InvariantError.prototype);
			        return _this;
			    }
			    return InvariantError;
			}(Error));
			function invariant(condition, message) {
			    if (!condition) {
			        throw new InvariantError(message);
			    }
			}
			function wrapConsoleMethod(method) {
			    return function () {
			        return console[method].apply(console, arguments);
			    };
			}
			(function (invariant) {
			    invariant.warn = wrapConsoleMethod("warn");
			    invariant.error = wrapConsoleMethod("error");
			})(invariant || (invariant = {}));
			// Code that uses ts-invariant with rollup-plugin-invariant may want to
			// import this process stub to avoid errors evaluating process.env.NODE_ENV.
			// However, because most ESM-to-CJS compilers will rewrite the process import
			// as tsInvariant.process, which prevents proper replacement by minifiers, we
			// also attempt to define the stub globally when it is not already defined.
			exports.process = { env: {} };
			if (typeof process === "object") {
			    exports.process = process;
			}
			else
			    try {
			        // Using Function to evaluate this assignment in global scope also escapes
			        // the strict mode of the current module, thereby allowing the assignment.
			        // Inspired by https://github.com/facebook/regenerator/pull/369.
			        Function("stub", "process = stub")(exports.process);
			    }
			    catch (atLeastWeTried) {
			        // The assignment can fail if a Content Security Policy heavy-handedly
			        // forbids Function usage. In those environments, developers should take
			        // extra care to replace process.env.NODE_ENV in their production builds,
			        // or define an appropriate global.process polyfill.
			    }
			var invariant$1 = invariant;

			exports.default = invariant$1;
			exports.InvariantError = InvariantError;
			exports.invariant = invariant;
			
	} (invariant$1));
		return invariant$1;
	}

	var linkUtils = {};

	var bundle_cjs = {};

	// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
	var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
	var nodejsCustomInspectSymbol$1 = nodejsCustomInspectSymbol;

	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	var MAX_ARRAY_LENGTH = 10;
	var MAX_RECURSIVE_DEPTH = 2;
	/**
	 * Used to print values in error messages.
	 */

	function inspect(value) {
	  return formatValue(value, []);
	}

	function formatValue(value, seenValues) {
	  switch (_typeof(value)) {
	    case 'string':
	      return JSON.stringify(value);

	    case 'function':
	      return value.name ? "[function ".concat(value.name, "]") : '[function]';

	    case 'object':
	      if (value === null) {
	        return 'null';
	      }

	      return formatObjectValue(value, seenValues);

	    default:
	      return String(value);
	  }
	}

	function formatObjectValue(value, previouslySeenValues) {
	  if (previouslySeenValues.indexOf(value) !== -1) {
	    return '[Circular]';
	  }

	  var seenValues = [].concat(previouslySeenValues, [value]);
	  var customInspectFn = getCustomFn(value);

	  if (customInspectFn !== undefined) {
	    var customValue = customInspectFn.call(value); // check for infinite recursion

	    if (customValue !== value) {
	      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
	    }
	  } else if (Array.isArray(value)) {
	    return formatArray(value, seenValues);
	  }

	  return formatObject(value, seenValues);
	}

	function formatObject(object, seenValues) {
	  var keys = Object.keys(object);

	  if (keys.length === 0) {
	    return '{}';
	  }

	  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
	    return '[' + getObjectTag(object) + ']';
	  }

	  var properties = keys.map(function (key) {
	    var value = formatValue(object[key], seenValues);
	    return key + ': ' + value;
	  });
	  return '{ ' + properties.join(', ') + ' }';
	}

	function formatArray(array, seenValues) {
	  if (array.length === 0) {
	    return '[]';
	  }

	  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
	    return '[Array]';
	  }

	  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
	  var remaining = array.length - len;
	  var items = [];

	  for (var i = 0; i < len; ++i) {
	    items.push(formatValue(array[i], seenValues));
	  }

	  if (remaining === 1) {
	    items.push('... 1 more item');
	  } else if (remaining > 1) {
	    items.push("... ".concat(remaining, " more items"));
	  }

	  return '[' + items.join(', ') + ']';
	}

	function getCustomFn(object) {
	  var customInspectFn = object[String(nodejsCustomInspectSymbol$1)];

	  if (typeof customInspectFn === 'function') {
	    return customInspectFn;
	  }

	  if (typeof object.inspect === 'function') {
	    return object.inspect;
	  }
	}

	function getObjectTag(object) {
	  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

	  if (tag === 'Object' && typeof object.constructor === 'function') {
	    var name = object.constructor.name;

	    if (typeof name === 'string' && name !== '') {
	      return name;
	    }
	  }

	  return tag;
	}

	function invariant(condition, message) {
	  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

	  if (!booleanCondition) {
	    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
	  }
	}

	/**
	 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
	 */

	function defineInspect(classObject) {
	  var fn = classObject.prototype.toJSON;
	  typeof fn === 'function' || invariant(0);
	  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

	  if (nodejsCustomInspectSymbol$1) {
	    classObject.prototype[nodejsCustomInspectSymbol$1] = fn;
	  }
	}

	/**
	 * Contains a range of UTF-8 character offsets and token references that
	 * identify the region of the source from which the AST derived.
	 */
	var Location = /*#__PURE__*/function () {
	  /**
	   * The character offset at which this Node begins.
	   */

	  /**
	   * The character offset at which this Node ends.
	   */

	  /**
	   * The Token at which this Node begins.
	   */

	  /**
	   * The Token at which this Node ends.
	   */

	  /**
	   * The Source document the AST represents.
	   */
	  function Location(startToken, endToken, source) {
	    this.start = startToken.start;
	    this.end = endToken.end;
	    this.startToken = startToken;
	    this.endToken = endToken;
	    this.source = source;
	  }

	  var _proto = Location.prototype;

	  _proto.toJSON = function toJSON() {
	    return {
	      start: this.start,
	      end: this.end
	    };
	  };

	  return Location;
	}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

	defineInspect(Location);
	/**
	 * Represents a range of characters represented by a lexical token
	 * within a Source.
	 */

	var Token = /*#__PURE__*/function () {
	  /**
	   * The kind of Token.
	   */

	  /**
	   * The character offset at which this Node begins.
	   */

	  /**
	   * The character offset at which this Node ends.
	   */

	  /**
	   * The 1-indexed line number on which this Token appears.
	   */

	  /**
	   * The 1-indexed column number at which this Token begins.
	   */

	  /**
	   * For non-punctuation tokens, represents the interpreted value of the token.
	   */

	  /**
	   * Tokens exist as nodes in a double-linked-list amongst all tokens
	   * including ignored tokens. <SOF> is always the first node and <EOF>
	   * the last.
	   */
	  function Token(kind, start, end, line, column, prev, value) {
	    this.kind = kind;
	    this.start = start;
	    this.end = end;
	    this.line = line;
	    this.column = column;
	    this.value = value;
	    this.prev = prev;
	    this.next = null;
	  }

	  var _proto2 = Token.prototype;

	  _proto2.toJSON = function toJSON() {
	    return {
	      kind: this.kind,
	      value: this.value,
	      line: this.line,
	      column: this.column
	    };
	  };

	  return Token;
	}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

	defineInspect(Token);
	/**
	 * @internal
	 */

	function isNode(maybeNode) {
	  return maybeNode != null && typeof maybeNode.kind === 'string';
	}
	/**
	 * The list of all possible AST node types.
	 */

	/**
	 * A visitor is provided to visit, it contains the collection of
	 * relevant functions to be called during the visitor's traversal.
	 */

	var QueryDocumentKeys = {
	  Name: [],
	  Document: ['definitions'],
	  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
	  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
	  Variable: ['name'],
	  SelectionSet: ['selections'],
	  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
	  Argument: ['name', 'value'],
	  FragmentSpread: ['name', 'directives'],
	  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
	  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
	  // or removed in the future.
	  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
	  IntValue: [],
	  FloatValue: [],
	  StringValue: [],
	  BooleanValue: [],
	  NullValue: [],
	  EnumValue: [],
	  ListValue: ['values'],
	  ObjectValue: ['fields'],
	  ObjectField: ['name', 'value'],
	  Directive: ['name', 'arguments'],
	  NamedType: ['name'],
	  ListType: ['type'],
	  NonNullType: ['type'],
	  SchemaDefinition: ['description', 'directives', 'operationTypes'],
	  OperationTypeDefinition: ['type'],
	  ScalarTypeDefinition: ['description', 'name', 'directives'],
	  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
	  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
	  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
	  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
	  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
	  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
	  EnumValueDefinition: ['description', 'name', 'directives'],
	  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
	  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
	  SchemaExtension: ['directives', 'operationTypes'],
	  ScalarTypeExtension: ['name', 'directives'],
	  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
	  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
	  UnionTypeExtension: ['name', 'directives', 'types'],
	  EnumTypeExtension: ['name', 'directives', 'values'],
	  InputObjectTypeExtension: ['name', 'directives', 'fields']
	};
	var BREAK = Object.freeze({});
	/**
	 * visit() will walk through an AST using a depth-first traversal, calling
	 * the visitor's enter function at each node in the traversal, and calling the
	 * leave function after visiting that node and all of its child nodes.
	 *
	 * By returning different values from the enter and leave functions, the
	 * behavior of the visitor can be altered, including skipping over a sub-tree of
	 * the AST (by returning false), editing the AST by returning a value or null
	 * to remove the value, or to stop the whole traversal by returning BREAK.
	 *
	 * When using visit() to edit an AST, the original AST will not be modified, and
	 * a new version of the AST with the changes applied will be returned from the
	 * visit function.
	 *
	 *     const editedAST = visit(ast, {
	 *       enter(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: skip visiting this node
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       },
	 *       leave(node, key, parent, path, ancestors) {
	 *         // @return
	 *         //   undefined: no action
	 *         //   false: no action
	 *         //   visitor.BREAK: stop visiting altogether
	 *         //   null: delete this node
	 *         //   any value: replace this node with the returned value
	 *       }
	 *     });
	 *
	 * Alternatively to providing enter() and leave() functions, a visitor can
	 * instead provide functions named the same as the kinds of AST nodes, or
	 * enter/leave visitors at a named key, leading to four permutations of the
	 * visitor API:
	 *
	 * 1) Named visitors triggered when entering a node of a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind(node) {
	 *         // enter the "Kind" node
	 *       }
	 *     })
	 *
	 * 2) Named visitors that trigger upon entering and leaving a node of
	 *    a specific kind.
	 *
	 *     visit(ast, {
	 *       Kind: {
	 *         enter(node) {
	 *           // enter the "Kind" node
	 *         }
	 *         leave(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 *
	 * 3) Generic visitors that trigger upon entering and leaving any node.
	 *
	 *     visit(ast, {
	 *       enter(node) {
	 *         // enter any node
	 *       },
	 *       leave(node) {
	 *         // leave any node
	 *       }
	 *     })
	 *
	 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
	 *
	 *     visit(ast, {
	 *       enter: {
	 *         Kind(node) {
	 *           // enter the "Kind" node
	 *         }
	 *       },
	 *       leave: {
	 *         Kind(node) {
	 *           // leave the "Kind" node
	 *         }
	 *       }
	 *     })
	 */

	function visit(root, visitor) {
	  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

	  /* eslint-disable no-undef-init */
	  var stack = undefined;
	  var inArray = Array.isArray(root);
	  var keys = [root];
	  var index = -1;
	  var edits = [];
	  var node = undefined;
	  var key = undefined;
	  var parent = undefined;
	  var path = [];
	  var ancestors = [];
	  var newRoot = root;
	  /* eslint-enable no-undef-init */

	  do {
	    index++;
	    var isLeaving = index === keys.length;
	    var isEdited = isLeaving && edits.length !== 0;

	    if (isLeaving) {
	      key = ancestors.length === 0 ? undefined : path[path.length - 1];
	      node = parent;
	      parent = ancestors.pop();

	      if (isEdited) {
	        if (inArray) {
	          node = node.slice();
	        } else {
	          var clone = {};

	          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
	            var k = _Object$keys2[_i2];
	            clone[k] = node[k];
	          }

	          node = clone;
	        }

	        var editOffset = 0;

	        for (var ii = 0; ii < edits.length; ii++) {
	          var editKey = edits[ii][0];
	          var editValue = edits[ii][1];

	          if (inArray) {
	            editKey -= editOffset;
	          }

	          if (inArray && editValue === null) {
	            node.splice(editKey, 1);
	            editOffset++;
	          } else {
	            node[editKey] = editValue;
	          }
	        }
	      }

	      index = stack.index;
	      keys = stack.keys;
	      edits = stack.edits;
	      inArray = stack.inArray;
	      stack = stack.prev;
	    } else {
	      key = parent ? inArray ? index : keys[index] : undefined;
	      node = parent ? parent[key] : newRoot;

	      if (node === null || node === undefined) {
	        continue;
	      }

	      if (parent) {
	        path.push(key);
	      }
	    }

	    var result = void 0;

	    if (!Array.isArray(node)) {
	      if (!isNode(node)) {
	        throw new Error("Invalid AST Node: ".concat(inspect(node), "."));
	      }

	      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

	      if (visitFn) {
	        result = visitFn.call(visitor, node, key, parent, path, ancestors);

	        if (result === BREAK) {
	          break;
	        }

	        if (result === false) {
	          if (!isLeaving) {
	            path.pop();
	            continue;
	          }
	        } else if (result !== undefined) {
	          edits.push([key, result]);

	          if (!isLeaving) {
	            if (isNode(result)) {
	              node = result;
	            } else {
	              path.pop();
	              continue;
	            }
	          }
	        }
	      }
	    }

	    if (result === undefined && isEdited) {
	      edits.push([key, node]);
	    }

	    if (isLeaving) {
	      path.pop();
	    } else {
	      var _visitorKeys$node$kin;

	      stack = {
	        inArray: inArray,
	        index: index,
	        keys: keys,
	        edits: edits,
	        prev: stack
	      };
	      inArray = Array.isArray(node);
	      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
	      index = -1;
	      edits = [];

	      if (parent) {
	        ancestors.push(parent);
	      }

	      parent = node;
	    }
	  } while (stack !== undefined);

	  if (edits.length !== 0) {
	    newRoot = edits[edits.length - 1][1];
	  }

	  return newRoot;
	}
	/**
	 * Creates a new visitor instance which delegates to many visitors to run in
	 * parallel. Each visitor will be visited for each node before moving on.
	 *
	 * If a prior visitor edits a node, no following visitors will see that node.
	 */

	function visitInParallel(visitors) {
	  var skipping = new Array(visitors.length);
	  return {
	    enter: function enter(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (skipping[i] == null) {
	          var fn = getVisitFn(visitors[i], node.kind,
	          /* isLeaving */
	          false);

	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);

	            if (result === false) {
	              skipping[i] = node;
	            } else if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined) {
	              return result;
	            }
	          }
	        }
	      }
	    },
	    leave: function leave(node) {
	      for (var i = 0; i < visitors.length; i++) {
	        if (skipping[i] == null) {
	          var fn = getVisitFn(visitors[i], node.kind,
	          /* isLeaving */
	          true);

	          if (fn) {
	            var result = fn.apply(visitors[i], arguments);

	            if (result === BREAK) {
	              skipping[i] = BREAK;
	            } else if (result !== undefined && result !== false) {
	              return result;
	            }
	          }
	        } else if (skipping[i] === node) {
	          skipping[i] = null;
	        }
	      }
	    }
	  };
	}
	/**
	 * Given a visitor instance, if it is leaving or not, and a node kind, return
	 * the function the visitor runtime should call.
	 */

	function getVisitFn(visitor, kind, isLeaving) {
	  var kindVisitor = visitor[kind];

	  if (kindVisitor) {
	    if (!isLeaving && typeof kindVisitor === 'function') {
	      // { Kind() {} }
	      return kindVisitor;
	    }

	    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

	    if (typeof kindSpecificVisitor === 'function') {
	      // { Kind: { enter() {}, leave() {} } }
	      return kindSpecificVisitor;
	    }
	  } else {
	    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

	    if (specificVisitor) {
	      if (typeof specificVisitor === 'function') {
	        // { enter() {}, leave() {} }
	        return specificVisitor;
	      }

	      var specificKindVisitor = specificVisitor[kind];

	      if (typeof specificKindVisitor === 'function') {
	        // { enter: { Kind() {} }, leave: { Kind() {} } }
	        return specificKindVisitor;
	      }
	    }
	  }
	}

	var visitor = /*#__PURE__*/Object.freeze({
		__proto__: null,
		QueryDocumentKeys: QueryDocumentKeys,
		BREAK: BREAK,
		visit: visit,
		visitInParallel: visitInParallel,
		getVisitFn: getVisitFn
	});

	var require$$0 = /*@__PURE__*/getAugmentedNamespace(visitor);

	var fastJsonStableStringify;
	var hasRequiredFastJsonStableStringify;

	function requireFastJsonStableStringify () {
		if (hasRequiredFastJsonStableStringify) return fastJsonStableStringify;
		hasRequiredFastJsonStableStringify = 1;

		fastJsonStableStringify = function (data, opts) {
		    if (!opts) opts = {};
		    if (typeof opts === 'function') opts = { cmp: opts };
		    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

		    var cmp = opts.cmp && (function (f) {
		        return function (node) {
		            return function (a, b) {
		                var aobj = { key: a, value: node[a] };
		                var bobj = { key: b, value: node[b] };
		                return f(aobj, bobj);
		            };
		        };
		    })(opts.cmp);

		    var seen = [];
		    return (function stringify (node) {
		        if (node && node.toJSON && typeof node.toJSON === 'function') {
		            node = node.toJSON();
		        }

		        if (node === undefined) return;
		        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
		        if (typeof node !== 'object') return JSON.stringify(node);

		        var i, out;
		        if (Array.isArray(node)) {
		            out = '[';
		            for (i = 0; i < node.length; i++) {
		                if (i) out += ',';
		                out += stringify(node[i]) || 'null';
		            }
		            return out + ']';
		        }

		        if (node === null) return 'null';

		        if (seen.indexOf(node) !== -1) {
		            if (cycles) return JSON.stringify('__cycle__');
		            throw new TypeError('Converting circular structure to JSON');
		        }

		        var seenIndex = seen.push(node) - 1;
		        var keys = Object.keys(node).sort(cmp && cmp(node));
		        out = '';
		        for (i = 0; i < keys.length; i++) {
		            var key = keys[i];
		            var value = stringify(node[key]);

		            if (!value) continue;
		            if (out) out += ',';
		            out += JSON.stringify(key) + ':' + value;
		        }
		        seen.splice(seenIndex, 1);
		        return '{' + out + '}';
		    })(data);
		};
		return fastJsonStableStringify;
	}

	var equality = {};

	var hasRequiredEquality;

	function requireEquality () {
		if (hasRequiredEquality) return equality;
		hasRequiredEquality = 1;

		Object.defineProperty(equality, '__esModule', { value: true });

		var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
		var previousComparisons = new Map();
		/**
		 * Performs a deep equality check on two JavaScript values, tolerating cycles.
		 */
		function equal(a, b) {
		    try {
		        return check(a, b);
		    }
		    finally {
		        previousComparisons.clear();
		    }
		}
		function check(a, b) {
		    // If the two values are strictly equal, our job is easy.
		    if (a === b) {
		        return true;
		    }
		    // Object.prototype.toString returns a representation of the runtime type of
		    // the given value that is considerably more precise than typeof.
		    var aTag = toString.call(a);
		    var bTag = toString.call(b);
		    // If the runtime types of a and b are different, they could maybe be equal
		    // under some interpretation of equality, but for simplicity and performance
		    // we just return false instead.
		    if (aTag !== bTag) {
		        return false;
		    }
		    switch (aTag) {
		        case '[object Array]':
		            // Arrays are a lot like other objects, but we can cheaply compare their
		            // lengths as a short-cut before comparing their elements.
		            if (a.length !== b.length)
		                return false;
		        // Fall through to object case...
		        case '[object Object]': {
		            if (previouslyCompared(a, b))
		                return true;
		            var aKeys = Object.keys(a);
		            var bKeys = Object.keys(b);
		            // If `a` and `b` have a different number of enumerable keys, they
		            // must be different.
		            var keyCount = aKeys.length;
		            if (keyCount !== bKeys.length)
		                return false;
		            // Now make sure they have the same keys.
		            for (var k = 0; k < keyCount; ++k) {
		                if (!hasOwnProperty.call(b, aKeys[k])) {
		                    return false;
		                }
		            }
		            // Finally, check deep equality of all child properties.
		            for (var k = 0; k < keyCount; ++k) {
		                var key = aKeys[k];
		                if (!check(a[key], b[key])) {
		                    return false;
		                }
		            }
		            return true;
		        }
		        case '[object Error]':
		            return a.name === b.name && a.message === b.message;
		        case '[object Number]':
		            // Handle NaN, which is !== itself.
		            if (a !== a)
		                return b !== b;
		        // Fall through to shared +a === +b case...
		        case '[object Boolean]':
		        case '[object Date]':
		            return +a === +b;
		        case '[object RegExp]':
		        case '[object String]':
		            return a == "" + b;
		        case '[object Map]':
		        case '[object Set]': {
		            if (a.size !== b.size)
		                return false;
		            if (previouslyCompared(a, b))
		                return true;
		            var aIterator = a.entries();
		            var isMap = aTag === '[object Map]';
		            while (true) {
		                var info = aIterator.next();
		                if (info.done)
		                    break;
		                // If a instanceof Set, aValue === aKey.
		                var _a = info.value, aKey = _a[0], aValue = _a[1];
		                // So this works the same way for both Set and Map.
		                if (!b.has(aKey)) {
		                    return false;
		                }
		                // However, we care about deep equality of values only when dealing
		                // with Map structures.
		                if (isMap && !check(aValue, b.get(aKey))) {
		                    return false;
		                }
		            }
		            return true;
		        }
		    }
		    // Otherwise the values are not equal.
		    return false;
		}
		function previouslyCompared(a, b) {
		    // Though cyclic references can make an object graph appear infinite from the
		    // perspective of a depth-first traversal, the graph still contains a finite
		    // number of distinct object references. We use the previousComparisons cache
		    // to avoid comparing the same pair of object references more than once, which
		    // guarantees termination (even if we end up comparing every object in one
		    // graph to every object in the other graph, which is extremely unlikely),
		    // while still allowing weird isomorphic structures (like rings with different
		    // lengths) a chance to pass the equality test.
		    var bSet = previousComparisons.get(a);
		    if (bSet) {
		        // Return true here because we can be sure false will be returned somewhere
		        // else if the objects are not equivalent.
		        if (bSet.has(b))
		            return true;
		    }
		    else {
		        previousComparisons.set(a, bSet = new Set);
		    }
		    bSet.add(b);
		    return false;
		}

		equality.default = equal;
		equality.equal = equal;
		
		return equality;
	}

	var hasRequiredBundle_cjs;

	function requireBundle_cjs () {
		if (hasRequiredBundle_cjs) return bundle_cjs;
		hasRequiredBundle_cjs = 1;
		bundle_cjs.__esModule = true;
		bundle_cjs.addTypenameToDocument = addTypenameToDocument;
		bundle_cjs.argumentsObjectFromField = argumentsObjectFromField;
		bundle_cjs.assign = assign;
		bundle_cjs.buildQueryFromSelectionSet = buildQueryFromSelectionSet;
		bundle_cjs.checkDocument = checkDocument;
		bundle_cjs.cloneDeep = cloneDeep;
		bundle_cjs.createFragmentMap = createFragmentMap;
		bundle_cjs.getDefaultValues = getDefaultValues;
		bundle_cjs.getDirectiveInfoFromField = getDirectiveInfoFromField;
		bundle_cjs.getDirectiveNames = getDirectiveNames;
		bundle_cjs.getDirectivesFromDocument = getDirectivesFromDocument;
		bundle_cjs.getEnv = getEnv;
		bundle_cjs.getFragmentDefinition = getFragmentDefinition;
		bundle_cjs.getFragmentDefinitions = getFragmentDefinitions;
		bundle_cjs.getFragmentQueryDocument = getFragmentQueryDocument;
		bundle_cjs.getInclusionDirectives = getInclusionDirectives;
		bundle_cjs.getMainDefinition = getMainDefinition;
		bundle_cjs.getMutationDefinition = getMutationDefinition;
		bundle_cjs.getOperationDefinition = getOperationDefinition;
		bundle_cjs.getOperationDefinitionOrDie = getOperationDefinitionOrDie;
		bundle_cjs.getOperationName = getOperationName;
		bundle_cjs.getQueryDefinition = getQueryDefinition;
		bundle_cjs.getStoreKeyName = getStoreKeyName;
		bundle_cjs.graphQLResultHasError = graphQLResultHasError;
		bundle_cjs.hasClientExports = hasClientExports;
		bundle_cjs.hasDirectives = hasDirectives;
		bundle_cjs.isDevelopment = isDevelopment;
		bundle_cjs.isEnv = isEnv;
		bundle_cjs.isField = isField;
		bundle_cjs.isIdValue = isIdValue;
		bundle_cjs.isInlineFragment = isInlineFragment;
		bundle_cjs.isJsonValue = isJsonValue;
		bundle_cjs.isNumberValue = isNumberValue;
		bundle_cjs.isProduction = isProduction;
		bundle_cjs.isScalarValue = isScalarValue;
		bundle_cjs.isTest = isTest;
		bundle_cjs.maybeDeepFreeze = maybeDeepFreeze;
		bundle_cjs.mergeDeep = mergeDeep;
		bundle_cjs.mergeDeepArray = mergeDeepArray;
		bundle_cjs.removeArgumentsFromDocument = removeArgumentsFromDocument;
		bundle_cjs.removeClientSetsFromDocument = removeClientSetsFromDocument;
		bundle_cjs.removeConnectionDirectiveFromDocument = removeConnectionDirectiveFromDocument;
		bundle_cjs.removeDirectivesFromDocument = removeDirectivesFromDocument;
		bundle_cjs.removeFragmentSpreadFromDocument = removeFragmentSpreadFromDocument;
		bundle_cjs.resultKeyNameFromField = resultKeyNameFromField;
		bundle_cjs.shouldInclude = shouldInclude;
		bundle_cjs.storeKeyNameFromField = storeKeyNameFromField;
		bundle_cjs.stripSymbols = stripSymbols;
		bundle_cjs.toIdValue = toIdValue;
		bundle_cjs.tryFunctionOrLogError = tryFunctionOrLogError;
		bundle_cjs.valueFromNode = valueFromNode;
		bundle_cjs.valueToObjectRepresentation = valueToObjectRepresentation;
		bundle_cjs.variablesInOperation = variablesInOperation;
		bundle_cjs.warnOnceInDevelopment = warnOnceInDevelopment;
		bundle_cjs.canUseWeakMap = bundle_cjs.isEqual = void 0;

		var _visitor = require$$0;

		var _tsInvariant = requireInvariant();

		var _tslib = require$$0$1;

		var _fastJsonStableStringify = _interopRequireDefault(requireFastJsonStableStringify());

		var _equality = requireEquality();

		bundle_cjs.isEqual = _equality.equal;

		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

		function isScalarValue(value) {
		  return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
		}

		function isNumberValue(value) {
		  return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
		}

		function isStringValue(value) {
		  return value.kind === 'StringValue';
		}

		function isBooleanValue(value) {
		  return value.kind === 'BooleanValue';
		}

		function isIntValue(value) {
		  return value.kind === 'IntValue';
		}

		function isFloatValue(value) {
		  return value.kind === 'FloatValue';
		}

		function isVariable(value) {
		  return value.kind === 'Variable';
		}

		function isObjectValue(value) {
		  return value.kind === 'ObjectValue';
		}

		function isListValue(value) {
		  return value.kind === 'ListValue';
		}

		function isEnumValue(value) {
		  return value.kind === 'EnumValue';
		}

		function isNullValue(value) {
		  return value.kind === 'NullValue';
		}

		function valueToObjectRepresentation(argObj, name, value, variables) {
		  if (isIntValue(value) || isFloatValue(value)) {
		    argObj[name.value] = Number(value.value);
		  } else if (isBooleanValue(value) || isStringValue(value)) {
		    argObj[name.value] = value.value;
		  } else if (isObjectValue(value)) {
		    var nestedArgObj_1 = {};
		    value.fields.map(function (obj) {
		      return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
		    });
		    argObj[name.value] = nestedArgObj_1;
		  } else if (isVariable(value)) {
		    var variableValue = (variables || {})[value.name.value];
		    argObj[name.value] = variableValue;
		  } else if (isListValue(value)) {
		    argObj[name.value] = value.values.map(function (listValue) {
		      var nestedArgArrayObj = {};
		      valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
		      return nestedArgArrayObj[name.value];
		    });
		  } else if (isEnumValue(value)) {
		    argObj[name.value] = value.value;
		  } else if (isNullValue(value)) {
		    argObj[name.value] = null;
		  } else {
		    throw process.env.NODE_ENV === "production" ? new _tsInvariant.InvariantError(17) : new _tsInvariant.InvariantError("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\"" + 'is not supported. Use variables instead of inline arguments to ' + 'overcome this limitation.');
		  }
		}

		function storeKeyNameFromField(field, variables) {
		  var directivesObj = null;

		  if (field.directives) {
		    directivesObj = {};
		    field.directives.forEach(function (directive) {
		      directivesObj[directive.name.value] = {};

		      if (directive.arguments) {
		        directive.arguments.forEach(function (_a) {
		          var name = _a.name,
		              value = _a.value;
		          return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
		        });
		      }
		    });
		  }

		  var argObj = null;

		  if (field.arguments && field.arguments.length) {
		    argObj = {};
		    field.arguments.forEach(function (_a) {
		      var name = _a.name,
		          value = _a.value;
		      return valueToObjectRepresentation(argObj, name, value, variables);
		    });
		  }

		  return getStoreKeyName(field.name.value, argObj, directivesObj);
		}

		var KNOWN_DIRECTIVES = ['connection', 'include', 'skip', 'client', 'rest', 'export'];

		function getStoreKeyName(fieldName, args, directives) {
		  if (directives && directives['connection'] && directives['connection']['key']) {
		    if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
		      var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
		      filterKeys.sort();
		      var queryArgs_1 = args;
		      var filteredArgs_1 = {};
		      filterKeys.forEach(function (key) {
		        filteredArgs_1[key] = queryArgs_1[key];
		      });
		      return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
		    } else {
		      return directives['connection']['key'];
		    }
		  }

		  var completeFieldName = fieldName;

		  if (args) {
		    var stringifiedArgs = (0, _fastJsonStableStringify.default)(args);
		    completeFieldName += "(" + stringifiedArgs + ")";
		  }

		  if (directives) {
		    Object.keys(directives).forEach(function (key) {
		      if (KNOWN_DIRECTIVES.indexOf(key) !== -1) return;

		      if (directives[key] && Object.keys(directives[key]).length) {
		        completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
		      } else {
		        completeFieldName += "@" + key;
		      }
		    });
		  }

		  return completeFieldName;
		}

		function argumentsObjectFromField(field, variables) {
		  if (field.arguments && field.arguments.length) {
		    var argObj_1 = {};
		    field.arguments.forEach(function (_a) {
		      var name = _a.name,
		          value = _a.value;
		      return valueToObjectRepresentation(argObj_1, name, value, variables);
		    });
		    return argObj_1;
		  }

		  return null;
		}

		function resultKeyNameFromField(field) {
		  return field.alias ? field.alias.value : field.name.value;
		}

		function isField(selection) {
		  return selection.kind === 'Field';
		}

		function isInlineFragment(selection) {
		  return selection.kind === 'InlineFragment';
		}

		function isIdValue(idObject) {
		  return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
		}

		function toIdValue(idConfig, generated) {
		  if (generated === void 0) {
		    generated = false;
		  }

		  return (0, _tslib.__assign)({
		    type: 'id',
		    generated: generated
		  }, typeof idConfig === 'string' ? {
		    id: idConfig,
		    typename: undefined
		  } : idConfig);
		}

		function isJsonValue(jsonObject) {
		  return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
		}

		function defaultValueFromVariable(node) {
		  throw process.env.NODE_ENV === "production" ? new _tsInvariant.InvariantError(18) : new _tsInvariant.InvariantError("Variable nodes are not supported by valueFromNode");
		}

		function valueFromNode(node, onVariable) {
		  if (onVariable === void 0) {
		    onVariable = defaultValueFromVariable;
		  }

		  switch (node.kind) {
		    case 'Variable':
		      return onVariable(node);

		    case 'NullValue':
		      return null;

		    case 'IntValue':
		      return parseInt(node.value, 10);

		    case 'FloatValue':
		      return parseFloat(node.value);

		    case 'ListValue':
		      return node.values.map(function (v) {
		        return valueFromNode(v, onVariable);
		      });

		    case 'ObjectValue':
		      {
		        var value = {};

		        for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
		          var field = _a[_i];
		          value[field.name.value] = valueFromNode(field.value, onVariable);
		        }

		        return value;
		      }

		    default:
		      return node.value;
		  }
		}

		function getDirectiveInfoFromField(field, variables) {
		  if (field.directives && field.directives.length) {
		    var directiveObj_1 = {};
		    field.directives.forEach(function (directive) {
		      directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
		    });
		    return directiveObj_1;
		  }

		  return null;
		}

		function shouldInclude(selection, variables) {
		  if (variables === void 0) {
		    variables = {};
		  }

		  return getInclusionDirectives(selection.directives).every(function (_a) {
		    var directive = _a.directive,
		        ifArgument = _a.ifArgument;
		    var evaledValue = false;

		    if (ifArgument.value.kind === 'Variable') {
		      evaledValue = variables[ifArgument.value.name.value];
		      process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(evaledValue !== void 0, 13) : (0, _tsInvariant.invariant)(evaledValue !== void 0, "Invalid variable referenced in @" + directive.name.value + " directive.");
		    } else {
		      evaledValue = ifArgument.value.value;
		    }

		    return directive.name.value === 'skip' ? !evaledValue : evaledValue;
		  });
		}

		function getDirectiveNames(doc) {
		  var names = [];
		  (0, _visitor.visit)(doc, {
		    Directive: function (node) {
		      names.push(node.name.value);
		    }
		  });
		  return names;
		}

		function hasDirectives(names, doc) {
		  return getDirectiveNames(doc).some(function (name) {
		    return names.indexOf(name) > -1;
		  });
		}

		function hasClientExports(document) {
		  return document && hasDirectives(['client'], document) && hasDirectives(['export'], document);
		}

		function isInclusionDirective(_a) {
		  var value = _a.name.value;
		  return value === 'skip' || value === 'include';
		}

		function getInclusionDirectives(directives) {
		  return directives ? directives.filter(isInclusionDirective).map(function (directive) {
		    var directiveArguments = directive.arguments;
		    var directiveName = directive.name.value;
		    process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(directiveArguments && directiveArguments.length === 1, 14) : (0, _tsInvariant.invariant)(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @" + directiveName + " directive.");
		    var ifArgument = directiveArguments[0];
		    process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15) : (0, _tsInvariant.invariant)(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @" + directiveName + " directive.");
		    var ifValue = ifArgument.value;
		    process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16) : (0, _tsInvariant.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
		    return {
		      directive: directive,
		      ifArgument: ifArgument
		    };
		  }) : [];
		}

		function getFragmentQueryDocument(document, fragmentName) {
		  var actualFragmentName = fragmentName;
		  var fragments = [];
		  document.definitions.forEach(function (definition) {
		    if (definition.kind === 'OperationDefinition') {
		      throw process.env.NODE_ENV === "production" ? new _tsInvariant.InvariantError(11) : new _tsInvariant.InvariantError("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " + 'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
		    }

		    if (definition.kind === 'FragmentDefinition') {
		      fragments.push(definition);
		    }
		  });

		  if (typeof actualFragmentName === 'undefined') {
		    process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(fragments.length === 1, 12) : (0, _tsInvariant.invariant)(fragments.length === 1, "Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
		    actualFragmentName = fragments[0].name.value;
		  }

		  var query = (0, _tslib.__assign)((0, _tslib.__assign)({}, document), {
		    definitions: (0, _tslib.__spreadArrays)([{
		      kind: 'OperationDefinition',
		      operation: 'query',
		      selectionSet: {
		        kind: 'SelectionSet',
		        selections: [{
		          kind: 'FragmentSpread',
		          name: {
		            kind: 'Name',
		            value: actualFragmentName
		          }
		        }]
		      }
		    }], document.definitions)
		  });
		  return query;
		}

		function assign(target) {
		  var sources = [];

		  for (var _i = 1; _i < arguments.length; _i++) {
		    sources[_i - 1] = arguments[_i];
		  }

		  sources.forEach(function (source) {
		    if (typeof source === 'undefined' || source === null) {
		      return;
		    }

		    Object.keys(source).forEach(function (key) {
		      target[key] = source[key];
		    });
		  });
		  return target;
		}

		function getMutationDefinition(doc) {
		  checkDocument(doc);
		  var mutationDef = doc.definitions.filter(function (definition) {
		    return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
		  })[0];
		  process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(mutationDef, 1) : (0, _tsInvariant.invariant)(mutationDef, 'Must contain a mutation definition.');
		  return mutationDef;
		}

		function checkDocument(doc) {
		  process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(doc && doc.kind === 'Document', 2) : (0, _tsInvariant.invariant)(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
		  var operations = doc.definitions.filter(function (d) {
		    return d.kind !== 'FragmentDefinition';
		  }).map(function (definition) {
		    if (definition.kind !== 'OperationDefinition') {
		      throw process.env.NODE_ENV === "production" ? new _tsInvariant.InvariantError(3) : new _tsInvariant.InvariantError("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
		    }

		    return definition;
		  });
		  process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(operations.length <= 1, 4) : (0, _tsInvariant.invariant)(operations.length <= 1, "Ambiguous GraphQL document: contains " + operations.length + " operations");
		  return doc;
		}

		function getOperationDefinition(doc) {
		  checkDocument(doc);
		  return doc.definitions.filter(function (definition) {
		    return definition.kind === 'OperationDefinition';
		  })[0];
		}

		function getOperationDefinitionOrDie(document) {
		  var def = getOperationDefinition(document);
		  process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(def, 5) : (0, _tsInvariant.invariant)(def, "GraphQL document is missing an operation");
		  return def;
		}

		function getOperationName(doc) {
		  return doc.definitions.filter(function (definition) {
		    return definition.kind === 'OperationDefinition' && definition.name;
		  }).map(function (x) {
		    return x.name.value;
		  })[0] || null;
		}

		function getFragmentDefinitions(doc) {
		  return doc.definitions.filter(function (definition) {
		    return definition.kind === 'FragmentDefinition';
		  });
		}

		function getQueryDefinition(doc) {
		  var queryDef = getOperationDefinition(doc);
		  process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(queryDef && queryDef.operation === 'query', 6) : (0, _tsInvariant.invariant)(queryDef && queryDef.operation === 'query', 'Must contain a query definition.');
		  return queryDef;
		}

		function getFragmentDefinition(doc) {
		  process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(doc.kind === 'Document', 7) : (0, _tsInvariant.invariant)(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
		  process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(doc.definitions.length <= 1, 8) : (0, _tsInvariant.invariant)(doc.definitions.length <= 1, 'Fragment must have exactly one definition.');
		  var fragmentDef = doc.definitions[0];
		  process.env.NODE_ENV === "production" ? (0, _tsInvariant.invariant)(fragmentDef.kind === 'FragmentDefinition', 9) : (0, _tsInvariant.invariant)(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.');
		  return fragmentDef;
		}

		function getMainDefinition(queryDoc) {
		  checkDocument(queryDoc);
		  var fragmentDefinition;

		  for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
		    var definition = _a[_i];

		    if (definition.kind === 'OperationDefinition') {
		      var operation = definition.operation;

		      if (operation === 'query' || operation === 'mutation' || operation === 'subscription') {
		        return definition;
		      }
		    }

		    if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
		      fragmentDefinition = definition;
		    }
		  }

		  if (fragmentDefinition) {
		    return fragmentDefinition;
		  }

		  throw process.env.NODE_ENV === "production" ? new _tsInvariant.InvariantError(10) : new _tsInvariant.InvariantError('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
		}

		function createFragmentMap(fragments) {
		  if (fragments === void 0) {
		    fragments = [];
		  }

		  var symTable = {};
		  fragments.forEach(function (fragment) {
		    symTable[fragment.name.value] = fragment;
		  });
		  return symTable;
		}

		function getDefaultValues(definition) {
		  if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
		    var defaultValues = definition.variableDefinitions.filter(function (_a) {
		      var defaultValue = _a.defaultValue;
		      return defaultValue;
		    }).map(function (_a) {
		      var variable = _a.variable,
		          defaultValue = _a.defaultValue;
		      var defaultValueObj = {};
		      valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
		      return defaultValueObj;
		    });
		    return assign.apply(void 0, (0, _tslib.__spreadArrays)([{}], defaultValues));
		  }

		  return {};
		}

		function variablesInOperation(operation) {
		  var names = new Set();

		  if (operation.variableDefinitions) {
		    for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
		      var definition = _a[_i];
		      names.add(definition.variable.name.value);
		    }
		  }

		  return names;
		}

		function filterInPlace(array, test, context) {
		  var target = 0;
		  array.forEach(function (elem, i) {
		    if (test.call(this, elem, i, array)) {
		      array[target++] = elem;
		    }
		  }, context);
		  array.length = target;
		  return array;
		}

		var TYPENAME_FIELD = {
		  kind: 'Field',
		  name: {
		    kind: 'Name',
		    value: '__typename'
		  }
		};

		function isEmpty(op, fragments) {
		  return op.selectionSet.selections.every(function (selection) {
		    return selection.kind === 'FragmentSpread' && isEmpty(fragments[selection.name.value], fragments);
		  });
		}

		function nullIfDocIsEmpty(doc) {
		  return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc))) ? null : doc;
		}

		function getDirectiveMatcher(directives) {
		  return function directiveMatcher(directive) {
		    return directives.some(function (dir) {
		      return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
		    });
		  };
		}

		function removeDirectivesFromDocument(directives, doc) {
		  var variablesInUse = Object.create(null);
		  var variablesToRemove = [];
		  var fragmentSpreadsInUse = Object.create(null);
		  var fragmentSpreadsToRemove = [];
		  var modifiedDoc = nullIfDocIsEmpty((0, _visitor.visit)(doc, {
		    Variable: {
		      enter: function (node, _key, parent) {
		        if (parent.kind !== 'VariableDefinition') {
		          variablesInUse[node.name.value] = true;
		        }
		      }
		    },
		    Field: {
		      enter: function (node) {
		        if (directives && node.directives) {
		          var shouldRemoveField = directives.some(function (directive) {
		            return directive.remove;
		          });

		          if (shouldRemoveField && node.directives && node.directives.some(getDirectiveMatcher(directives))) {
		            if (node.arguments) {
		              node.arguments.forEach(function (arg) {
		                if (arg.value.kind === 'Variable') {
		                  variablesToRemove.push({
		                    name: arg.value.name.value
		                  });
		                }
		              });
		            }

		            if (node.selectionSet) {
		              getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
		                fragmentSpreadsToRemove.push({
		                  name: frag.name.value
		                });
		              });
		            }

		            return null;
		          }
		        }
		      }
		    },
		    FragmentSpread: {
		      enter: function (node) {
		        fragmentSpreadsInUse[node.name.value] = true;
		      }
		    },
		    Directive: {
		      enter: function (node) {
		        if (getDirectiveMatcher(directives)(node)) {
		          return null;
		        }
		      }
		    }
		  }));

		  if (modifiedDoc && filterInPlace(variablesToRemove, function (v) {
		    return !variablesInUse[v.name];
		  }).length) {
		    modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
		  }

		  if (modifiedDoc && filterInPlace(fragmentSpreadsToRemove, function (fs) {
		    return !fragmentSpreadsInUse[fs.name];
		  }).length) {
		    modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
		  }

		  return modifiedDoc;
		}

		function addTypenameToDocument(doc) {
		  return (0, _visitor.visit)(checkDocument(doc), {
		    SelectionSet: {
		      enter: function (node, _key, parent) {
		        if (parent && parent.kind === 'OperationDefinition') {
		          return;
		        }

		        var selections = node.selections;

		        if (!selections) {
		          return;
		        }

		        var skip = selections.some(function (selection) {
		          return isField(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
		        });

		        if (skip) {
		          return;
		        }

		        var field = parent;

		        if (isField(field) && field.directives && field.directives.some(function (d) {
		          return d.name.value === 'export';
		        })) {
		          return;
		        }

		        return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
		          selections: (0, _tslib.__spreadArrays)(selections, [TYPENAME_FIELD])
		        });
		      }
		    }
		  });
		}

		var connectionRemoveConfig = {
		  test: function (directive) {
		    var willRemove = directive.name.value === 'connection';

		    if (willRemove) {
		      if (!directive.arguments || !directive.arguments.some(function (arg) {
		        return arg.name.value === 'key';
		      })) {
		        process.env.NODE_ENV === "production" || _tsInvariant.invariant.warn('Removing an @connection directive even though it does not have a key. ' + 'You may want to use the key parameter to specify a store key.');
		      }
		    }

		    return willRemove;
		  }
		};

		function removeConnectionDirectiveFromDocument(doc) {
		  return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
		}

		function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
		  if (nestedCheck === void 0) {
		    nestedCheck = true;
		  }

		  return selectionSet && selectionSet.selections && selectionSet.selections.some(function (selection) {
		    return hasDirectivesInSelection(directives, selection, nestedCheck);
		  });
		}

		function hasDirectivesInSelection(directives, selection, nestedCheck) {
		  if (nestedCheck === void 0) {
		    nestedCheck = true;
		  }

		  if (!isField(selection)) {
		    return true;
		  }

		  if (!selection.directives) {
		    return false;
		  }

		  return selection.directives.some(getDirectiveMatcher(directives)) || nestedCheck && hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
		}

		function getDirectivesFromDocument(directives, doc) {
		  checkDocument(doc);
		  var parentPath;
		  return nullIfDocIsEmpty((0, _visitor.visit)(doc, {
		    SelectionSet: {
		      enter: function (node, _key, _parent, path) {
		        var currentPath = path.join('-');

		        if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
		          if (node.selections) {
		            var selectionsWithDirectives = node.selections.filter(function (selection) {
		              return hasDirectivesInSelection(directives, selection);
		            });

		            if (hasDirectivesInSelectionSet(directives, node, false)) {
		              parentPath = currentPath;
		            }

		            return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
		              selections: selectionsWithDirectives
		            });
		          } else {
		            return null;
		          }
		        }
		      }
		    }
		  }));
		}

		function getArgumentMatcher(config) {
		  return function argumentMatcher(argument) {
		    return config.some(function (aConfig) {
		      return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
		    });
		  };
		}

		function removeArgumentsFromDocument(config, doc) {
		  var argMatcher = getArgumentMatcher(config);
		  return nullIfDocIsEmpty((0, _visitor.visit)(doc, {
		    OperationDefinition: {
		      enter: function (node) {
		        return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
		          variableDefinitions: node.variableDefinitions.filter(function (varDef) {
		            return !config.some(function (arg) {
		              return arg.name === varDef.variable.name.value;
		            });
		          })
		        });
		      }
		    },
		    Field: {
		      enter: function (node) {
		        var shouldRemoveField = config.some(function (argConfig) {
		          return argConfig.remove;
		        });

		        if (shouldRemoveField) {
		          var argMatchCount_1 = 0;
		          node.arguments.forEach(function (arg) {
		            if (argMatcher(arg)) {
		              argMatchCount_1 += 1;
		            }
		          });

		          if (argMatchCount_1 === 1) {
		            return null;
		          }
		        }
		      }
		    },
		    Argument: {
		      enter: function (node) {
		        if (argMatcher(node)) {
		          return null;
		        }
		      }
		    }
		  }));
		}

		function removeFragmentSpreadFromDocument(config, doc) {
		  function enter(node) {
		    if (config.some(function (def) {
		      return def.name === node.name.value;
		    })) {
		      return null;
		    }
		  }

		  return nullIfDocIsEmpty((0, _visitor.visit)(doc, {
		    FragmentSpread: {
		      enter: enter
		    },
		    FragmentDefinition: {
		      enter: enter
		    }
		  }));
		}

		function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
		  var allFragments = [];
		  selectionSet.selections.forEach(function (selection) {
		    if ((isField(selection) || isInlineFragment(selection)) && selection.selectionSet) {
		      getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) {
		        return allFragments.push(frag);
		      });
		    } else if (selection.kind === 'FragmentSpread') {
		      allFragments.push(selection);
		    }
		  });
		  return allFragments;
		}

		function buildQueryFromSelectionSet(document) {
		  var definition = getMainDefinition(document);
		  var definitionOperation = definition.operation;

		  if (definitionOperation === 'query') {
		    return document;
		  }

		  var modifiedDoc = (0, _visitor.visit)(document, {
		    OperationDefinition: {
		      enter: function (node) {
		        return (0, _tslib.__assign)((0, _tslib.__assign)({}, node), {
		          operation: 'query'
		        });
		      }
		    }
		  });
		  return modifiedDoc;
		}

		function removeClientSetsFromDocument(document) {
		  checkDocument(document);
		  var modifiedDoc = removeDirectivesFromDocument([{
		    test: function (directive) {
		      return directive.name.value === 'client';
		    },
		    remove: true
		  }], document);

		  if (modifiedDoc) {
		    modifiedDoc = (0, _visitor.visit)(modifiedDoc, {
		      FragmentDefinition: {
		        enter: function (node) {
		          if (node.selectionSet) {
		            var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
		              return isField(selection) && selection.name.value === '__typename';
		            });

		            if (isTypenameOnly) {
		              return null;
		            }
		          }
		        }
		      }
		    });
		  }

		  return modifiedDoc;
		}

		var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
		bundle_cjs.canUseWeakMap = canUseWeakMap;
		var toString = Object.prototype.toString;

		function cloneDeep(value) {
		  return cloneDeepHelper(value, new Map());
		}

		function cloneDeepHelper(val, seen) {
		  switch (toString.call(val)) {
		    case "[object Array]":
		      {
		        if (seen.has(val)) return seen.get(val);
		        var copy_1 = val.slice(0);
		        seen.set(val, copy_1);
		        copy_1.forEach(function (child, i) {
		          copy_1[i] = cloneDeepHelper(child, seen);
		        });
		        return copy_1;
		      }

		    case "[object Object]":
		      {
		        if (seen.has(val)) return seen.get(val);
		        var copy_2 = Object.create(Object.getPrototypeOf(val));
		        seen.set(val, copy_2);
		        Object.keys(val).forEach(function (key) {
		          copy_2[key] = cloneDeepHelper(val[key], seen);
		        });
		        return copy_2;
		      }

		    default:
		      return val;
		  }
		}

		function getEnv() {
		  if (typeof process !== 'undefined' && process.env.NODE_ENV) {
		    return process.env.NODE_ENV;
		  }

		  return 'development';
		}

		function isEnv(env) {
		  return getEnv() === env;
		}

		function isProduction() {
		  return isEnv('production') === true;
		}

		function isDevelopment() {
		  return isEnv('development') === true;
		}

		function isTest() {
		  return isEnv('test') === true;
		}

		function tryFunctionOrLogError(f) {
		  try {
		    return f();
		  } catch (e) {
		    if (console.error) {
		      console.error(e);
		    }
		  }
		}

		function graphQLResultHasError(result) {
		  return result.errors && result.errors.length;
		}

		function deepFreeze(o) {
		  Object.freeze(o);
		  Object.getOwnPropertyNames(o).forEach(function (prop) {
		    if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) {
		      deepFreeze(o[prop]);
		    }
		  });
		  return o;
		}

		function maybeDeepFreeze(obj) {
		  if (isDevelopment() || isTest()) {
		    var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';

		    if (!symbolIsPolyfilled) {
		      return deepFreeze(obj);
		    }
		  }

		  return obj;
		}

		var hasOwnProperty = Object.prototype.hasOwnProperty;

		function mergeDeep() {
		  var sources = [];

		  for (var _i = 0; _i < arguments.length; _i++) {
		    sources[_i] = arguments[_i];
		  }

		  return mergeDeepArray(sources);
		}

		function mergeDeepArray(sources) {
		  var target = sources[0] || {};
		  var count = sources.length;

		  if (count > 1) {
		    var pastCopies = [];
		    target = shallowCopyForMerge(target, pastCopies);

		    for (var i = 1; i < count; ++i) {
		      target = mergeHelper(target, sources[i], pastCopies);
		    }
		  }

		  return target;
		}

		function isObject(obj) {
		  return obj !== null && typeof obj === 'object';
		}

		function mergeHelper(target, source, pastCopies) {
		  if (isObject(source) && isObject(target)) {
		    if (Object.isExtensible && !Object.isExtensible(target)) {
		      target = shallowCopyForMerge(target, pastCopies);
		    }

		    Object.keys(source).forEach(function (sourceKey) {
		      var sourceValue = source[sourceKey];

		      if (hasOwnProperty.call(target, sourceKey)) {
		        var targetValue = target[sourceKey];

		        if (sourceValue !== targetValue) {
		          target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
		        }
		      } else {
		        target[sourceKey] = sourceValue;
		      }
		    });
		    return target;
		  }

		  return source;
		}

		function shallowCopyForMerge(value, pastCopies) {
		  if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
		    if (Array.isArray(value)) {
		      value = value.slice(0);
		    } else {
		      value = (0, _tslib.__assign)({
		        __proto__: Object.getPrototypeOf(value)
		      }, value);
		    }

		    pastCopies.push(value);
		  }

		  return value;
		}

		var haveWarned = Object.create({});

		function warnOnceInDevelopment(msg, type) {
		  if (type === void 0) {
		    type = 'warn';
		  }

		  if (!isProduction() && !haveWarned[msg]) {
		    if (!isTest()) {
		      haveWarned[msg] = true;
		    }

		    if (type === 'error') {
		      console.error(msg);
		    } else {
		      console.warn(msg);
		    }
		  }
		}

		function stripSymbols(data) {
		  return JSON.parse(JSON.stringify(data));
		}
		return bundle_cjs;
	}

	var hasRequiredLinkUtils;

	function requireLinkUtils () {
		if (hasRequiredLinkUtils) return linkUtils;
		hasRequiredLinkUtils = 1;
		Object.defineProperty(linkUtils, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var zen_observable_ts_1 = tslib_1.__importDefault(requireLib());
		var apollo_utilities_1 = requireBundle_cjs();
		linkUtils.getOperationName = apollo_utilities_1.getOperationName;
		var ts_invariant_1 = requireInvariant();
		function validateOperation(operation) {
		    var OPERATION_FIELDS = [
		        'query',
		        'operationName',
		        'variables',
		        'extensions',
		        'context',
		    ];
		    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
		        var key = _a[_i];
		        if (OPERATION_FIELDS.indexOf(key) < 0) {
		            throw new ts_invariant_1.InvariantError("illegal argument: " + key);
		        }
		    }
		    return operation;
		}
		linkUtils.validateOperation = validateOperation;
		var LinkError = (function (_super) {
		    tslib_1.__extends(LinkError, _super);
		    function LinkError(message, link) {
		        var _this = _super.call(this, message) || this;
		        _this.link = link;
		        return _this;
		    }
		    return LinkError;
		}(Error));
		linkUtils.LinkError = LinkError;
		function isTerminating(link) {
		    return link.request.length <= 1;
		}
		linkUtils.isTerminating = isTerminating;
		function toPromise(observable) {
		    var completed = false;
		    return new Promise(function (resolve, reject) {
		        observable.subscribe({
		            next: function (data) {
		                if (completed) {
		                    ts_invariant_1.invariant.warn("Promise Wrapper does not support multiple results from Observable");
		                }
		                else {
		                    completed = true;
		                    resolve(data);
		                }
		            },
		            error: reject,
		        });
		    });
		}
		linkUtils.toPromise = toPromise;
		linkUtils.makePromise = toPromise;
		function fromPromise(promise) {
		    return new zen_observable_ts_1.default(function (observer) {
		        promise
		            .then(function (value) {
		            observer.next(value);
		            observer.complete();
		        })
		            .catch(observer.error.bind(observer));
		    });
		}
		linkUtils.fromPromise = fromPromise;
		function fromError(errorValue) {
		    return new zen_observable_ts_1.default(function (observer) {
		        observer.error(errorValue);
		    });
		}
		linkUtils.fromError = fromError;
		function transformOperation(operation) {
		    var transformedOperation = {
		        variables: operation.variables || {},
		        extensions: operation.extensions || {},
		        operationName: operation.operationName,
		        query: operation.query,
		    };
		    if (!transformedOperation.operationName) {
		        transformedOperation.operationName =
		            typeof transformedOperation.query !== 'string'
		                ? apollo_utilities_1.getOperationName(transformedOperation.query)
		                : '';
		    }
		    return transformedOperation;
		}
		linkUtils.transformOperation = transformOperation;
		function createOperation(starting, operation) {
		    var context = tslib_1.__assign({}, starting);
		    var setContext = function (next) {
		        if (typeof next === 'function') {
		            context = tslib_1.__assign({}, context, next(context));
		        }
		        else {
		            context = tslib_1.__assign({}, context, next);
		        }
		    };
		    var getContext = function () { return (tslib_1.__assign({}, context)); };
		    Object.defineProperty(operation, 'setContext', {
		        enumerable: false,
		        value: setContext,
		    });
		    Object.defineProperty(operation, 'getContext', {
		        enumerable: false,
		        value: getContext,
		    });
		    Object.defineProperty(operation, 'toKey', {
		        enumerable: false,
		        value: function () { return getKey(operation); },
		    });
		    return operation;
		}
		linkUtils.createOperation = createOperation;
		function getKey(operation) {
		    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
		    return JSON.stringify([operationName, query, variables]);
		}
		linkUtils.getKey = getKey;
		
		return linkUtils;
	}

	var hasRequiredLink;

	function requireLink () {
		if (hasRequiredLink) return link;
		hasRequiredLink = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			var tslib_1 = require$$0$1;
			var zen_observable_ts_1 = tslib_1.__importDefault(requireLib());
			var ts_invariant_1 = requireInvariant();
			var linkUtils_1 = requireLinkUtils();
			function passthrough(op, forward) {
			    return forward ? forward(op) : zen_observable_ts_1.default.of();
			}
			function toLink(handler) {
			    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
			}
			function empty() {
			    return new ApolloLink(function () { return zen_observable_ts_1.default.of(); });
			}
			exports.empty = empty;
			function from(links) {
			    if (links.length === 0)
			        return empty();
			    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
			}
			exports.from = from;
			function split(test, left, right) {
			    var leftLink = toLink(left);
			    var rightLink = toLink(right || new ApolloLink(passthrough));
			    if (linkUtils_1.isTerminating(leftLink) && linkUtils_1.isTerminating(rightLink)) {
			        return new ApolloLink(function (operation) {
			            return test(operation)
			                ? leftLink.request(operation) || zen_observable_ts_1.default.of()
			                : rightLink.request(operation) || zen_observable_ts_1.default.of();
			        });
			    }
			    else {
			        return new ApolloLink(function (operation, forward) {
			            return test(operation)
			                ? leftLink.request(operation, forward) || zen_observable_ts_1.default.of()
			                : rightLink.request(operation, forward) || zen_observable_ts_1.default.of();
			        });
			    }
			}
			exports.split = split;
			exports.concat = function (first, second) {
			    var firstLink = toLink(first);
			    if (linkUtils_1.isTerminating(firstLink)) {
			        ts_invariant_1.invariant.warn(new linkUtils_1.LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
			        return firstLink;
			    }
			    var nextLink = toLink(second);
			    if (linkUtils_1.isTerminating(nextLink)) {
			        return new ApolloLink(function (operation) {
			            return firstLink.request(operation, function (op) { return nextLink.request(op) || zen_observable_ts_1.default.of(); }) || zen_observable_ts_1.default.of();
			        });
			    }
			    else {
			        return new ApolloLink(function (operation, forward) {
			            return (firstLink.request(operation, function (op) {
			                return nextLink.request(op, forward) || zen_observable_ts_1.default.of();
			            }) || zen_observable_ts_1.default.of());
			        });
			    }
			};
			var ApolloLink = (function () {
			    function ApolloLink(request) {
			        if (request)
			            this.request = request;
			    }
			    ApolloLink.prototype.split = function (test, left, right) {
			        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
			    };
			    ApolloLink.prototype.concat = function (next) {
			        return exports.concat(this, next);
			    };
			    ApolloLink.prototype.request = function (operation, forward) {
			        throw new ts_invariant_1.InvariantError('request is not implemented');
			    };
			    ApolloLink.empty = empty;
			    ApolloLink.from = from;
			    ApolloLink.split = split;
			    ApolloLink.execute = execute;
			    return ApolloLink;
			}());
			exports.ApolloLink = ApolloLink;
			function execute(link, operation) {
			    return (link.request(linkUtils_1.createOperation(operation.context, linkUtils_1.transformOperation(linkUtils_1.validateOperation(operation)))) || zen_observable_ts_1.default.of());
			}
			exports.execute = execute;
			
	} (link));
		return link;
	}

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		tslib_1.__exportStar(requireLink(), exports);
		var linkUtils_1 = requireLinkUtils();
		exports.createOperation = linkUtils_1.createOperation;
		exports.makePromise = linkUtils_1.makePromise;
		exports.toPromise = linkUtils_1.toPromise;
		exports.fromPromise = linkUtils_1.fromPromise;
		exports.fromError = linkUtils_1.fromError;
		exports.getOperationName = linkUtils_1.getOperationName;
		var zen_observable_ts_1 = tslib_1.__importDefault(requireLib());
		exports.Observable = zen_observable_ts_1.default;
		
	} (lib$1));

	var dist$5 = {};

	var exports$1 = {};

	var dist$4 = {};

	var loglevel = {};

	var hasRequiredLoglevel;

	function requireLoglevel () {
		if (hasRequiredLoglevel) return loglevel;
		hasRequiredLoglevel = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			(function (LogLevel) {
			    /** No logs will be generated. */
			    LogLevel[LogLevel["None"] = 0] = "None";
			    /** Only SDK internal errors will be logged. */
			    LogLevel[LogLevel["Error"] = 1] = "Error";
			    /** Information useful for debugging the SDK will be logged. */
			    LogLevel[LogLevel["Debug"] = 2] = "Debug";
			    /** All SDK actions will be logged. */
			    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
			})(exports.LogLevel || (exports.LogLevel = {}));
			
	} (loglevel));
		return loglevel;
	}

	var session$1 = {};

	var hasRequiredSession$1;

	function requireSession$1 () {
		if (hasRequiredSession$1) return session$1;
		hasRequiredSession$1 = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			(function (SessionStatus) {
			    /** JSDoc */
			    SessionStatus["Ok"] = "ok";
			    /** JSDoc */
			    SessionStatus["Exited"] = "exited";
			    /** JSDoc */
			    SessionStatus["Crashed"] = "crashed";
			    /** JSDoc */
			    SessionStatus["Abnormal"] = "abnormal";
			})(exports.SessionStatus || (exports.SessionStatus = {}));
			
	} (session$1));
		return session$1;
	}

	var severity = {};

	var hasRequiredSeverity;

	function requireSeverity () {
		if (hasRequiredSeverity) return severity;
		hasRequiredSeverity = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			(function (Severity) {
			    /** JSDoc */
			    Severity["Fatal"] = "fatal";
			    /** JSDoc */
			    Severity["Error"] = "error";
			    /** JSDoc */
			    Severity["Warning"] = "warning";
			    /** JSDoc */
			    Severity["Log"] = "log";
			    /** JSDoc */
			    Severity["Info"] = "info";
			    /** JSDoc */
			    Severity["Debug"] = "debug";
			    /** JSDoc */
			    Severity["Critical"] = "critical";
			})(exports.Severity || (exports.Severity = {}));
			// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
			(function (Severity) {
			    /**
			     * Converts a string-based level into a {@link Severity}.
			     *
			     * @param level string representation of Severity
			     * @returns Severity
			     */
			    function fromString(level) {
			        switch (level) {
			            case 'debug':
			                return Severity.Debug;
			            case 'info':
			                return Severity.Info;
			            case 'warn':
			            case 'warning':
			                return Severity.Warning;
			            case 'error':
			                return Severity.Error;
			            case 'fatal':
			                return Severity.Fatal;
			            case 'critical':
			                return Severity.Critical;
			            case 'log':
			            default:
			                return Severity.Log;
			        }
			    }
			    Severity.fromString = fromString;
			})(exports.Severity || (exports.Severity = {}));
			
	} (severity));
		return severity;
	}

	var status = {};

	var hasRequiredStatus;

	function requireStatus () {
		if (hasRequiredStatus) return status;
		hasRequiredStatus = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			(function (Status) {
			    /** The status could not be determined. */
			    Status["Unknown"] = "unknown";
			    /** The event was skipped due to configuration or callbacks. */
			    Status["Skipped"] = "skipped";
			    /** The event was sent to Sentry successfully. */
			    Status["Success"] = "success";
			    /** The client is currently rate limited and will try again later. */
			    Status["RateLimit"] = "rate_limit";
			    /** The event could not be processed. */
			    Status["Invalid"] = "invalid";
			    /** A server-side error ocurred during submission. */
			    Status["Failed"] = "failed";
			})(exports.Status || (exports.Status = {}));
			// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
			(function (Status) {
			    /**
			     * Converts a HTTP status code into a {@link Status}.
			     *
			     * @param code The HTTP response status code.
			     * @returns The send status or {@link Status.Unknown}.
			     */
			    function fromHttpCode(code) {
			        if (code >= 200 && code < 300) {
			            return Status.Success;
			        }
			        if (code === 429) {
			            return Status.RateLimit;
			        }
			        if (code >= 400 && code < 500) {
			            return Status.Invalid;
			        }
			        if (code >= 500) {
			            return Status.Failed;
			        }
			        return Status.Unknown;
			    }
			    Status.fromHttpCode = fromHttpCode;
			})(exports.Status || (exports.Status = {}));
			
	} (status));
		return status;
	}

	var transaction = {};

	var hasRequiredTransaction;

	function requireTransaction () {
		if (hasRequiredTransaction) return transaction;
		hasRequiredTransaction = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			(function (TransactionSamplingMethod) {
			    TransactionSamplingMethod["Explicit"] = "explicitly_set";
			    TransactionSamplingMethod["Sampler"] = "client_sampler";
			    TransactionSamplingMethod["Rate"] = "client_rate";
			    TransactionSamplingMethod["Inheritance"] = "inheritance";
			})(exports.TransactionSamplingMethod || (exports.TransactionSamplingMethod = {}));
			
	} (transaction));
		return transaction;
	}

	var hasRequiredDist$4;

	function requireDist$4 () {
		if (hasRequiredDist$4) return dist$4;
		hasRequiredDist$4 = 1;
		Object.defineProperty(dist$4, "__esModule", { value: true });
		var loglevel_1 = requireLoglevel();
		dist$4.LogLevel = loglevel_1.LogLevel;
		var session_1 = requireSession$1();
		dist$4.SessionStatus = session_1.SessionStatus;
		var severity_1 = requireSeverity();
		dist$4.Severity = severity_1.Severity;
		var status_1 = requireStatus();
		dist$4.Status = status_1.Status;
		var transaction_1 = requireTransaction();
		dist$4.TransactionSamplingMethod = transaction_1.TransactionSamplingMethod;
		
		return dist$4;
	}

	var dist$3 = {};

	var dist$2 = {};

	var dist$1 = {};

	var scope = {};

	var dist = {};

	var async = {};

	var hasRequiredAsync;

	function requireAsync () {
		if (hasRequiredAsync) return async;
		hasRequiredAsync = 1;
		Object.defineProperty(async, "__esModule", { value: true });
		/**
		 * Consumes the promise and logs the error when it rejects.
		 * @param promise A promise to forget.
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		function forget(promise) {
		    promise.then(null, function (e) {
		        // TODO: Use a better logging mechanism
		        // eslint-disable-next-line no-console
		        console.error(e);
		    });
		}
		async.forget = forget;
		
		return async;
	}

	var browser = {};

	var is = {};

	/* eslint-disable @typescript-eslint/no-explicit-any */

	var hasRequiredIs;

	function requireIs () {
		if (hasRequiredIs) return is;
		hasRequiredIs = 1;
		/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
		Object.defineProperty(is, "__esModule", { value: true });
		/**
		 * Checks whether given value's type is one of a few Error or Error-like
		 * {@link isError}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isError(wat) {
		    switch (Object.prototype.toString.call(wat)) {
		        case '[object Error]':
		            return true;
		        case '[object Exception]':
		            return true;
		        case '[object DOMException]':
		            return true;
		        default:
		            return isInstanceOf(wat, Error);
		    }
		}
		is.isError = isError;
		/**
		 * Checks whether given value's type is ErrorEvent
		 * {@link isErrorEvent}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isErrorEvent(wat) {
		    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
		}
		is.isErrorEvent = isErrorEvent;
		/**
		 * Checks whether given value's type is DOMError
		 * {@link isDOMError}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isDOMError(wat) {
		    return Object.prototype.toString.call(wat) === '[object DOMError]';
		}
		is.isDOMError = isDOMError;
		/**
		 * Checks whether given value's type is DOMException
		 * {@link isDOMException}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isDOMException(wat) {
		    return Object.prototype.toString.call(wat) === '[object DOMException]';
		}
		is.isDOMException = isDOMException;
		/**
		 * Checks whether given value's type is a string
		 * {@link isString}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isString(wat) {
		    return Object.prototype.toString.call(wat) === '[object String]';
		}
		is.isString = isString;
		/**
		 * Checks whether given value's is a primitive (undefined, null, number, boolean, string, bigint, symbol)
		 * {@link isPrimitive}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isPrimitive(wat) {
		    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
		}
		is.isPrimitive = isPrimitive;
		/**
		 * Checks whether given value's type is an object literal
		 * {@link isPlainObject}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isPlainObject(wat) {
		    return Object.prototype.toString.call(wat) === '[object Object]';
		}
		is.isPlainObject = isPlainObject;
		/**
		 * Checks whether given value's type is an Event instance
		 * {@link isEvent}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isEvent(wat) {
		    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
		}
		is.isEvent = isEvent;
		/**
		 * Checks whether given value's type is an Element instance
		 * {@link isElement}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isElement(wat) {
		    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
		}
		is.isElement = isElement;
		/**
		 * Checks whether given value's type is an regexp
		 * {@link isRegExp}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isRegExp(wat) {
		    return Object.prototype.toString.call(wat) === '[object RegExp]';
		}
		is.isRegExp = isRegExp;
		/**
		 * Checks whether given value has a then function.
		 * @param wat A value to be checked.
		 */
		function isThenable(wat) {
		    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		    return Boolean(wat && wat.then && typeof wat.then === 'function');
		}
		is.isThenable = isThenable;
		/**
		 * Checks whether given value's type is a SyntheticEvent
		 * {@link isSyntheticEvent}.
		 *
		 * @param wat A value to be checked.
		 * @returns A boolean representing the result.
		 */
		function isSyntheticEvent(wat) {
		    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
		}
		is.isSyntheticEvent = isSyntheticEvent;
		/**
		 * Checks whether given value's type is an instance of provided constructor.
		 * {@link isInstanceOf}.
		 *
		 * @param wat A value to be checked.
		 * @param base A constructor to be used in a check.
		 * @returns A boolean representing the result.
		 */
		function isInstanceOf(wat, base) {
		    try {
		        return wat instanceof base;
		    }
		    catch (_e) {
		        return false;
		    }
		}
		is.isInstanceOf = isInstanceOf;
		
		return is;
	}

	var hasRequiredBrowser;

	function requireBrowser () {
		if (hasRequiredBrowser) return browser;
		hasRequiredBrowser = 1;
		Object.defineProperty(browser, "__esModule", { value: true });
		var is_1 = requireIs();
		/**
		 * Given a child DOM element, returns a query-selector statement describing that
		 * and its ancestors
		 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
		 * @returns generated DOM path
		 */
		function htmlTreeAsString(elem) {
		    // try/catch both:
		    // - accessing event.target (see getsentry/raven-js#838, #768)
		    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
		    // - can throw an exception in some circumstances.
		    try {
		        var currentElem = elem;
		        var MAX_TRAVERSE_HEIGHT = 5;
		        var MAX_OUTPUT_LEN = 80;
		        var out = [];
		        var height = 0;
		        var len = 0;
		        var separator = ' > ';
		        var sepLength = separator.length;
		        var nextStr = void 0;
		        // eslint-disable-next-line no-plusplus
		        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
		            nextStr = _htmlElementAsString(currentElem);
		            // bail out if
		            // - nextStr is the 'html' element
		            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
		            //   (ignore this limit if we are on the first iteration)
		            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
		                break;
		            }
		            out.push(nextStr);
		            len += nextStr.length;
		            currentElem = currentElem.parentNode;
		        }
		        return out.reverse().join(separator);
		    }
		    catch (_oO) {
		        return '<unknown>';
		    }
		}
		browser.htmlTreeAsString = htmlTreeAsString;
		/**
		 * Returns a simple, query-selector representation of a DOM element
		 * e.g. [HTMLElement] => input#foo.btn[name=baz]
		 * @returns generated DOM path
		 */
		function _htmlElementAsString(el) {
		    var elem = el;
		    var out = [];
		    var className;
		    var classes;
		    var key;
		    var attr;
		    var i;
		    if (!elem || !elem.tagName) {
		        return '';
		    }
		    out.push(elem.tagName.toLowerCase());
		    if (elem.id) {
		        out.push("#" + elem.id);
		    }
		    // eslint-disable-next-line prefer-const
		    className = elem.className;
		    if (className && is_1.isString(className)) {
		        classes = className.split(/\s+/);
		        for (i = 0; i < classes.length; i++) {
		            out.push("." + classes[i]);
		        }
		    }
		    var allowedAttrs = ['type', 'name', 'title', 'alt'];
		    for (i = 0; i < allowedAttrs.length; i++) {
		        key = allowedAttrs[i];
		        attr = elem.getAttribute(key);
		        if (attr) {
		            out.push("[" + key + "=\"" + attr + "\"]");
		        }
		    }
		    return out.join('');
		}
		
		return browser;
	}

	var dsn = {};

	var error = {};

	var polyfill = {};

	var hasRequiredPolyfill;

	function requirePolyfill () {
		if (hasRequiredPolyfill) return polyfill;
		hasRequiredPolyfill = 1;
		Object.defineProperty(polyfill, "__esModule", { value: true });
		polyfill.setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
		/**
		 * setPrototypeOf polyfill using __proto__
		 */
		// eslint-disable-next-line @typescript-eslint/ban-types
		function setProtoOf(obj, proto) {
		    // @ts-ignore __proto__ does not exist on obj
		    obj.__proto__ = proto;
		    return obj;
		}
		/**
		 * setPrototypeOf polyfill using mixin
		 */
		// eslint-disable-next-line @typescript-eslint/ban-types
		function mixinProperties(obj, proto) {
		    for (var prop in proto) {
		        // eslint-disable-next-line no-prototype-builtins
		        if (!obj.hasOwnProperty(prop)) {
		            // @ts-ignore typescript complains about indexing so we remove
		            obj[prop] = proto[prop];
		        }
		    }
		    return obj;
		}
		
		return polyfill;
	}

	var hasRequiredError;

	function requireError () {
		if (hasRequiredError) return error;
		hasRequiredError = 1;
		Object.defineProperty(error, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var polyfill_1 = requirePolyfill();
		/** An error emitted by Sentry SDKs and related utilities. */
		var SentryError = /** @class */ (function (_super) {
		    tslib_1.__extends(SentryError, _super);
		    function SentryError(message) {
		        var _newTarget = this.constructor;
		        var _this = _super.call(this, message) || this;
		        _this.message = message;
		        _this.name = _newTarget.prototype.constructor.name;
		        polyfill_1.setPrototypeOf(_this, _newTarget.prototype);
		        return _this;
		    }
		    return SentryError;
		}(Error));
		error.SentryError = SentryError;
		
		return error;
	}

	var hasRequiredDsn;

	function requireDsn () {
		if (hasRequiredDsn) return dsn;
		hasRequiredDsn = 1;
		Object.defineProperty(dsn, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var error_1 = requireError();
		/** Regular expression used to parse a Dsn. */
		var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
		/** Error message */
		var ERROR_MESSAGE = 'Invalid Dsn';
		/** The Sentry Dsn, identifying a Sentry instance and project. */
		var Dsn = /** @class */ (function () {
		    /** Creates a new Dsn component */
		    function Dsn(from) {
		        if (typeof from === 'string') {
		            this._fromString(from);
		        }
		        else {
		            this._fromComponents(from);
		        }
		        this._validate();
		    }
		    /**
		     * Renders the string representation of this Dsn.
		     *
		     * By default, this will render the public representation without the password
		     * component. To get the deprecated private representation, set `withPassword`
		     * to true.
		     *
		     * @param withPassword When set to true, the password will be included.
		     */
		    Dsn.prototype.toString = function (withPassword) {
		        if (withPassword === void 0) { withPassword = false; }
		        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
		        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
		            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
		    };
		    /** Parses a string into this Dsn. */
		    Dsn.prototype._fromString = function (str) {
		        var match = DSN_REGEX.exec(str);
		        if (!match) {
		            throw new error_1.SentryError(ERROR_MESSAGE);
		        }
		        var _a = tslib_1.__read(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
		        var path = '';
		        var projectId = lastPath;
		        var split = projectId.split('/');
		        if (split.length > 1) {
		            path = split.slice(0, -1).join('/');
		            projectId = split.pop();
		        }
		        if (projectId) {
		            var projectMatch = projectId.match(/^\d+/);
		            if (projectMatch) {
		                projectId = projectMatch[0];
		            }
		        }
		        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
		    };
		    /** Maps Dsn components into this instance. */
		    Dsn.prototype._fromComponents = function (components) {
		        this.protocol = components.protocol;
		        this.user = components.user;
		        this.pass = components.pass || '';
		        this.host = components.host;
		        this.port = components.port || '';
		        this.path = components.path || '';
		        this.projectId = components.projectId;
		    };
		    /** Validates this Dsn and throws on error. */
		    Dsn.prototype._validate = function () {
		        var _this = this;
		        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
		            if (!_this[component]) {
		                throw new error_1.SentryError(ERROR_MESSAGE + ": " + component + " missing");
		            }
		        });
		        if (!this.projectId.match(/^\d+$/)) {
		            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
		        }
		        if (this.protocol !== 'http' && this.protocol !== 'https') {
		            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
		        }
		        if (this.port && isNaN(parseInt(this.port, 10))) {
		            throw new error_1.SentryError(ERROR_MESSAGE + ": Invalid port " + this.port);
		        }
		    };
		    return Dsn;
		}());
		dsn.Dsn = Dsn;
		
		return dsn;
	}

	var instrument = {};

	var logger = {};

	var misc = {};

	var node = {exports: {}};

	var object = {};

	var memo = {};

	var hasRequiredMemo;

	function requireMemo () {
		if (hasRequiredMemo) return memo;
		hasRequiredMemo = 1;
		Object.defineProperty(memo, "__esModule", { value: true });
		/* eslint-disable @typescript-eslint/no-unsafe-member-access */
		/* eslint-disable @typescript-eslint/no-explicit-any */
		/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
		/**
		 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
		 */
		var Memo = /** @class */ (function () {
		    function Memo() {
		        this._hasWeakSet = typeof WeakSet === 'function';
		        this._inner = this._hasWeakSet ? new WeakSet() : [];
		    }
		    /**
		     * Sets obj to remember.
		     * @param obj Object to remember
		     */
		    Memo.prototype.memoize = function (obj) {
		        if (this._hasWeakSet) {
		            if (this._inner.has(obj)) {
		                return true;
		            }
		            this._inner.add(obj);
		            return false;
		        }
		        // eslint-disable-next-line @typescript-eslint/prefer-for-of
		        for (var i = 0; i < this._inner.length; i++) {
		            var value = this._inner[i];
		            if (value === obj) {
		                return true;
		            }
		        }
		        this._inner.push(obj);
		        return false;
		    };
		    /**
		     * Removes object from internal storage.
		     * @param obj Object to forget
		     */
		    Memo.prototype.unmemoize = function (obj) {
		        if (this._hasWeakSet) {
		            this._inner.delete(obj);
		        }
		        else {
		            for (var i = 0; i < this._inner.length; i++) {
		                if (this._inner[i] === obj) {
		                    this._inner.splice(i, 1);
		                    break;
		                }
		            }
		        }
		    };
		    return Memo;
		}());
		memo.Memo = Memo;
		
		return memo;
	}

	var stacktrace = {};

	var hasRequiredStacktrace;

	function requireStacktrace () {
		if (hasRequiredStacktrace) return stacktrace;
		hasRequiredStacktrace = 1;
		Object.defineProperty(stacktrace, "__esModule", { value: true });
		var defaultFunctionName = '<anonymous>';
		/**
		 * Safely extract function name from itself
		 */
		function getFunctionName(fn) {
		    try {
		        if (!fn || typeof fn !== 'function') {
		            return defaultFunctionName;
		        }
		        return fn.name || defaultFunctionName;
		    }
		    catch (e) {
		        // Just accessing custom props in some Selenium environments
		        // can cause a "Permission denied" exception (see raven-js#495).
		        return defaultFunctionName;
		    }
		}
		stacktrace.getFunctionName = getFunctionName;
		
		return stacktrace;
	}

	var string = {};

	var hasRequiredString;

	function requireString () {
		if (hasRequiredString) return string;
		hasRequiredString = 1;
		Object.defineProperty(string, "__esModule", { value: true });
		var is_1 = requireIs();
		/**
		 * Truncates given string to the maximum characters count
		 *
		 * @param str An object that contains serializable values
		 * @param max Maximum number of characters in truncated string (0 = unlimited)
		 * @returns string Encoded
		 */
		function truncate(str, max) {
		    if (max === void 0) { max = 0; }
		    if (typeof str !== 'string' || max === 0) {
		        return str;
		    }
		    return str.length <= max ? str : str.substr(0, max) + "...";
		}
		string.truncate = truncate;
		/**
		 * This is basically just `trim_line` from
		 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
		 *
		 * @param str An object that contains serializable values
		 * @param max Maximum number of characters in truncated string
		 * @returns string Encoded
		 */
		function snipLine(line, colno) {
		    var newLine = line;
		    var ll = newLine.length;
		    if (ll <= 150) {
		        return newLine;
		    }
		    if (colno > ll) {
		        // eslint-disable-next-line no-param-reassign
		        colno = ll;
		    }
		    var start = Math.max(colno - 60, 0);
		    if (start < 5) {
		        start = 0;
		    }
		    var end = Math.min(start + 140, ll);
		    if (end > ll - 5) {
		        end = ll;
		    }
		    if (end === ll) {
		        start = Math.max(end - 140, 0);
		    }
		    newLine = newLine.slice(start, end);
		    if (start > 0) {
		        newLine = "'{snip} " + newLine;
		    }
		    if (end < ll) {
		        newLine += ' {snip}';
		    }
		    return newLine;
		}
		string.snipLine = snipLine;
		/**
		 * Join values in array
		 * @param input array of values to be joined together
		 * @param delimiter string to be placed in-between values
		 * @returns Joined values
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		function safeJoin(input, delimiter) {
		    if (!Array.isArray(input)) {
		        return '';
		    }
		    var output = [];
		    // eslint-disable-next-line @typescript-eslint/prefer-for-of
		    for (var i = 0; i < input.length; i++) {
		        var value = input[i];
		        try {
		            output.push(String(value));
		        }
		        catch (e) {
		            output.push('[value cannot be serialized]');
		        }
		    }
		    return output.join(delimiter);
		}
		string.safeJoin = safeJoin;
		/**
		 * Checks if the value matches a regex or includes the string
		 * @param value The string value to be checked against
		 * @param pattern Either a regex or a string that must be contained in value
		 */
		function isMatchingPattern(value, pattern) {
		    if (!is_1.isString(value)) {
		        return false;
		    }
		    if (is_1.isRegExp(pattern)) {
		        return pattern.test(value);
		    }
		    if (typeof pattern === 'string') {
		        return value.indexOf(pattern) !== -1;
		    }
		    return false;
		}
		string.isMatchingPattern = isMatchingPattern;
		
		return string;
	}

	var hasRequiredObject;

	function requireObject () {
		if (hasRequiredObject) return object;
		hasRequiredObject = 1;
		Object.defineProperty(object, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var browser_1 = requireBrowser();
		var is_1 = requireIs();
		var memo_1 = requireMemo();
		var stacktrace_1 = requireStacktrace();
		var string_1 = requireString();
		/**
		 * Wrap a given object method with a higher-order function
		 *
		 * @param source An object that contains a method to be wrapped.
		 * @param name A name of method to be wrapped.
		 * @param replacementFactory A function that should be used to wrap a given method, returning the wrapped method which
		 * will be substituted in for `source[name]`.
		 * @returns void
		 */
		function fill(source, name, replacementFactory) {
		    if (!(name in source)) {
		        return;
		    }
		    var original = source[name];
		    var wrapped = replacementFactory(original);
		    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
		    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
		    if (typeof wrapped === 'function') {
		        try {
		            wrapped.prototype = wrapped.prototype || {};
		            Object.defineProperties(wrapped, {
		                __sentry_original__: {
		                    enumerable: false,
		                    value: original,
		                },
		            });
		        }
		        catch (_Oo) {
		            // This can throw if multiple fill happens on a global object like XMLHttpRequest
		            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
		        }
		    }
		    source[name] = wrapped;
		}
		object.fill = fill;
		/**
		 * Encodes given object into url-friendly format
		 *
		 * @param object An object that contains serializable values
		 * @returns string Encoded
		 */
		function urlEncode(object) {
		    return Object.keys(object)
		        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
		        .join('&');
		}
		object.urlEncode = urlEncode;
		/**
		 * Transforms any object into an object literal with all its attributes
		 * attached to it.
		 *
		 * @param value Initial source that we have to transform in order for it to be usable by the serializer
		 */
		function getWalkSource(value) {
		    if (is_1.isError(value)) {
		        var error = value;
		        var err = {
		            message: error.message,
		            name: error.name,
		            stack: error.stack,
		        };
		        for (var i in error) {
		            if (Object.prototype.hasOwnProperty.call(error, i)) {
		                err[i] = error[i];
		            }
		        }
		        return err;
		    }
		    if (is_1.isEvent(value)) {
		        var event_1 = value;
		        var source = {};
		        source.type = event_1.type;
		        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
		        try {
		            source.target = is_1.isElement(event_1.target)
		                ? browser_1.htmlTreeAsString(event_1.target)
		                : Object.prototype.toString.call(event_1.target);
		        }
		        catch (_oO) {
		            source.target = '<unknown>';
		        }
		        try {
		            source.currentTarget = is_1.isElement(event_1.currentTarget)
		                ? browser_1.htmlTreeAsString(event_1.currentTarget)
		                : Object.prototype.toString.call(event_1.currentTarget);
		        }
		        catch (_oO) {
		            source.currentTarget = '<unknown>';
		        }
		        if (typeof CustomEvent !== 'undefined' && is_1.isInstanceOf(value, CustomEvent)) {
		            source.detail = event_1.detail;
		        }
		        for (var i in event_1) {
		            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
		                source[i] = event_1;
		            }
		        }
		        return source;
		    }
		    return value;
		}
		/** Calculates bytes size of input string */
		function utf8Length(value) {
		    // eslint-disable-next-line no-bitwise
		    return ~-encodeURI(value).split(/%..|./).length;
		}
		/** Calculates bytes size of input object */
		function jsonSize(value) {
		    return utf8Length(JSON.stringify(value));
		}
		/** JSDoc */
		function normalizeToSize(object, 
		// Default Node.js REPL depth
		depth, 
		// 100kB, as 200kB is max payload size, so half sounds reasonable
		maxSize) {
		    if (depth === void 0) { depth = 3; }
		    if (maxSize === void 0) { maxSize = 100 * 1024; }
		    var serialized = normalize(object, depth);
		    if (jsonSize(serialized) > maxSize) {
		        return normalizeToSize(object, depth - 1, maxSize);
		    }
		    return serialized;
		}
		object.normalizeToSize = normalizeToSize;
		/**
		 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
		 * booleans, null, and undefined.
		 *
		 * @param value The value to stringify
		 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
		 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
		 *  unchanged.
		 */
		function serializeValue(value) {
		    var type = Object.prototype.toString.call(value);
		    // Node.js REPL notation
		    if (typeof value === 'string') {
		        return value;
		    }
		    if (type === '[object Object]') {
		        return '[Object]';
		    }
		    if (type === '[object Array]') {
		        return '[Array]';
		    }
		    var normalized = normalizeValue(value);
		    return is_1.isPrimitive(normalized) ? normalized : type;
		}
		/**
		 * normalizeValue()
		 *
		 * Takes unserializable input and make it serializable friendly
		 *
		 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
		 * - serializes Error objects
		 * - filter global objects
		 */
		function normalizeValue(value, key) {
		    if (key === 'domain' && value && typeof value === 'object' && value._events) {
		        return '[Domain]';
		    }
		    if (key === 'domainEmitter') {
		        return '[DomainEmitter]';
		    }
		    if (typeof commonjsGlobal !== 'undefined' && value === commonjsGlobal) {
		        return '[Global]';
		    }
		    if (typeof window !== 'undefined' && value === window) {
		        return '[Window]';
		    }
		    if (typeof document !== 'undefined' && value === document) {
		        return '[Document]';
		    }
		    // React's SyntheticEvent thingy
		    if (is_1.isSyntheticEvent(value)) {
		        return '[SyntheticEvent]';
		    }
		    if (typeof value === 'number' && value !== value) {
		        return '[NaN]';
		    }
		    if (value === void 0) {
		        return '[undefined]';
		    }
		    if (typeof value === 'function') {
		        return "[Function: " + stacktrace_1.getFunctionName(value) + "]";
		    }
		    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
		    if (typeof value === 'symbol') {
		        return "[" + String(value) + "]";
		    }
		    if (typeof value === 'bigint') {
		        return "[BigInt: " + String(value) + "]";
		    }
		    return value;
		}
		/**
		 * Walks an object to perform a normalization on it
		 *
		 * @param key of object that's walked in current iteration
		 * @param value object to be walked
		 * @param depth Optional number indicating how deep should walking be performed
		 * @param memo Optional Memo class handling decycling
		 */
		// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
		function walk(key, value, depth, memo) {
		    if (depth === void 0) { depth = +Infinity; }
		    if (memo === void 0) { memo = new memo_1.Memo(); }
		    // If we reach the maximum depth, serialize whatever has left
		    if (depth === 0) {
		        return serializeValue(value);
		    }
		    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
		    // If value implements `toJSON` method, call it and return early
		    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
		        return value.toJSON();
		    }
		    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
		    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
		    var normalized = normalizeValue(value, key);
		    if (is_1.isPrimitive(normalized)) {
		        return normalized;
		    }
		    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
		    var source = getWalkSource(value);
		    // Create an accumulator that will act as a parent for all future itterations of that branch
		    var acc = Array.isArray(value) ? [] : {};
		    // If we already walked that branch, bail out, as it's circular reference
		    if (memo.memoize(value)) {
		        return '[Circular ~]';
		    }
		    // Walk all keys of the source
		    for (var innerKey in source) {
		        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
		        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
		            continue;
		        }
		        // Recursively walk through all the child nodes
		        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
		    }
		    // Once walked through all the branches, remove the parent from memo storage
		    memo.unmemoize(value);
		    // Return accumulated values
		    return acc;
		}
		object.walk = walk;
		/**
		 * normalize()
		 *
		 * - Creates a copy to prevent original input mutation
		 * - Skip non-enumerablers
		 * - Calls `toJSON` if implemented
		 * - Removes circular references
		 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
		 * - Translates known global objects/Classes to a string representations
		 * - Takes care of Error objects serialization
		 * - Optionally limit depth of final output
		 */
		// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
		function normalize(input, depth) {
		    try {
		        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
		    }
		    catch (_oO) {
		        return '**non-serializable**';
		    }
		}
		object.normalize = normalize;
		/**
		 * Given any captured exception, extract its keys and create a sorted
		 * and truncated list that will be used inside the event message.
		 * eg. `Non-error exception captured with keys: foo, bar, baz`
		 */
		// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
		function extractExceptionKeysForMessage(exception, maxLength) {
		    if (maxLength === void 0) { maxLength = 40; }
		    var keys = Object.keys(getWalkSource(exception));
		    keys.sort();
		    if (!keys.length) {
		        return '[object has no keys]';
		    }
		    if (keys[0].length >= maxLength) {
		        return string_1.truncate(keys[0], maxLength);
		    }
		    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
		        var serialized = keys.slice(0, includedKeys).join(', ');
		        if (serialized.length > maxLength) {
		            continue;
		        }
		        if (includedKeys === keys.length) {
		            return serialized;
		        }
		        return string_1.truncate(serialized, maxLength);
		    }
		    return '';
		}
		object.extractExceptionKeysForMessage = extractExceptionKeysForMessage;
		/**
		 * Given any object, return the new object with removed keys that value was `undefined`.
		 * Works recursively on objects and arrays.
		 */
		function dropUndefinedKeys(val) {
		    var e_1, _a;
		    if (is_1.isPlainObject(val)) {
		        var obj = val;
		        var rv = {};
		        try {
		            for (var _b = tslib_1.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
		                var key = _c.value;
		                if (typeof obj[key] !== 'undefined') {
		                    rv[key] = dropUndefinedKeys(obj[key]);
		                }
		            }
		        }
		        catch (e_1_1) { e_1 = { error: e_1_1 }; }
		        finally {
		            try {
		                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
		            }
		            finally { if (e_1) throw e_1.error; }
		        }
		        return rv;
		    }
		    if (Array.isArray(val)) {
		        return val.map(dropUndefinedKeys);
		    }
		    return val;
		}
		object.dropUndefinedKeys = dropUndefinedKeys;
		
		return object;
	}

	var hasRequiredNode;

	function requireNode () {
		if (hasRequiredNode) return node.exports;
		hasRequiredNode = 1;
		(function (module, exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			var is_1 = requireIs();
			var object_1 = requireObject();
			/**
			 * Checks whether we're in the Node.js or Browser environment
			 *
			 * @returns Answer to given question
			 */
			function isNodeEnv() {
			    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
			}
			exports.isNodeEnv = isNodeEnv;
			/**
			 * Requires a module which is protected against bundler minification.
			 *
			 * @param request The module path to resolve
			 */
			// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
			function dynamicRequire(mod, request) {
			    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			    return mod.require(request);
			}
			exports.dynamicRequire = dynamicRequire;
			/** Default request keys that'll be used to extract data from the request */
			var DEFAULT_REQUEST_KEYS = ['cookies', 'data', 'headers', 'method', 'query_string', 'url'];
			/**
			 * Normalizes data from the request object, accounting for framework differences.
			 *
			 * @param req The request object from which to extract data
			 * @param keys An optional array of keys to include in the normalized data. Defaults to DEFAULT_REQUEST_KEYS if not
			 * provided.
			 * @returns An object containing normalized request data
			 */
			function extractNodeRequestData(req, keys) {
			    if (keys === void 0) { keys = DEFAULT_REQUEST_KEYS; }
			    // make sure we can safely use dynamicRequire below
			    if (!isNodeEnv()) {
			        throw new Error("Can't get node request data outside of a node environment");
			    }
			    var requestData = {};
			    // headers:
			    //   node, express: req.headers
			    //   koa: req.header
			    var headers = (req.headers || req.header || {});
			    // method:
			    //   node, express, koa: req.method
			    var method = req.method;
			    // host:
			    //   express: req.hostname in > 4 and req.host in < 4
			    //   koa: req.host
			    //   node: req.headers.host
			    var host = req.hostname || req.host || headers.host || '<no host>';
			    // protocol:
			    //   node: <n/a>
			    //   express, koa: req.protocol
			    var protocol = req.protocol === 'https' || req.secure || (req.socket || {}).encrypted
			        ? 'https'
			        : 'http';
			    // url (including path and query string):
			    //   node, express: req.originalUrl
			    //   koa: req.url
			    var originalUrl = (req.originalUrl || req.url || '');
			    // absolute url
			    var absoluteUrl = protocol + "://" + host + originalUrl;
			    keys.forEach(function (key) {
			        switch (key) {
			            case 'headers':
			                requestData.headers = headers;
			                break;
			            case 'method':
			                requestData.method = method;
			                break;
			            case 'url':
			                requestData.url = absoluteUrl;
			                break;
			            case 'cookies':
			                // cookies:
			                //   node, express, koa: req.headers.cookie
			                //   vercel, sails.js, express (w/ cookie middleware): req.cookies
			                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			                requestData.cookies = req.cookies || dynamicRequire(module, 'cookie').parse(headers.cookie || '');
			                break;
			            case 'query_string':
			                // query string:
			                //   node: req.url (raw)
			                //   express, koa: req.query
			                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
			                requestData.query_string = dynamicRequire(module, 'url').parse(originalUrl || '', false).query;
			                break;
			            case 'data':
			                if (method === 'GET' || method === 'HEAD') {
			                    break;
			                }
			                // body data:
			                //   node, express, koa: req.body
			                if (req.body !== undefined) {
			                    requestData.data = is_1.isString(req.body) ? req.body : JSON.stringify(object_1.normalize(req.body));
			                }
			                break;
			            default:
			                if ({}.hasOwnProperty.call(req, key)) {
			                    requestData[key] = req[key];
			                }
			        }
			    });
			    return requestData;
			}
			exports.extractNodeRequestData = extractNodeRequestData;
			
	} (node, node.exports));
		return node.exports;
	}

	var hasRequiredMisc;

	function requireMisc () {
		if (hasRequiredMisc) return misc;
		hasRequiredMisc = 1;
		Object.defineProperty(misc, "__esModule", { value: true });
		var node_1 = requireNode();
		var string_1 = requireString();
		var fallbackGlobalObject = {};
		/**
		 * Safely get global scope object
		 *
		 * @returns Global scope object
		 */
		function getGlobalObject() {
		    return (node_1.isNodeEnv()
		        ? commonjsGlobal
		        : typeof window !== 'undefined'
		            ? window
		            : typeof self !== 'undefined'
		                ? self
		                : fallbackGlobalObject);
		}
		misc.getGlobalObject = getGlobalObject;
		/**
		 * UUID4 generator
		 *
		 * @returns string Generated UUID4.
		 */
		function uuid4() {
		    var global = getGlobalObject();
		    var crypto = global.crypto || global.msCrypto;
		    if (!(crypto === void 0) && crypto.getRandomValues) {
		        // Use window.crypto API if available
		        var arr = new Uint16Array(8);
		        crypto.getRandomValues(arr);
		        // set 4 in byte 7
		        // eslint-disable-next-line no-bitwise
		        arr[3] = (arr[3] & 0xfff) | 0x4000;
		        // set 2 most significant bits of byte 9 to '10'
		        // eslint-disable-next-line no-bitwise
		        arr[4] = (arr[4] & 0x3fff) | 0x8000;
		        var pad = function (num) {
		            var v = num.toString(16);
		            while (v.length < 4) {
		                v = "0" + v;
		            }
		            return v;
		        };
		        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
		    }
		    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
		    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		        // eslint-disable-next-line no-bitwise
		        var r = (Math.random() * 16) | 0;
		        // eslint-disable-next-line no-bitwise
		        var v = c === 'x' ? r : (r & 0x3) | 0x8;
		        return v.toString(16);
		    });
		}
		misc.uuid4 = uuid4;
		/**
		 * Parses string form of URL into an object
		 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
		 * // intentionally using regex and not <a/> href parsing trick because React Native and other
		 * // environments where DOM might not be available
		 * @returns parsed URL object
		 */
		function parseUrl(url) {
		    if (!url) {
		        return {};
		    }
		    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
		    if (!match) {
		        return {};
		    }
		    // coerce to undefined values to empty string so we don't get 'undefined'
		    var query = match[6] || '';
		    var fragment = match[8] || '';
		    return {
		        host: match[4],
		        path: match[5],
		        protocol: match[2],
		        relative: match[5] + query + fragment,
		    };
		}
		misc.parseUrl = parseUrl;
		/**
		 * Extracts either message or type+value from an event that can be used for user-facing logs
		 * @returns event's description
		 */
		function getEventDescription(event) {
		    if (event.message) {
		        return event.message;
		    }
		    if (event.exception && event.exception.values && event.exception.values[0]) {
		        var exception = event.exception.values[0];
		        if (exception.type && exception.value) {
		            return exception.type + ": " + exception.value;
		        }
		        return exception.type || exception.value || event.event_id || '<unknown>';
		    }
		    return event.event_id || '<unknown>';
		}
		misc.getEventDescription = getEventDescription;
		/** JSDoc */
		function consoleSandbox(callback) {
		    var global = getGlobalObject();
		    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
		    if (!('console' in global)) {
		        return callback();
		    }
		    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		    var originalConsole = global.console;
		    var wrappedLevels = {};
		    // Restore all wrapped console methods
		    levels.forEach(function (level) {
		        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		        if (level in global.console && originalConsole[level].__sentry_original__) {
		            wrappedLevels[level] = originalConsole[level];
		            originalConsole[level] = originalConsole[level].__sentry_original__;
		        }
		    });
		    // Perform callback manipulations
		    var result = callback();
		    // Revert restoration to wrapped state
		    Object.keys(wrappedLevels).forEach(function (level) {
		        originalConsole[level] = wrappedLevels[level];
		    });
		    return result;
		}
		misc.consoleSandbox = consoleSandbox;
		/**
		 * Adds exception values, type and value to an synthetic Exception.
		 * @param event The event to modify.
		 * @param value Value of the exception.
		 * @param type Type of the exception.
		 * @hidden
		 */
		function addExceptionTypeValue(event, value, type) {
		    event.exception = event.exception || {};
		    event.exception.values = event.exception.values || [];
		    event.exception.values[0] = event.exception.values[0] || {};
		    event.exception.values[0].value = event.exception.values[0].value || value || '';
		    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
		}
		misc.addExceptionTypeValue = addExceptionTypeValue;
		/**
		 * Adds exception mechanism to a given event.
		 * @param event The event to modify.
		 * @param mechanism Mechanism of the mechanism.
		 * @hidden
		 */
		function addExceptionMechanism(event, mechanism) {
		    if (mechanism === void 0) { mechanism = {}; }
		    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
		    try {
		        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
		        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
		        Object.keys(mechanism).forEach(function (key) {
		            // @ts-ignore Mechanism has no index signature
		            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		            event.exception.values[0].mechanism[key] = mechanism[key];
		        });
		    }
		    catch (_oO) {
		        // no-empty
		    }
		}
		misc.addExceptionMechanism = addExceptionMechanism;
		/**
		 * A safe form of location.href
		 */
		function getLocationHref() {
		    try {
		        return document.location.href;
		    }
		    catch (oO) {
		        return '';
		    }
		}
		misc.getLocationHref = getLocationHref;
		// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
		var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
		/**
		 * Parses input into a SemVer interface
		 * @param input string representation of a semver version
		 */
		function parseSemver(input) {
		    var match = input.match(SEMVER_REGEXP) || [];
		    var major = parseInt(match[1], 10);
		    var minor = parseInt(match[2], 10);
		    var patch = parseInt(match[3], 10);
		    return {
		        buildmetadata: match[5],
		        major: isNaN(major) ? undefined : major,
		        minor: isNaN(minor) ? undefined : minor,
		        patch: isNaN(patch) ? undefined : patch,
		        prerelease: match[4],
		    };
		}
		misc.parseSemver = parseSemver;
		var defaultRetryAfter = 60 * 1000; // 60 seconds
		/**
		 * Extracts Retry-After value from the request header or returns default value
		 * @param now current unix timestamp
		 * @param header string representation of 'Retry-After' header
		 */
		function parseRetryAfterHeader(now, header) {
		    if (!header) {
		        return defaultRetryAfter;
		    }
		    var headerDelay = parseInt("" + header, 10);
		    if (!isNaN(headerDelay)) {
		        return headerDelay * 1000;
		    }
		    var headerDate = Date.parse("" + header);
		    if (!isNaN(headerDate)) {
		        return headerDate - now;
		    }
		    return defaultRetryAfter;
		}
		misc.parseRetryAfterHeader = parseRetryAfterHeader;
		/**
		 * This function adds context (pre/post/line) lines to the provided frame
		 *
		 * @param lines string[] containing all lines
		 * @param frame StackFrame that will be mutated
		 * @param linesOfContext number of context lines we want to add pre/post
		 */
		function addContextToFrame(lines, frame, linesOfContext) {
		    if (linesOfContext === void 0) { linesOfContext = 5; }
		    var lineno = frame.lineno || 0;
		    var maxLines = lines.length;
		    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
		    frame.pre_context = lines
		        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
		        .map(function (line) { return string_1.snipLine(line, 0); });
		    frame.context_line = string_1.snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
		    frame.post_context = lines
		        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
		        .map(function (line) { return string_1.snipLine(line, 0); });
		}
		misc.addContextToFrame = addContextToFrame;
		/**
		 * Strip the query string and fragment off of a given URL or path (if present)
		 *
		 * @param urlPath Full URL or path, including possible query string and/or fragment
		 * @returns URL or path without query string or fragment
		 */
		function stripUrlQueryAndFragment(urlPath) {
		    // eslint-disable-next-line no-useless-escape
		    return urlPath.split(/[\?#]/, 1)[0];
		}
		misc.stripUrlQueryAndFragment = stripUrlQueryAndFragment;
		
		return misc;
	}

	var hasRequiredLogger;

	function requireLogger () {
		if (hasRequiredLogger) return logger;
		hasRequiredLogger = 1;
		Object.defineProperty(logger, "__esModule", { value: true });
		/* eslint-disable @typescript-eslint/no-explicit-any */
		var misc_1 = requireMisc();
		// TODO: Implement different loggers for different environments
		var global = misc_1.getGlobalObject();
		/** Prefix for logging strings */
		var PREFIX = 'Sentry Logger ';
		/** JSDoc */
		var Logger = /** @class */ (function () {
		    /** JSDoc */
		    function Logger() {
		        this._enabled = false;
		    }
		    /** JSDoc */
		    Logger.prototype.disable = function () {
		        this._enabled = false;
		    };
		    /** JSDoc */
		    Logger.prototype.enable = function () {
		        this._enabled = true;
		    };
		    /** JSDoc */
		    Logger.prototype.log = function () {
		        var args = [];
		        for (var _i = 0; _i < arguments.length; _i++) {
		            args[_i] = arguments[_i];
		        }
		        if (!this._enabled) {
		            return;
		        }
		        misc_1.consoleSandbox(function () {
		            global.console.log(PREFIX + "[Log]: " + args.join(' '));
		        });
		    };
		    /** JSDoc */
		    Logger.prototype.warn = function () {
		        var args = [];
		        for (var _i = 0; _i < arguments.length; _i++) {
		            args[_i] = arguments[_i];
		        }
		        if (!this._enabled) {
		            return;
		        }
		        misc_1.consoleSandbox(function () {
		            global.console.warn(PREFIX + "[Warn]: " + args.join(' '));
		        });
		    };
		    /** JSDoc */
		    Logger.prototype.error = function () {
		        var args = [];
		        for (var _i = 0; _i < arguments.length; _i++) {
		            args[_i] = arguments[_i];
		        }
		        if (!this._enabled) {
		            return;
		        }
		        misc_1.consoleSandbox(function () {
		            global.console.error(PREFIX + "[Error]: " + args.join(' '));
		        });
		    };
		    return Logger;
		}());
		// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
		global.__SENTRY__ = global.__SENTRY__ || {};
		var logger$1 = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());
		logger.logger = logger$1;
		
		return logger;
	}

	var supports = {};

	var hasRequiredSupports;

	function requireSupports () {
		if (hasRequiredSupports) return supports;
		hasRequiredSupports = 1;
		Object.defineProperty(supports, "__esModule", { value: true });
		var logger_1 = requireLogger();
		var misc_1 = requireMisc();
		/**
		 * Tells whether current environment supports ErrorEvent objects
		 * {@link supportsErrorEvent}.
		 *
		 * @returns Answer to the given question.
		 */
		function supportsErrorEvent() {
		    try {
		        new ErrorEvent('');
		        return true;
		    }
		    catch (e) {
		        return false;
		    }
		}
		supports.supportsErrorEvent = supportsErrorEvent;
		/**
		 * Tells whether current environment supports DOMError objects
		 * {@link supportsDOMError}.
		 *
		 * @returns Answer to the given question.
		 */
		function supportsDOMError() {
		    try {
		        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
		        // 1 argument required, but only 0 present.
		        // @ts-ignore It really needs 1 argument, not 0.
		        new DOMError('');
		        return true;
		    }
		    catch (e) {
		        return false;
		    }
		}
		supports.supportsDOMError = supportsDOMError;
		/**
		 * Tells whether current environment supports DOMException objects
		 * {@link supportsDOMException}.
		 *
		 * @returns Answer to the given question.
		 */
		function supportsDOMException() {
		    try {
		        new DOMException('');
		        return true;
		    }
		    catch (e) {
		        return false;
		    }
		}
		supports.supportsDOMException = supportsDOMException;
		/**
		 * Tells whether current environment supports Fetch API
		 * {@link supportsFetch}.
		 *
		 * @returns Answer to the given question.
		 */
		function supportsFetch() {
		    if (!('fetch' in misc_1.getGlobalObject())) {
		        return false;
		    }
		    try {
		        new Headers();
		        new Request('');
		        new Response();
		        return true;
		    }
		    catch (e) {
		        return false;
		    }
		}
		supports.supportsFetch = supportsFetch;
		/**
		 * isNativeFetch checks if the given function is a native implementation of fetch()
		 */
		// eslint-disable-next-line @typescript-eslint/ban-types
		function isNativeFetch(func) {
		    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
		}
		/**
		 * Tells whether current environment supports Fetch API natively
		 * {@link supportsNativeFetch}.
		 *
		 * @returns true if `window.fetch` is natively implemented, false otherwise
		 */
		function supportsNativeFetch() {
		    if (!supportsFetch()) {
		        return false;
		    }
		    var global = misc_1.getGlobalObject();
		    // Fast path to avoid DOM I/O
		    // eslint-disable-next-line @typescript-eslint/unbound-method
		    if (isNativeFetch(global.fetch)) {
		        return true;
		    }
		    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
		    // so create a "pure" iframe to see if that has native fetch
		    var result = false;
		    var doc = global.document;
		    // eslint-disable-next-line deprecation/deprecation
		    if (doc && typeof doc.createElement === "function") {
		        try {
		            var sandbox = doc.createElement('iframe');
		            sandbox.hidden = true;
		            doc.head.appendChild(sandbox);
		            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
		                // eslint-disable-next-line @typescript-eslint/unbound-method
		                result = isNativeFetch(sandbox.contentWindow.fetch);
		            }
		            doc.head.removeChild(sandbox);
		        }
		        catch (err) {
		            logger_1.logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
		        }
		    }
		    return result;
		}
		supports.supportsNativeFetch = supportsNativeFetch;
		/**
		 * Tells whether current environment supports ReportingObserver API
		 * {@link supportsReportingObserver}.
		 *
		 * @returns Answer to the given question.
		 */
		function supportsReportingObserver() {
		    return 'ReportingObserver' in misc_1.getGlobalObject();
		}
		supports.supportsReportingObserver = supportsReportingObserver;
		/**
		 * Tells whether current environment supports Referrer Policy API
		 * {@link supportsReferrerPolicy}.
		 *
		 * @returns Answer to the given question.
		 */
		function supportsReferrerPolicy() {
		    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
		    // https://caniuse.com/#feat=referrer-policy
		    // It doesn't. And it throw exception instead of ignoring this parameter...
		    // REF: https://github.com/getsentry/raven-js/issues/1233
		    if (!supportsFetch()) {
		        return false;
		    }
		    try {
		        new Request('_', {
		            referrerPolicy: 'origin',
		        });
		        return true;
		    }
		    catch (e) {
		        return false;
		    }
		}
		supports.supportsReferrerPolicy = supportsReferrerPolicy;
		/**
		 * Tells whether current environment supports History API
		 * {@link supportsHistory}.
		 *
		 * @returns Answer to the given question.
		 */
		function supportsHistory() {
		    // NOTE: in Chrome App environment, touching history.pushState, *even inside
		    //       a try/catch block*, will cause Chrome to output an error to console.error
		    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
		    var global = misc_1.getGlobalObject();
		    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    var chrome = global.chrome;
		    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
		    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
		    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
		    return !isChromePackagedApp && hasHistoryApi;
		}
		supports.supportsHistory = supportsHistory;
		
		return supports;
	}

	var hasRequiredInstrument;

	function requireInstrument () {
		if (hasRequiredInstrument) return instrument;
		hasRequiredInstrument = 1;
		Object.defineProperty(instrument, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var is_1 = requireIs();
		var logger_1 = requireLogger();
		var misc_1 = requireMisc();
		var object_1 = requireObject();
		var stacktrace_1 = requireStacktrace();
		var supports_1 = requireSupports();
		var global = misc_1.getGlobalObject();
		/**
		 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
		 *  - Console API
		 *  - Fetch API
		 *  - XHR API
		 *  - History API
		 *  - DOM API (click/typing)
		 *  - Error API
		 *  - UnhandledRejection API
		 */
		var handlers = {};
		var instrumented = {};
		/** Instruments given API */
		function instrument$1(type) {
		    if (instrumented[type]) {
		        return;
		    }
		    instrumented[type] = true;
		    switch (type) {
		        case 'console':
		            instrumentConsole();
		            break;
		        case 'dom':
		            instrumentDOM();
		            break;
		        case 'xhr':
		            instrumentXHR();
		            break;
		        case 'fetch':
		            instrumentFetch();
		            break;
		        case 'history':
		            instrumentHistory();
		            break;
		        case 'error':
		            instrumentError();
		            break;
		        case 'unhandledrejection':
		            instrumentUnhandledRejection();
		            break;
		        default:
		            logger_1.logger.warn('unknown instrumentation type:', type);
		    }
		}
		/**
		 * Add handler that will be called when given type of instrumentation triggers.
		 * Use at your own risk, this might break without changelog notice, only used internally.
		 * @hidden
		 */
		function addInstrumentationHandler(handler) {
		    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
		        return;
		    }
		    handlers[handler.type] = handlers[handler.type] || [];
		    handlers[handler.type].push(handler.callback);
		    instrument$1(handler.type);
		}
		instrument.addInstrumentationHandler = addInstrumentationHandler;
		/** JSDoc */
		function triggerHandlers(type, data) {
		    var e_1, _a;
		    if (!type || !handlers[type]) {
		        return;
		    }
		    try {
		        for (var _b = tslib_1.__values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
		            var handler = _c.value;
		            try {
		                handler(data);
		            }
		            catch (e) {
		                logger_1.logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + stacktrace_1.getFunctionName(handler) + "\nError: " + e);
		            }
		        }
		    }
		    catch (e_1_1) { e_1 = { error: e_1_1 }; }
		    finally {
		        try {
		            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
		        }
		        finally { if (e_1) throw e_1.error; }
		    }
		}
		/** JSDoc */
		function instrumentConsole() {
		    if (!('console' in global)) {
		        return;
		    }
		    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
		        if (!(level in global.console)) {
		            return;
		        }
		        object_1.fill(global.console, level, function (originalConsoleLevel) {
		            return function () {
		                var args = [];
		                for (var _i = 0; _i < arguments.length; _i++) {
		                    args[_i] = arguments[_i];
		                }
		                triggerHandlers('console', { args: args, level: level });
		                // this fails for some browsers. :(
		                if (originalConsoleLevel) {
		                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
		                }
		            };
		        });
		    });
		}
		/** JSDoc */
		function instrumentFetch() {
		    if (!supports_1.supportsNativeFetch()) {
		        return;
		    }
		    object_1.fill(global, 'fetch', function (originalFetch) {
		        return function () {
		            var args = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                args[_i] = arguments[_i];
		            }
		            var handlerData = {
		                args: args,
		                fetchData: {
		                    method: getFetchMethod(args),
		                    url: getFetchUrl(args),
		                },
		                startTimestamp: Date.now(),
		            };
		            triggerHandlers('fetch', tslib_1.__assign({}, handlerData));
		            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		            return originalFetch.apply(global, args).then(function (response) {
		                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), response: response }));
		                return response;
		            }, function (error) {
		                triggerHandlers('fetch', tslib_1.__assign(tslib_1.__assign({}, handlerData), { endTimestamp: Date.now(), error: error }));
		                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
		                //       it means the sentry.javascript SDK caught an error invoking your application code.
		                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
		                throw error;
		            });
		        };
		    });
		}
		/* eslint-disable @typescript-eslint/no-unsafe-member-access */
		/** Extract `method` from fetch call arguments */
		function getFetchMethod(fetchArgs) {
		    if (fetchArgs === void 0) { fetchArgs = []; }
		    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
		        return String(fetchArgs[0].method).toUpperCase();
		    }
		    if (fetchArgs[1] && fetchArgs[1].method) {
		        return String(fetchArgs[1].method).toUpperCase();
		    }
		    return 'GET';
		}
		/** Extract `url` from fetch call arguments */
		function getFetchUrl(fetchArgs) {
		    if (fetchArgs === void 0) { fetchArgs = []; }
		    if (typeof fetchArgs[0] === 'string') {
		        return fetchArgs[0];
		    }
		    if ('Request' in global && is_1.isInstanceOf(fetchArgs[0], Request)) {
		        return fetchArgs[0].url;
		    }
		    return String(fetchArgs[0]);
		}
		/* eslint-enable @typescript-eslint/no-unsafe-member-access */
		/** JSDoc */
		function instrumentXHR() {
		    if (!('XMLHttpRequest' in global)) {
		        return;
		    }
		    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
		    var requestKeys = [];
		    var requestValues = [];
		    var xhrproto = XMLHttpRequest.prototype;
		    object_1.fill(xhrproto, 'open', function (originalOpen) {
		        return function () {
		            var args = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                args[_i] = arguments[_i];
		            }
		            // eslint-disable-next-line @typescript-eslint/no-this-alias
		            var xhr = this;
		            var url = args[1];
		            xhr.__sentry_xhr__ = {
		                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		                method: is_1.isString(args[0]) ? args[0].toUpperCase() : args[0],
		                url: args[1],
		            };
		            // if Sentry key appears in URL, don't capture it as a request
		            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		            if (is_1.isString(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
		                xhr.__sentry_own_request__ = true;
		            }
		            var onreadystatechangeHandler = function () {
		                if (xhr.readyState === 4) {
		                    try {
		                        // touching statusCode in some platforms throws
		                        // an exception
		                        if (xhr.__sentry_xhr__) {
		                            xhr.__sentry_xhr__.status_code = xhr.status;
		                        }
		                    }
		                    catch (e) {
		                        /* do nothing */
		                    }
		                    try {
		                        var requestPos = requestKeys.indexOf(xhr);
		                        if (requestPos !== -1) {
		                            // Make sure to pop both key and value to keep it in sync.
		                            requestKeys.splice(requestPos);
		                            var args_1 = requestValues.splice(requestPos)[0];
		                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) {
		                                xhr.__sentry_xhr__.body = args_1[0];
		                            }
		                        }
		                    }
		                    catch (e) {
		                        /* do nothing */
		                    }
		                    triggerHandlers('xhr', {
		                        args: args,
		                        endTimestamp: Date.now(),
		                        startTimestamp: Date.now(),
		                        xhr: xhr,
		                    });
		                }
		            };
		            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
		                object_1.fill(xhr, 'onreadystatechange', function (original) {
		                    return function () {
		                        var readyStateArgs = [];
		                        for (var _i = 0; _i < arguments.length; _i++) {
		                            readyStateArgs[_i] = arguments[_i];
		                        }
		                        onreadystatechangeHandler();
		                        return original.apply(xhr, readyStateArgs);
		                    };
		                });
		            }
		            else {
		                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
		            }
		            return originalOpen.apply(xhr, args);
		        };
		    });
		    object_1.fill(xhrproto, 'send', function (originalSend) {
		        return function () {
		            var args = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                args[_i] = arguments[_i];
		            }
		            requestKeys.push(this);
		            requestValues.push(args);
		            triggerHandlers('xhr', {
		                args: args,
		                startTimestamp: Date.now(),
		                xhr: this,
		            });
		            return originalSend.apply(this, args);
		        };
		    });
		}
		var lastHref;
		/** JSDoc */
		function instrumentHistory() {
		    if (!supports_1.supportsHistory()) {
		        return;
		    }
		    var oldOnPopState = global.onpopstate;
		    global.onpopstate = function () {
		        var args = [];
		        for (var _i = 0; _i < arguments.length; _i++) {
		            args[_i] = arguments[_i];
		        }
		        var to = global.location.href;
		        // keep track of the current URL state, as we always receive only the updated state
		        var from = lastHref;
		        lastHref = to;
		        triggerHandlers('history', {
		            from: from,
		            to: to,
		        });
		        if (oldOnPopState) {
		            return oldOnPopState.apply(this, args);
		        }
		    };
		    /** @hidden */
		    function historyReplacementFunction(originalHistoryFunction) {
		        return function () {
		            var args = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                args[_i] = arguments[_i];
		            }
		            var url = args.length > 2 ? args[2] : undefined;
		            if (url) {
		                // coerce to string (this is what pushState does)
		                var from = lastHref;
		                var to = String(url);
		                // keep track of the current URL state, as we always receive only the updated state
		                lastHref = to;
		                triggerHandlers('history', {
		                    from: from,
		                    to: to,
		                });
		            }
		            return originalHistoryFunction.apply(this, args);
		        };
		    }
		    object_1.fill(global.history, 'pushState', historyReplacementFunction);
		    object_1.fill(global.history, 'replaceState', historyReplacementFunction);
		}
		/** JSDoc */
		function instrumentDOM() {
		    if (!('document' in global)) {
		        return;
		    }
		    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
		    // to the document. Do this before we instrument addEventListener.
		    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
		    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
		    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
		    ['EventTarget', 'Node'].forEach(function (target) {
		        /* eslint-disable @typescript-eslint/no-unsafe-member-access */
		        var proto = global[target] && global[target].prototype;
		        // eslint-disable-next-line no-prototype-builtins
		        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
		            return;
		        }
		        /* eslint-enable @typescript-eslint/no-unsafe-member-access */
		        object_1.fill(proto, 'addEventListener', function (original) {
		            return function (eventName, fn, options) {
		                if (fn && fn.handleEvent) {
		                    if (eventName === 'click') {
		                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
		                            return function (event) {
		                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
		                                return innerOriginal.call(this, event);
		                            };
		                        });
		                    }
		                    if (eventName === 'keypress') {
		                        object_1.fill(fn, 'handleEvent', function (innerOriginal) {
		                            return function (event) {
		                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
		                                return innerOriginal.call(this, event);
		                            };
		                        });
		                    }
		                }
		                else {
		                    if (eventName === 'click') {
		                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
		                    }
		                    if (eventName === 'keypress') {
		                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
		                    }
		                }
		                return original.call(this, eventName, fn, options);
		            };
		        });
		        object_1.fill(proto, 'removeEventListener', function (original) {
		            return function (eventName, fn, options) {
		                try {
		                    original.call(this, eventName, fn.__sentry_wrapped__, options);
		                }
		                catch (e) {
		                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
		                }
		                return original.call(this, eventName, fn, options);
		            };
		        });
		    });
		}
		var debounceDuration = 1000;
		var debounceTimer = 0;
		var keypressTimeout;
		var lastCapturedEvent;
		/**
		 * Wraps addEventListener to capture UI breadcrumbs
		 * @param name the event name (e.g. "click")
		 * @param handler function that will be triggered
		 * @param debounce decides whether it should wait till another event loop
		 * @returns wrapped breadcrumb events handler
		 * @hidden
		 */
		function domEventHandler(name, handler, debounce) {
		    if (debounce === void 0) { debounce = false; }
		    return function (event) {
		        // reset keypress timeout; e.g. triggering a 'click' after
		        // a 'keypress' will reset the keypress debounce so that a new
		        // set of keypresses can be recorded
		        keypressTimeout = undefined;
		        // It's possible this handler might trigger multiple times for the same
		        // event (e.g. event propagation through node ancestors). Ignore if we've
		        // already captured the event.
		        if (!event || lastCapturedEvent === event) {
		            return;
		        }
		        lastCapturedEvent = event;
		        if (debounceTimer) {
		            clearTimeout(debounceTimer);
		        }
		        if (debounce) {
		            debounceTimer = setTimeout(function () {
		                handler({ event: event, name: name });
		            });
		        }
		        else {
		            handler({ event: event, name: name });
		        }
		    };
		}
		/**
		 * Wraps addEventListener to capture keypress UI events
		 * @param handler function that will be triggered
		 * @returns wrapped keypress events handler
		 * @hidden
		 */
		function keypressEventHandler(handler) {
		    // TODO: if somehow user switches keypress target before
		    //       debounce timeout is triggered, we will only capture
		    //       a single breadcrumb from the FIRST target (acceptable?)
		    return function (event) {
		        var target;
		        try {
		            target = event.target;
		        }
		        catch (e) {
		            // just accessing event properties can throw an exception in some rare circumstances
		            // see: https://github.com/getsentry/raven-js/issues/838
		            return;
		        }
		        var tagName = target && target.tagName;
		        // only consider keypress events on actual input elements
		        // this will disregard keypresses targeting body (e.g. tabbing
		        // through elements, hotkeys, etc)
		        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
		            return;
		        }
		        // record first keypress in a series, but ignore subsequent
		        // keypresses until debounce clears
		        if (!keypressTimeout) {
		            domEventHandler('input', handler)(event);
		        }
		        clearTimeout(keypressTimeout);
		        keypressTimeout = setTimeout(function () {
		            keypressTimeout = undefined;
		        }, debounceDuration);
		    };
		}
		var _oldOnErrorHandler = null;
		/** JSDoc */
		function instrumentError() {
		    _oldOnErrorHandler = global.onerror;
		    global.onerror = function (msg, url, line, column, error) {
		        triggerHandlers('error', {
		            column: column,
		            error: error,
		            line: line,
		            msg: msg,
		            url: url,
		        });
		        if (_oldOnErrorHandler) {
		            // eslint-disable-next-line prefer-rest-params
		            return _oldOnErrorHandler.apply(this, arguments);
		        }
		        return false;
		    };
		}
		var _oldOnUnhandledRejectionHandler = null;
		/** JSDoc */
		function instrumentUnhandledRejection() {
		    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
		    global.onunhandledrejection = function (e) {
		        triggerHandlers('unhandledrejection', e);
		        if (_oldOnUnhandledRejectionHandler) {
		            // eslint-disable-next-line prefer-rest-params
		            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
		        }
		        return true;
		    };
		}
		
		return instrument;
	}

	var path = {};

	var hasRequiredPath;

	function requirePath () {
		if (hasRequiredPath) return path;
		hasRequiredPath = 1;
		// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
		// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
		Object.defineProperty(path, "__esModule", { value: true });
		/** JSDoc */
		function normalizeArray(parts, allowAboveRoot) {
		    // if the path tries to go above the root, `up` ends up > 0
		    var up = 0;
		    for (var i = parts.length - 1; i >= 0; i--) {
		        var last = parts[i];
		        if (last === '.') {
		            parts.splice(i, 1);
		        }
		        else if (last === '..') {
		            parts.splice(i, 1);
		            // eslint-disable-next-line no-plusplus
		            up++;
		        }
		        else if (up) {
		            parts.splice(i, 1);
		            // eslint-disable-next-line no-plusplus
		            up--;
		        }
		    }
		    // if the path is allowed to go above the root, restore leading ..s
		    if (allowAboveRoot) {
		        // eslint-disable-next-line no-plusplus
		        for (; up--; up) {
		            parts.unshift('..');
		        }
		    }
		    return parts;
		}
		// Split a filename into [root, dir, basename, ext], unix version
		// 'root' is just a slash, or nothing.
		var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
		/** JSDoc */
		function splitPath(filename) {
		    var parts = splitPathRe.exec(filename);
		    return parts ? parts.slice(1) : [];
		}
		// path.resolve([from ...], to)
		// posix version
		/** JSDoc */
		function resolve() {
		    var args = [];
		    for (var _i = 0; _i < arguments.length; _i++) {
		        args[_i] = arguments[_i];
		    }
		    var resolvedPath = '';
		    var resolvedAbsolute = false;
		    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
		        var path = i >= 0 ? args[i] : '/';
		        // Skip empty entries
		        if (!path) {
		            continue;
		        }
		        resolvedPath = path + "/" + resolvedPath;
		        resolvedAbsolute = path.charAt(0) === '/';
		    }
		    // At this point the path should be resolved to a full absolute path, but
		    // handle relative paths to be safe (might happen when process.cwd() fails)
		    // Normalize the path
		    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
		    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
		}
		path.resolve = resolve;
		/** JSDoc */
		function trim(arr) {
		    var start = 0;
		    for (; start < arr.length; start++) {
		        if (arr[start] !== '') {
		            break;
		        }
		    }
		    var end = arr.length - 1;
		    for (; end >= 0; end--) {
		        if (arr[end] !== '') {
		            break;
		        }
		    }
		    if (start > end) {
		        return [];
		    }
		    return arr.slice(start, end - start + 1);
		}
		// path.relative(from, to)
		// posix version
		/** JSDoc */
		function relative(from, to) {
		    /* eslint-disable no-param-reassign */
		    from = resolve(from).substr(1);
		    to = resolve(to).substr(1);
		    /* eslint-enable no-param-reassign */
		    var fromParts = trim(from.split('/'));
		    var toParts = trim(to.split('/'));
		    var length = Math.min(fromParts.length, toParts.length);
		    var samePartsLength = length;
		    for (var i = 0; i < length; i++) {
		        if (fromParts[i] !== toParts[i]) {
		            samePartsLength = i;
		            break;
		        }
		    }
		    var outputParts = [];
		    for (var i = samePartsLength; i < fromParts.length; i++) {
		        outputParts.push('..');
		    }
		    outputParts = outputParts.concat(toParts.slice(samePartsLength));
		    return outputParts.join('/');
		}
		path.relative = relative;
		// path.normalize(path)
		// posix version
		/** JSDoc */
		function normalizePath(path) {
		    var isPathAbsolute = isAbsolute(path);
		    var trailingSlash = path.substr(-1) === '/';
		    // Normalize the path
		    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
		    if (!normalizedPath && !isPathAbsolute) {
		        normalizedPath = '.';
		    }
		    if (normalizedPath && trailingSlash) {
		        normalizedPath += '/';
		    }
		    return (isPathAbsolute ? '/' : '') + normalizedPath;
		}
		path.normalizePath = normalizePath;
		// posix version
		/** JSDoc */
		function isAbsolute(path) {
		    return path.charAt(0) === '/';
		}
		path.isAbsolute = isAbsolute;
		// posix version
		/** JSDoc */
		function join() {
		    var args = [];
		    for (var _i = 0; _i < arguments.length; _i++) {
		        args[_i] = arguments[_i];
		    }
		    return normalizePath(args.join('/'));
		}
		path.join = join;
		/** JSDoc */
		function dirname(path) {
		    var result = splitPath(path);
		    var root = result[0];
		    var dir = result[1];
		    if (!root && !dir) {
		        // No dirname whatsoever
		        return '.';
		    }
		    if (dir) {
		        // It has a dirname, strip trailing slash
		        dir = dir.substr(0, dir.length - 1);
		    }
		    return root + dir;
		}
		path.dirname = dirname;
		/** JSDoc */
		function basename(path, ext) {
		    var f = splitPath(path)[2];
		    if (ext && f.substr(ext.length * -1) === ext) {
		        f = f.substr(0, f.length - ext.length);
		    }
		    return f;
		}
		path.basename = basename;
		
		return path;
	}

	var promisebuffer = {};

	var syncpromise = {};

	var hasRequiredSyncpromise;

	function requireSyncpromise () {
		if (hasRequiredSyncpromise) return syncpromise;
		hasRequiredSyncpromise = 1;
		Object.defineProperty(syncpromise, "__esModule", { value: true });
		/* eslint-disable @typescript-eslint/explicit-function-return-type */
		/* eslint-disable @typescript-eslint/typedef */
		/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
		/* eslint-disable @typescript-eslint/no-explicit-any */
		var is_1 = requireIs();
		/** SyncPromise internal states */
		var States;
		(function (States) {
		    /** Pending */
		    States["PENDING"] = "PENDING";
		    /** Resolved / OK */
		    States["RESOLVED"] = "RESOLVED";
		    /** Rejected / Error */
		    States["REJECTED"] = "REJECTED";
		})(States || (States = {}));
		/**
		 * Thenable class that behaves like a Promise and follows it's interface
		 * but is not async internally
		 */
		var SyncPromise = /** @class */ (function () {
		    function SyncPromise(executor) {
		        var _this = this;
		        this._state = States.PENDING;
		        this._handlers = [];
		        /** JSDoc */
		        this._resolve = function (value) {
		            _this._setResult(States.RESOLVED, value);
		        };
		        /** JSDoc */
		        this._reject = function (reason) {
		            _this._setResult(States.REJECTED, reason);
		        };
		        /** JSDoc */
		        this._setResult = function (state, value) {
		            if (_this._state !== States.PENDING) {
		                return;
		            }
		            if (is_1.isThenable(value)) {
		                value.then(_this._resolve, _this._reject);
		                return;
		            }
		            _this._state = state;
		            _this._value = value;
		            _this._executeHandlers();
		        };
		        // TODO: FIXME
		        /** JSDoc */
		        this._attachHandler = function (handler) {
		            _this._handlers = _this._handlers.concat(handler);
		            _this._executeHandlers();
		        };
		        /** JSDoc */
		        this._executeHandlers = function () {
		            if (_this._state === States.PENDING) {
		                return;
		            }
		            var cachedHandlers = _this._handlers.slice();
		            _this._handlers = [];
		            cachedHandlers.forEach(function (handler) {
		                if (handler.done) {
		                    return;
		                }
		                if (_this._state === States.RESOLVED) {
		                    if (handler.onfulfilled) {
		                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
		                        handler.onfulfilled(_this._value);
		                    }
		                }
		                if (_this._state === States.REJECTED) {
		                    if (handler.onrejected) {
		                        handler.onrejected(_this._value);
		                    }
		                }
		                handler.done = true;
		            });
		        };
		        try {
		            executor(this._resolve, this._reject);
		        }
		        catch (e) {
		            this._reject(e);
		        }
		    }
		    /** JSDoc */
		    SyncPromise.resolve = function (value) {
		        return new SyncPromise(function (resolve) {
		            resolve(value);
		        });
		    };
		    /** JSDoc */
		    SyncPromise.reject = function (reason) {
		        return new SyncPromise(function (_, reject) {
		            reject(reason);
		        });
		    };
		    /** JSDoc */
		    SyncPromise.all = function (collection) {
		        return new SyncPromise(function (resolve, reject) {
		            if (!Array.isArray(collection)) {
		                reject(new TypeError("Promise.all requires an array as input."));
		                return;
		            }
		            if (collection.length === 0) {
		                resolve([]);
		                return;
		            }
		            var counter = collection.length;
		            var resolvedCollection = [];
		            collection.forEach(function (item, index) {
		                SyncPromise.resolve(item)
		                    .then(function (value) {
		                    resolvedCollection[index] = value;
		                    counter -= 1;
		                    if (counter !== 0) {
		                        return;
		                    }
		                    resolve(resolvedCollection);
		                })
		                    .then(null, reject);
		            });
		        });
		    };
		    /** JSDoc */
		    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
		        var _this = this;
		        return new SyncPromise(function (resolve, reject) {
		            _this._attachHandler({
		                done: false,
		                onfulfilled: function (result) {
		                    if (!onfulfilled) {
		                        // TODO: ¯\_(ツ)_/¯
		                        // TODO: FIXME
		                        resolve(result);
		                        return;
		                    }
		                    try {
		                        resolve(onfulfilled(result));
		                        return;
		                    }
		                    catch (e) {
		                        reject(e);
		                        return;
		                    }
		                },
		                onrejected: function (reason) {
		                    if (!onrejected) {
		                        reject(reason);
		                        return;
		                    }
		                    try {
		                        resolve(onrejected(reason));
		                        return;
		                    }
		                    catch (e) {
		                        reject(e);
		                        return;
		                    }
		                },
		            });
		        });
		    };
		    /** JSDoc */
		    SyncPromise.prototype.catch = function (onrejected) {
		        return this.then(function (val) { return val; }, onrejected);
		    };
		    /** JSDoc */
		    SyncPromise.prototype.finally = function (onfinally) {
		        var _this = this;
		        return new SyncPromise(function (resolve, reject) {
		            var val;
		            var isRejected;
		            return _this.then(function (value) {
		                isRejected = false;
		                val = value;
		                if (onfinally) {
		                    onfinally();
		                }
		            }, function (reason) {
		                isRejected = true;
		                val = reason;
		                if (onfinally) {
		                    onfinally();
		                }
		            }).then(function () {
		                if (isRejected) {
		                    reject(val);
		                    return;
		                }
		                resolve(val);
		            });
		        });
		    };
		    /** JSDoc */
		    SyncPromise.prototype.toString = function () {
		        return '[object SyncPromise]';
		    };
		    return SyncPromise;
		}());
		syncpromise.SyncPromise = SyncPromise;
		
		return syncpromise;
	}

	var hasRequiredPromisebuffer;

	function requirePromisebuffer () {
		if (hasRequiredPromisebuffer) return promisebuffer;
		hasRequiredPromisebuffer = 1;
		Object.defineProperty(promisebuffer, "__esModule", { value: true });
		var error_1 = requireError();
		var syncpromise_1 = requireSyncpromise();
		/** A simple queue that holds promises. */
		var PromiseBuffer = /** @class */ (function () {
		    function PromiseBuffer(_limit) {
		        this._limit = _limit;
		        /** Internal set of queued Promises */
		        this._buffer = [];
		    }
		    /**
		     * Says if the buffer is ready to take more requests
		     */
		    PromiseBuffer.prototype.isReady = function () {
		        return this._limit === undefined || this.length() < this._limit;
		    };
		    /**
		     * Add a promise to the queue.
		     *
		     * @param task Can be any PromiseLike<T>
		     * @returns The original promise.
		     */
		    PromiseBuffer.prototype.add = function (task) {
		        var _this = this;
		        if (!this.isReady()) {
		            return syncpromise_1.SyncPromise.reject(new error_1.SentryError('Not adding Promise due to buffer limit reached.'));
		        }
		        if (this._buffer.indexOf(task) === -1) {
		            this._buffer.push(task);
		        }
		        task
		            .then(function () { return _this.remove(task); })
		            .then(null, function () {
		            return _this.remove(task).then(null, function () {
		                // We have to add this catch here otherwise we have an unhandledPromiseRejection
		                // because it's a new Promise chain.
		            });
		        });
		        return task;
		    };
		    /**
		     * Remove a promise to the queue.
		     *
		     * @param task Can be any PromiseLike<T>
		     * @returns Removed promise.
		     */
		    PromiseBuffer.prototype.remove = function (task) {
		        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
		        return removedTask;
		    };
		    /**
		     * This function returns the number of unresolved promises in the queue.
		     */
		    PromiseBuffer.prototype.length = function () {
		        return this._buffer.length;
		    };
		    /**
		     * This will drain the whole queue, returns true if queue is empty or drained.
		     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
		     *
		     * @param timeout Number in ms to wait until it resolves with false.
		     */
		    PromiseBuffer.prototype.drain = function (timeout) {
		        var _this = this;
		        return new syncpromise_1.SyncPromise(function (resolve) {
		            var capturedSetTimeout = setTimeout(function () {
		                if (timeout && timeout > 0) {
		                    resolve(false);
		                }
		            }, timeout);
		            syncpromise_1.SyncPromise.all(_this._buffer)
		                .then(function () {
		                clearTimeout(capturedSetTimeout);
		                resolve(true);
		            })
		                .then(null, function () {
		                resolve(true);
		            });
		        });
		    };
		    return PromiseBuffer;
		}());
		promisebuffer.PromiseBuffer = PromiseBuffer;
		
		return promisebuffer;
	}

	var time = {exports: {}};

	var hasRequiredTime;

	function requireTime () {
		if (hasRequiredTime) return time.exports;
		hasRequiredTime = 1;
		(function (module, exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			var misc_1 = requireMisc();
			var node_1 = requireNode();
			/**
			 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
			 *
			 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
			 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
			 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
			 */
			var dateTimestampSource = {
			    nowSeconds: function () { return Date.now() / 1000; },
			};
			/**
			 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
			 * support the API.
			 *
			 * Wrapping the native API works around differences in behavior from different browsers.
			 */
			function getBrowserPerformance() {
			    var performance = misc_1.getGlobalObject().performance;
			    if (!performance || !performance.now) {
			        return undefined;
			    }
			    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
			    //
			    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
			    // performance.now() gives a date arbitrarily in the past.
			    //
			    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
			    // undefined.
			    //
			    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
			    // interact with data coming out of performance entries.
			    //
			    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
			    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
			    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
			    // observed skews that can be as long as days, weeks or months.
			    //
			    // See https://github.com/getsentry/sentry-javascript/issues/2590.
			    //
			    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
			    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
			    // transactions of long-lived web pages.
			    var timeOrigin = Date.now() - performance.now();
			    return {
			        now: function () { return performance.now(); },
			        timeOrigin: timeOrigin,
			    };
			}
			/**
			 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
			 * implement the API.
			 */
			function getNodePerformance() {
			    try {
			        var perfHooks = node_1.dynamicRequire(module, 'perf_hooks');
			        return perfHooks.performance;
			    }
			    catch (_) {
			        return undefined;
			    }
			}
			/**
			 * The Performance API implementation for the current platform, if available.
			 */
			var platformPerformance = node_1.isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
			var timestampSource = platformPerformance === undefined
			    ? dateTimestampSource
			    : {
			        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
			    };
			/**
			 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
			 */
			exports.dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
			/**
			 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
			 * availability of the Performance API.
			 *
			 * See `usingPerformanceAPI` to test whether the Performance API is used.
			 *
			 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
			 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
			 * skew can grow to arbitrary amounts like days, weeks or months.
			 * See https://github.com/getsentry/sentry-javascript/issues/2590.
			 */
			exports.timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
			// Re-exported with an old name for backwards-compatibility.
			exports.timestampWithMs = exports.timestampInSeconds;
			/**
			 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
			 */
			exports.usingPerformanceAPI = platformPerformance !== undefined;
			/**
			 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
			 * performance API is available.
			 */
			exports.browserPerformanceTimeOrigin = (function () {
			    var performance = misc_1.getGlobalObject().performance;
			    if (!performance) {
			        return undefined;
			    }
			    if (performance.timeOrigin) {
			        return performance.timeOrigin;
			    }
			    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
			    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
			    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
			    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
			    // Date API.
			    // eslint-disable-next-line deprecation/deprecation
			    return (performance.timing && performance.timing.navigationStart) || Date.now();
			})();
			
	} (time, time.exports));
		return time.exports;
	}

	var hasRequiredDist$3;

	function requireDist$3 () {
		if (hasRequiredDist$3) return dist;
		hasRequiredDist$3 = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			var tslib_1 = require$$0$1;
			tslib_1.__exportStar(requireAsync(), exports);
			tslib_1.__exportStar(requireBrowser(), exports);
			tslib_1.__exportStar(requireDsn(), exports);
			tslib_1.__exportStar(requireError(), exports);
			tslib_1.__exportStar(requireInstrument(), exports);
			tslib_1.__exportStar(requireIs(), exports);
			tslib_1.__exportStar(requireLogger(), exports);
			tslib_1.__exportStar(requireMemo(), exports);
			tslib_1.__exportStar(requireMisc(), exports);
			tslib_1.__exportStar(requireNode(), exports);
			tslib_1.__exportStar(requireObject(), exports);
			tslib_1.__exportStar(requirePath(), exports);
			tslib_1.__exportStar(requirePromisebuffer(), exports);
			tslib_1.__exportStar(requireStacktrace(), exports);
			tslib_1.__exportStar(requireString(), exports);
			tslib_1.__exportStar(requireSupports(), exports);
			tslib_1.__exportStar(requireSyncpromise(), exports);
			tslib_1.__exportStar(requireTime(), exports);
			
	} (dist));
		return dist;
	}

	var hasRequiredScope;

	function requireScope () {
		if (hasRequiredScope) return scope;
		hasRequiredScope = 1;
		Object.defineProperty(scope, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var utils_1 = requireDist$3();
		/**
		 * Holds additional event information. {@link Scope.applyToEvent} will be
		 * called by the client before an event will be sent.
		 */
		var Scope = /** @class */ (function () {
		    function Scope() {
		        /** Flag if notifiying is happening. */
		        this._notifyingListeners = false;
		        /** Callback for client to receive scope changes. */
		        this._scopeListeners = [];
		        /** Callback list that will be called after {@link applyToEvent}. */
		        this._eventProcessors = [];
		        /** Array of breadcrumbs. */
		        this._breadcrumbs = [];
		        /** User */
		        this._user = {};
		        /** Tags */
		        this._tags = {};
		        /** Extra */
		        this._extra = {};
		        /** Contexts */
		        this._contexts = {};
		    }
		    /**
		     * Inherit values from the parent scope.
		     * @param scope to clone.
		     */
		    Scope.clone = function (scope) {
		        var newScope = new Scope();
		        if (scope) {
		            newScope._breadcrumbs = tslib_1.__spread(scope._breadcrumbs);
		            newScope._tags = tslib_1.__assign({}, scope._tags);
		            newScope._extra = tslib_1.__assign({}, scope._extra);
		            newScope._contexts = tslib_1.__assign({}, scope._contexts);
		            newScope._user = scope._user;
		            newScope._level = scope._level;
		            newScope._span = scope._span;
		            newScope._session = scope._session;
		            newScope._transactionName = scope._transactionName;
		            newScope._fingerprint = scope._fingerprint;
		            newScope._eventProcessors = tslib_1.__spread(scope._eventProcessors);
		        }
		        return newScope;
		    };
		    /**
		     * Add internal on change listener. Used for sub SDKs that need to store the scope.
		     * @hidden
		     */
		    Scope.prototype.addScopeListener = function (callback) {
		        this._scopeListeners.push(callback);
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.addEventProcessor = function (callback) {
		        this._eventProcessors.push(callback);
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setUser = function (user) {
		        this._user = user || {};
		        if (this._session) {
		            this._session.update({ user: user });
		        }
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.getUser = function () {
		        return this._user;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setTags = function (tags) {
		        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), tags);
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setTag = function (key, value) {
		        var _a;
		        this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setExtras = function (extras) {
		        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), extras);
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setExtra = function (key, extra) {
		        var _a;
		        this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setFingerprint = function (fingerprint) {
		        this._fingerprint = fingerprint;
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setLevel = function (level) {
		        this._level = level;
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setTransactionName = function (name) {
		        this._transactionName = name;
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * Can be removed in major version.
		     * @deprecated in favor of {@link this.setTransactionName}
		     */
		    Scope.prototype.setTransaction = function (name) {
		        return this.setTransactionName(name);
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setContext = function (key, context) {
		        var _a;
		        if (context === null) {
		            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
		            delete this._contexts[key];
		        }
		        else {
		            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
		        }
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setSpan = function (span) {
		        this._span = span;
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.getSpan = function () {
		        return this._span;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.getTransaction = function () {
		        var _a, _b, _c, _d;
		        // often, this span will be a transaction, but it's not guaranteed to be
		        var span = this.getSpan();
		        // try it the new way first
		        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) {
		            return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
		        }
		        // fallback to the old way (known bug: this only finds transactions with sampled = true)
		        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) {
		            return span.spanRecorder.spans[0];
		        }
		        // neither way found a transaction
		        return undefined;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.setSession = function (session) {
		        if (!session) {
		            delete this._session;
		        }
		        else {
		            this._session = session;
		        }
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.getSession = function () {
		        return this._session;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.update = function (captureContext) {
		        if (!captureContext) {
		            return this;
		        }
		        if (typeof captureContext === 'function') {
		            var updatedScope = captureContext(this);
		            return updatedScope instanceof Scope ? updatedScope : this;
		        }
		        if (captureContext instanceof Scope) {
		            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext._tags);
		            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext._extra);
		            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext._contexts);
		            if (captureContext._user && Object.keys(captureContext._user).length) {
		                this._user = captureContext._user;
		            }
		            if (captureContext._level) {
		                this._level = captureContext._level;
		            }
		            if (captureContext._fingerprint) {
		                this._fingerprint = captureContext._fingerprint;
		            }
		        }
		        else if (utils_1.isPlainObject(captureContext)) {
		            // eslint-disable-next-line no-param-reassign
		            captureContext = captureContext;
		            this._tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), captureContext.tags);
		            this._extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), captureContext.extra);
		            this._contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), captureContext.contexts);
		            if (captureContext.user) {
		                this._user = captureContext.user;
		            }
		            if (captureContext.level) {
		                this._level = captureContext.level;
		            }
		            if (captureContext.fingerprint) {
		                this._fingerprint = captureContext.fingerprint;
		            }
		        }
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.clear = function () {
		        this._breadcrumbs = [];
		        this._tags = {};
		        this._extra = {};
		        this._user = {};
		        this._contexts = {};
		        this._level = undefined;
		        this._transactionName = undefined;
		        this._fingerprint = undefined;
		        this._span = undefined;
		        this._session = undefined;
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
		        var mergedBreadcrumb = tslib_1.__assign({ timestamp: utils_1.dateTimestampInSeconds() }, breadcrumb);
		        this._breadcrumbs =
		            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
		                ? tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
		                : tslib_1.__spread(this._breadcrumbs, [mergedBreadcrumb]);
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * @inheritDoc
		     */
		    Scope.prototype.clearBreadcrumbs = function () {
		        this._breadcrumbs = [];
		        this._notifyScopeListeners();
		        return this;
		    };
		    /**
		     * Applies the current context and fingerprint to the event.
		     * Note that breadcrumbs will be added by the client.
		     * Also if the event has already breadcrumbs on it, we do not merge them.
		     * @param event Event
		     * @param hint May contain additional informartion about the original exception.
		     * @hidden
		     */
		    Scope.prototype.applyToEvent = function (event, hint) {
		        var _a;
		        if (this._extra && Object.keys(this._extra).length) {
		            event.extra = tslib_1.__assign(tslib_1.__assign({}, this._extra), event.extra);
		        }
		        if (this._tags && Object.keys(this._tags).length) {
		            event.tags = tslib_1.__assign(tslib_1.__assign({}, this._tags), event.tags);
		        }
		        if (this._user && Object.keys(this._user).length) {
		            event.user = tslib_1.__assign(tslib_1.__assign({}, this._user), event.user);
		        }
		        if (this._contexts && Object.keys(this._contexts).length) {
		            event.contexts = tslib_1.__assign(tslib_1.__assign({}, this._contexts), event.contexts);
		        }
		        if (this._level) {
		            event.level = this._level;
		        }
		        if (this._transactionName) {
		            event.transaction = this._transactionName;
		        }
		        // We want to set the trace context for normal events only if there isn't already
		        // a trace context on the event. There is a product feature in place where we link
		        // errors with transaction and it relys on that.
		        if (this._span) {
		            event.contexts = tslib_1.__assign({ trace: this._span.getTraceContext() }, event.contexts);
		            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
		            if (transactionName) {
		                event.tags = tslib_1.__assign({ transaction: transactionName }, event.tags);
		            }
		        }
		        this._applyFingerprint(event);
		        event.breadcrumbs = tslib_1.__spread((event.breadcrumbs || []), this._breadcrumbs);
		        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
		        return this._notifyEventProcessors(tslib_1.__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
		    };
		    /**
		     * This will be called after {@link applyToEvent} is finished.
		     */
		    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
		        var _this = this;
		        if (index === void 0) { index = 0; }
		        return new utils_1.SyncPromise(function (resolve, reject) {
		            var processor = processors[index];
		            if (event === null || typeof processor !== 'function') {
		                resolve(event);
		            }
		            else {
		                var result = processor(tslib_1.__assign({}, event), hint);
		                if (utils_1.isThenable(result)) {
		                    result
		                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
		                        .then(null, reject);
		                }
		                else {
		                    _this._notifyEventProcessors(processors, result, hint, index + 1)
		                        .then(resolve)
		                        .then(null, reject);
		                }
		            }
		        });
		    };
		    /**
		     * This will be called on every set call.
		     */
		    Scope.prototype._notifyScopeListeners = function () {
		        var _this = this;
		        // We need this check for this._notifyingListeners to be able to work on scope during updates
		        // If this check is not here we'll produce endless recursion when something is done with the scope
		        // during the callback.
		        if (!this._notifyingListeners) {
		            this._notifyingListeners = true;
		            this._scopeListeners.forEach(function (callback) {
		                callback(_this);
		            });
		            this._notifyingListeners = false;
		        }
		    };
		    /**
		     * Applies fingerprint from the scope to the event if there's one,
		     * uses message if there's one instead or get rid of empty fingerprint
		     */
		    Scope.prototype._applyFingerprint = function (event) {
		        // Make sure it's an array first and we actually have something in place
		        event.fingerprint = event.fingerprint
		            ? Array.isArray(event.fingerprint)
		                ? event.fingerprint
		                : [event.fingerprint]
		            : [];
		        // If we have something on the scope, then merge it with event
		        if (this._fingerprint) {
		            event.fingerprint = event.fingerprint.concat(this._fingerprint);
		        }
		        // If we have no data at all, remove empty array default
		        if (event.fingerprint && !event.fingerprint.length) {
		            delete event.fingerprint;
		        }
		    };
		    return Scope;
		}());
		scope.Scope = Scope;
		/**
		 * Retruns the global event processors.
		 */
		function getGlobalEventProcessors() {
		    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
		    var global = utils_1.getGlobalObject();
		    global.__SENTRY__ = global.__SENTRY__ || {};
		    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
		    return global.__SENTRY__.globalEventProcessors;
		    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
		}
		/**
		 * Add a EventProcessor to be kept globally.
		 * @param callback EventProcessor to add
		 */
		function addGlobalEventProcessor(callback) {
		    getGlobalEventProcessors().push(callback);
		}
		scope.addGlobalEventProcessor = addGlobalEventProcessor;
		
		return scope;
	}

	var session = {};

	var hasRequiredSession;

	function requireSession () {
		if (hasRequiredSession) return session;
		hasRequiredSession = 1;
		Object.defineProperty(session, "__esModule", { value: true });
		var types_1 = requireDist$4();
		var utils_1 = requireDist$3();
		/**
		 * @inheritdoc
		 */
		var Session = /** @class */ (function () {
		    function Session(context) {
		        this.errors = 0;
		        this.sid = utils_1.uuid4();
		        this.timestamp = Date.now();
		        this.started = Date.now();
		        this.duration = 0;
		        this.status = types_1.SessionStatus.Ok;
		        if (context) {
		            this.update(context);
		        }
		    }
		    /** JSDoc */
		    // eslint-disable-next-line complexity
		    Session.prototype.update = function (context) {
		        if (context === void 0) { context = {}; }
		        if (context.user) {
		            if (context.user.ip_address) {
		                this.ipAddress = context.user.ip_address;
		            }
		            if (!context.did) {
		                this.did = context.user.id || context.user.email || context.user.username;
		            }
		        }
		        this.timestamp = context.timestamp || Date.now();
		        if (context.sid) {
		            // Good enough uuid validation. — Kamil
		            this.sid = context.sid.length === 32 ? context.sid : utils_1.uuid4();
		        }
		        if (context.did) {
		            this.did = "" + context.did;
		        }
		        if (typeof context.started === 'number') {
		            this.started = context.started;
		        }
		        if (typeof context.duration === 'number') {
		            this.duration = context.duration;
		        }
		        else {
		            this.duration = this.timestamp - this.started;
		        }
		        if (context.release) {
		            this.release = context.release;
		        }
		        if (context.environment) {
		            this.environment = context.environment;
		        }
		        if (context.ipAddress) {
		            this.ipAddress = context.ipAddress;
		        }
		        if (context.userAgent) {
		            this.userAgent = context.userAgent;
		        }
		        if (typeof context.errors === 'number') {
		            this.errors = context.errors;
		        }
		        if (context.status) {
		            this.status = context.status;
		        }
		    };
		    /** JSDoc */
		    Session.prototype.close = function (status) {
		        if (status) {
		            this.update({ status: status });
		        }
		        else if (this.status === types_1.SessionStatus.Ok) {
		            this.update({ status: types_1.SessionStatus.Exited });
		        }
		        else {
		            this.update();
		        }
		    };
		    /** JSDoc */
		    Session.prototype.toJSON = function () {
		        return utils_1.dropUndefinedKeys({
		            sid: "" + this.sid,
		            init: true,
		            started: new Date(this.started).toISOString(),
		            timestamp: new Date(this.timestamp).toISOString(),
		            status: this.status,
		            errors: this.errors,
		            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
		            duration: this.duration,
		            attrs: utils_1.dropUndefinedKeys({
		                release: this.release,
		                environment: this.environment,
		                ip_address: this.ipAddress,
		                user_agent: this.userAgent,
		            }),
		        });
		    };
		    return Session;
		}());
		session.Session = Session;
		
		return session;
	}

	var hub = {};

	var hasRequiredHub;

	function requireHub () {
		if (hasRequiredHub) return hub;
		hasRequiredHub = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			var tslib_1 = require$$0$1;
			var utils_1 = requireDist$3();
			var scope_1 = requireScope();
			var session_1 = requireSession();
			/**
			 * API compatibility version of this hub.
			 *
			 * WARNING: This number should only be increased when the global interface
			 * changes and new methods are introduced.
			 *
			 * @hidden
			 */
			exports.API_VERSION = 3;
			/**
			 * Default maximum number of breadcrumbs added to an event. Can be overwritten
			 * with {@link Options.maxBreadcrumbs}.
			 */
			var DEFAULT_BREADCRUMBS = 100;
			/**
			 * Absolute maximum number of breadcrumbs added to an event. The
			 * `maxBreadcrumbs` option cannot be higher than this value.
			 */
			var MAX_BREADCRUMBS = 100;
			/**
			 * @inheritDoc
			 */
			var Hub = /** @class */ (function () {
			    /**
			     * Creates a new instance of the hub, will push one {@link Layer} into the
			     * internal stack on creation.
			     *
			     * @param client bound to the hub.
			     * @param scope bound to the hub.
			     * @param version number, higher number means higher priority.
			     */
			    function Hub(client, scope, _version) {
			        if (scope === void 0) { scope = new scope_1.Scope(); }
			        if (_version === void 0) { _version = exports.API_VERSION; }
			        this._version = _version;
			        /** Is a {@link Layer}[] containing the client and scope */
			        this._stack = [{}];
			        this.getStackTop().scope = scope;
			        this.bindClient(client);
			    }
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.isOlderThan = function (version) {
			        return this._version < version;
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.bindClient = function (client) {
			        var top = this.getStackTop();
			        top.client = client;
			        if (client && client.setupIntegrations) {
			            client.setupIntegrations();
			        }
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.pushScope = function () {
			        // We want to clone the content of prev scope
			        var scope = scope_1.Scope.clone(this.getScope());
			        this.getStack().push({
			            client: this.getClient(),
			            scope: scope,
			        });
			        return scope;
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.popScope = function () {
			        if (this.getStack().length <= 1)
			            return false;
			        return !!this.getStack().pop();
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.withScope = function (callback) {
			        var scope = this.pushScope();
			        try {
			            callback(scope);
			        }
			        finally {
			            this.popScope();
			        }
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.getClient = function () {
			        return this.getStackTop().client;
			    };
			    /** Returns the scope of the top stack. */
			    Hub.prototype.getScope = function () {
			        return this.getStackTop().scope;
			    };
			    /** Returns the scope stack for domains or the process. */
			    Hub.prototype.getStack = function () {
			        return this._stack;
			    };
			    /** Returns the topmost scope layer in the order domain > local > process. */
			    Hub.prototype.getStackTop = function () {
			        return this._stack[this._stack.length - 1];
			    };
			    /**
			     * @inheritDoc
			     */
			    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
			    Hub.prototype.captureException = function (exception, hint) {
			        var eventId = (this._lastEventId = utils_1.uuid4());
			        var finalHint = hint;
			        // If there's no explicit hint provided, mimick the same thing that would happen
			        // in the minimal itself to create a consistent behavior.
			        // We don't do this in the client, as it's the lowest level API, and doing this,
			        // would prevent user from having full control over direct calls.
			        if (!hint) {
			            var syntheticException = void 0;
			            try {
			                throw new Error('Sentry syntheticException');
			            }
			            catch (exception) {
			                syntheticException = exception;
			            }
			            finalHint = {
			                originalException: exception,
			                syntheticException: syntheticException,
			            };
			        }
			        this._invokeClient('captureException', exception, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
			        return eventId;
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.captureMessage = function (message, level, hint) {
			        var eventId = (this._lastEventId = utils_1.uuid4());
			        var finalHint = hint;
			        // If there's no explicit hint provided, mimick the same thing that would happen
			        // in the minimal itself to create a consistent behavior.
			        // We don't do this in the client, as it's the lowest level API, and doing this,
			        // would prevent user from having full control over direct calls.
			        if (!hint) {
			            var syntheticException = void 0;
			            try {
			                throw new Error(message);
			            }
			            catch (exception) {
			                syntheticException = exception;
			            }
			            finalHint = {
			                originalException: message,
			                syntheticException: syntheticException,
			            };
			        }
			        this._invokeClient('captureMessage', message, level, tslib_1.__assign(tslib_1.__assign({}, finalHint), { event_id: eventId }));
			        return eventId;
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.captureEvent = function (event, hint) {
			        var eventId = (this._lastEventId = utils_1.uuid4());
			        this._invokeClient('captureEvent', event, tslib_1.__assign(tslib_1.__assign({}, hint), { event_id: eventId }));
			        return eventId;
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.lastEventId = function () {
			        return this._lastEventId;
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
			        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
			        if (!scope || !client)
			            return;
			        // eslint-disable-next-line @typescript-eslint/unbound-method
			        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
			        if (maxBreadcrumbs <= 0)
			            return;
			        var timestamp = utils_1.dateTimestampInSeconds();
			        var mergedBreadcrumb = tslib_1.__assign({ timestamp: timestamp }, breadcrumb);
			        var finalBreadcrumb = beforeBreadcrumb
			            ? utils_1.consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
			            : mergedBreadcrumb;
			        if (finalBreadcrumb === null)
			            return;
			        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.setUser = function (user) {
			        var scope = this.getScope();
			        if (scope)
			            scope.setUser(user);
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.setTags = function (tags) {
			        var scope = this.getScope();
			        if (scope)
			            scope.setTags(tags);
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.setExtras = function (extras) {
			        var scope = this.getScope();
			        if (scope)
			            scope.setExtras(extras);
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.setTag = function (key, value) {
			        var scope = this.getScope();
			        if (scope)
			            scope.setTag(key, value);
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.setExtra = function (key, extra) {
			        var scope = this.getScope();
			        if (scope)
			            scope.setExtra(key, extra);
			    };
			    /**
			     * @inheritDoc
			     */
			    // eslint-disable-next-line @typescript-eslint/no-explicit-any
			    Hub.prototype.setContext = function (name, context) {
			        var scope = this.getScope();
			        if (scope)
			            scope.setContext(name, context);
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.configureScope = function (callback) {
			        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
			        if (scope && client) {
			            callback(scope);
			        }
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.run = function (callback) {
			        var oldHub = makeMain(this);
			        try {
			            callback(this);
			        }
			        finally {
			            makeMain(oldHub);
			        }
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.getIntegration = function (integration) {
			        var client = this.getClient();
			        if (!client)
			            return null;
			        try {
			            return client.getIntegration(integration);
			        }
			        catch (_oO) {
			            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
			            return null;
			        }
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.startSpan = function (context) {
			        return this._callExtensionMethod('startSpan', context);
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.startTransaction = function (context, customSamplingContext) {
			        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.traceHeaders = function () {
			        return this._callExtensionMethod('traceHeaders');
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.startSession = function (context) {
			        // End existing session if there's one
			        this.endSession();
			        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
			        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
			        var session = new session_1.Session(tslib_1.__assign(tslib_1.__assign({ release: release,
			            environment: environment }, (scope && { user: scope.getUser() })), context));
			        if (scope) {
			            scope.setSession(session);
			        }
			        return session;
			    };
			    /**
			     * @inheritDoc
			     */
			    Hub.prototype.endSession = function () {
			        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
			        if (!scope)
			            return;
			        var session = scope.getSession && scope.getSession();
			        if (session) {
			            session.close();
			            if (client && client.captureSession) {
			                client.captureSession(session);
			            }
			            scope.setSession();
			        }
			    };
			    /**
			     * Internal helper function to call a method on the top client if it exists.
			     *
			     * @param method The method to call on the client.
			     * @param args Arguments to pass to the client function.
			     */
			    // eslint-disable-next-line @typescript-eslint/no-explicit-any
			    Hub.prototype._invokeClient = function (method) {
			        var _a;
			        var args = [];
			        for (var _i = 1; _i < arguments.length; _i++) {
			            args[_i - 1] = arguments[_i];
			        }
			        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
			        if (client && client[method]) {
			            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
			            (_a = client)[method].apply(_a, tslib_1.__spread(args, [scope]));
			        }
			    };
			    /**
			     * Calls global extension method and binding current instance to the function call
			     */
			    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
			    // eslint-disable-next-line @typescript-eslint/no-explicit-any
			    Hub.prototype._callExtensionMethod = function (method) {
			        var args = [];
			        for (var _i = 1; _i < arguments.length; _i++) {
			            args[_i - 1] = arguments[_i];
			        }
			        var carrier = getMainCarrier();
			        var sentry = carrier.__SENTRY__;
			        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
			            return sentry.extensions[method].apply(this, args);
			        }
			        utils_1.logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
			    };
			    return Hub;
			}());
			exports.Hub = Hub;
			/** Returns the global shim registry. */
			function getMainCarrier() {
			    var carrier = utils_1.getGlobalObject();
			    carrier.__SENTRY__ = carrier.__SENTRY__ || {
			        extensions: {},
			        hub: undefined,
			    };
			    return carrier;
			}
			exports.getMainCarrier = getMainCarrier;
			/**
			 * Replaces the current main hub with the passed one on the global object
			 *
			 * @returns The old replaced hub
			 */
			function makeMain(hub) {
			    var registry = getMainCarrier();
			    var oldHub = getHubFromCarrier(registry);
			    setHubOnCarrier(registry, hub);
			    return oldHub;
			}
			exports.makeMain = makeMain;
			/**
			 * Returns the default hub instance.
			 *
			 * If a hub is already registered in the global carrier but this module
			 * contains a more recent version, it replaces the registered version.
			 * Otherwise, the currently registered hub will be returned.
			 */
			function getCurrentHub() {
			    // Get main carrier (global for every environment)
			    var registry = getMainCarrier();
			    // If there's no hub, or its an old API, assign a new one
			    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(exports.API_VERSION)) {
			        setHubOnCarrier(registry, new Hub());
			    }
			    // Prefer domains over global if they are there (applicable only to Node environment)
			    if (utils_1.isNodeEnv()) {
			        return getHubFromActiveDomain(registry);
			    }
			    // Return hub that lives on a global object
			    return getHubFromCarrier(registry);
			}
			exports.getCurrentHub = getCurrentHub;
			/**
			 * Returns the active domain, if one exists
			 *
			 * @returns The domain, or undefined if there is no active domain
			 */
			function getActiveDomain() {
			    var sentry = getMainCarrier().__SENTRY__;
			    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
			}
			exports.getActiveDomain = getActiveDomain;
			/**
			 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
			 * @returns discovered hub
			 */
			function getHubFromActiveDomain(registry) {
			    try {
			        var activeDomain = getActiveDomain();
			        // If there's no active domain, just return global hub
			        if (!activeDomain) {
			            return getHubFromCarrier(registry);
			        }
			        // If there's no hub on current domain, or it's an old API, assign a new one
			        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(exports.API_VERSION)) {
			            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
			            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, scope_1.Scope.clone(registryHubTopStack.scope)));
			        }
			        // Return hub that lives on a domain
			        return getHubFromCarrier(activeDomain);
			    }
			    catch (_Oo) {
			        // Return hub that lives on a global object
			        return getHubFromCarrier(registry);
			    }
			}
			/**
			 * This will tell whether a carrier has a hub on it or not
			 * @param carrier object
			 */
			function hasHubOnCarrier(carrier) {
			    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
			}
			/**
			 * This will create a new {@link Hub} and add to the passed object on
			 * __SENTRY__.hub.
			 * @param carrier object
			 * @hidden
			 */
			function getHubFromCarrier(carrier) {
			    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
			        return carrier.__SENTRY__.hub;
			    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
			    carrier.__SENTRY__.hub = new Hub();
			    return carrier.__SENTRY__.hub;
			}
			exports.getHubFromCarrier = getHubFromCarrier;
			/**
			 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
			 * @param carrier object
			 * @param hub Hub
			 */
			function setHubOnCarrier(carrier, hub) {
			    if (!carrier)
			        return false;
			    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
			    carrier.__SENTRY__.hub = hub;
			    return true;
			}
			exports.setHubOnCarrier = setHubOnCarrier;
			
	} (hub));
		return hub;
	}

	var hasRequiredDist$2;

	function requireDist$2 () {
		if (hasRequiredDist$2) return dist$1;
		hasRequiredDist$2 = 1;
		Object.defineProperty(dist$1, "__esModule", { value: true });
		var scope_1 = requireScope();
		dist$1.addGlobalEventProcessor = scope_1.addGlobalEventProcessor;
		dist$1.Scope = scope_1.Scope;
		var session_1 = requireSession();
		dist$1.Session = session_1.Session;
		var hub_1 = requireHub();
		dist$1.getActiveDomain = hub_1.getActiveDomain;
		dist$1.getCurrentHub = hub_1.getCurrentHub;
		dist$1.getHubFromCarrier = hub_1.getHubFromCarrier;
		dist$1.getMainCarrier = hub_1.getMainCarrier;
		dist$1.Hub = hub_1.Hub;
		dist$1.makeMain = hub_1.makeMain;
		dist$1.setHubOnCarrier = hub_1.setHubOnCarrier;
		
		return dist$1;
	}

	var hasRequiredDist$1;

	function requireDist$1 () {
		if (hasRequiredDist$1) return dist$2;
		hasRequiredDist$1 = 1;
		Object.defineProperty(dist$2, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var hub_1 = requireDist$2();
		/**
		 * This calls a function on the current hub.
		 * @param method function to call on hub.
		 * @param args to pass to function.
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		function callOnHub(method) {
		    var args = [];
		    for (var _i = 1; _i < arguments.length; _i++) {
		        args[_i - 1] = arguments[_i];
		    }
		    var hub = hub_1.getCurrentHub();
		    if (hub && hub[method]) {
		        // eslint-disable-next-line @typescript-eslint/no-explicit-any
		        return hub[method].apply(hub, tslib_1.__spread(args));
		    }
		    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
		}
		/**
		 * Captures an exception event and sends it to Sentry.
		 *
		 * @param exception An exception-like object.
		 * @returns The generated eventId.
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
		function captureException(exception, captureContext) {
		    var syntheticException;
		    try {
		        throw new Error('Sentry syntheticException');
		    }
		    catch (exception) {
		        syntheticException = exception;
		    }
		    return callOnHub('captureException', exception, {
		        captureContext: captureContext,
		        originalException: exception,
		        syntheticException: syntheticException,
		    });
		}
		dist$2.captureException = captureException;
		/**
		 * Captures a message event and sends it to Sentry.
		 *
		 * @param message The message to send to Sentry.
		 * @param level Define the level of the message.
		 * @returns The generated eventId.
		 */
		function captureMessage(message, captureContext) {
		    var syntheticException;
		    try {
		        throw new Error(message);
		    }
		    catch (exception) {
		        syntheticException = exception;
		    }
		    // This is necessary to provide explicit scopes upgrade, without changing the original
		    // arity of the `captureMessage(message, level)` method.
		    var level = typeof captureContext === 'string' ? captureContext : undefined;
		    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
		    return callOnHub('captureMessage', message, level, tslib_1.__assign({ originalException: message, syntheticException: syntheticException }, context));
		}
		dist$2.captureMessage = captureMessage;
		/**
		 * Captures a manually created event and sends it to Sentry.
		 *
		 * @param event The event to send to Sentry.
		 * @returns The generated eventId.
		 */
		function captureEvent(event) {
		    return callOnHub('captureEvent', event);
		}
		dist$2.captureEvent = captureEvent;
		/**
		 * Callback to set context information onto the scope.
		 * @param callback Callback function that receives Scope.
		 */
		function configureScope(callback) {
		    callOnHub('configureScope', callback);
		}
		dist$2.configureScope = configureScope;
		/**
		 * Records a new breadcrumb which will be attached to future events.
		 *
		 * Breadcrumbs will be added to subsequent events to provide more context on
		 * user's actions prior to an error or crash.
		 *
		 * @param breadcrumb The breadcrumb to record.
		 */
		function addBreadcrumb(breadcrumb) {
		    callOnHub('addBreadcrumb', breadcrumb);
		}
		dist$2.addBreadcrumb = addBreadcrumb;
		/**
		 * Sets context data with the given name.
		 * @param name of the context
		 * @param context Any kind of data. This data will be normalized.
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		function setContext(name, context) {
		    callOnHub('setContext', name, context);
		}
		dist$2.setContext = setContext;
		/**
		 * Set an object that will be merged sent as extra data with the event.
		 * @param extras Extras object to merge into current context.
		 */
		function setExtras(extras) {
		    callOnHub('setExtras', extras);
		}
		dist$2.setExtras = setExtras;
		/**
		 * Set an object that will be merged sent as tags data with the event.
		 * @param tags Tags context object to merge into current context.
		 */
		function setTags(tags) {
		    callOnHub('setTags', tags);
		}
		dist$2.setTags = setTags;
		/**
		 * Set key:value that will be sent as extra data with the event.
		 * @param key String of extra
		 * @param extra Any kind of data. This data will be normalized.
		 */
		function setExtra(key, extra) {
		    callOnHub('setExtra', key, extra);
		}
		dist$2.setExtra = setExtra;
		/**
		 * Set key:value that will be sent as tags data with the event.
		 *
		 * Can also be used to unset a tag, by passing `undefined`.
		 *
		 * @param key String key of tag
		 * @param value Value of tag
		 */
		function setTag(key, value) {
		    callOnHub('setTag', key, value);
		}
		dist$2.setTag = setTag;
		/**
		 * Updates user context information for future events.
		 *
		 * @param user User context object to be set in the current context. Pass `null` to unset the user.
		 */
		function setUser(user) {
		    callOnHub('setUser', user);
		}
		dist$2.setUser = setUser;
		/**
		 * Creates a new scope with and executes the given operation within.
		 * The scope is automatically removed once the operation
		 * finishes or throws.
		 *
		 * This is essentially a convenience function for:
		 *
		 *     pushScope();
		 *     callback();
		 *     popScope();
		 *
		 * @param callback that will be enclosed into push/popScope.
		 */
		function withScope(callback) {
		    callOnHub('withScope', callback);
		}
		dist$2.withScope = withScope;
		/**
		 * Calls a function on the latest client. Use this with caution, it's meant as
		 * in "internal" helper so we don't need to expose every possible function in
		 * the shim. It is not guaranteed that the client actually implements the
		 * function.
		 *
		 * @param method The method to call on the client/client.
		 * @param args Arguments to pass to the client/fontend.
		 * @hidden
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		function _callOnClient(method) {
		    var args = [];
		    for (var _i = 1; _i < arguments.length; _i++) {
		        args[_i - 1] = arguments[_i];
		    }
		    callOnHub.apply(void 0, tslib_1.__spread(['_invokeClient', method], args));
		}
		dist$2._callOnClient = _callOnClient;
		/**
		 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
		 *
		 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
		 * new child span within the transaction or any span, call the respective `.startChild()` method.
		 *
		 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
		 *
		 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
		 * finished child spans will be sent to Sentry.
		 *
		 * @param context Properties of the new `Transaction`.
		 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
		 * default values). See {@link Options.tracesSampler}.
		 *
		 * @returns The transaction which was just started
		 */
		function startTransaction(context, customSamplingContext) {
		    return callOnHub('startTransaction', tslib_1.__assign({}, context), customSamplingContext);
		}
		dist$2.startTransaction = startTransaction;
		
		return dist$2;
	}

	var api = {};

	var hasRequiredApi;

	function requireApi () {
		if (hasRequiredApi) return api;
		hasRequiredApi = 1;
		Object.defineProperty(api, "__esModule", { value: true });
		var utils_1 = requireDist$3();
		var SENTRY_API_VERSION = '7';
		/** Helper class to provide urls to different Sentry endpoints. */
		var API = /** @class */ (function () {
		    /** Create a new instance of API */
		    function API(dsn) {
		        this.dsn = dsn;
		        this._dsnObject = new utils_1.Dsn(dsn);
		    }
		    /** Returns the Dsn object. */
		    API.prototype.getDsn = function () {
		        return this._dsnObject;
		    };
		    /** Returns the prefix to construct Sentry ingestion API endpoints. */
		    API.prototype.getBaseApiEndpoint = function () {
		        var dsn = this._dsnObject;
		        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
		        var port = dsn.port ? ":" + dsn.port : '';
		        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
		    };
		    /** Returns the store endpoint URL. */
		    API.prototype.getStoreEndpoint = function () {
		        return this._getIngestEndpoint('store');
		    };
		    /**
		     * Returns the store endpoint URL with auth in the query string.
		     *
		     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
		     */
		    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
		        return this.getStoreEndpoint() + "?" + this._encodedAuth();
		    };
		    /**
		     * Returns the envelope endpoint URL with auth in the query string.
		     *
		     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
		     */
		    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
		        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
		    };
		    /** Returns only the path component for the store endpoint. */
		    API.prototype.getStoreEndpointPath = function () {
		        var dsn = this._dsnObject;
		        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
		    };
		    /**
		     * Returns an object that can be used in request headers.
		     * This is needed for node and the old /store endpoint in sentry
		     */
		    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
		        var dsn = this._dsnObject;
		        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
		        header.push("sentry_client=" + clientName + "/" + clientVersion);
		        header.push("sentry_key=" + dsn.user);
		        if (dsn.pass) {
		            header.push("sentry_secret=" + dsn.pass);
		        }
		        return {
		            'Content-Type': 'application/json',
		            'X-Sentry-Auth': header.join(', '),
		        };
		    };
		    /** Returns the url to the report dialog endpoint. */
		    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
		        if (dialogOptions === void 0) { dialogOptions = {}; }
		        var dsn = this._dsnObject;
		        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
		        var encodedOptions = [];
		        encodedOptions.push("dsn=" + dsn.toString());
		        for (var key in dialogOptions) {
		            if (key === 'dsn') {
		                continue;
		            }
		            if (key === 'user') {
		                if (!dialogOptions.user) {
		                    continue;
		                }
		                if (dialogOptions.user.name) {
		                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
		                }
		                if (dialogOptions.user.email) {
		                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
		                }
		            }
		            else {
		                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
		            }
		        }
		        if (encodedOptions.length) {
		            return endpoint + "?" + encodedOptions.join('&');
		        }
		        return endpoint;
		    };
		    /** Returns the envelope endpoint URL. */
		    API.prototype._getEnvelopeEndpoint = function () {
		        return this._getIngestEndpoint('envelope');
		    };
		    /** Returns the ingest API endpoint for target. */
		    API.prototype._getIngestEndpoint = function (target) {
		        var base = this.getBaseApiEndpoint();
		        var dsn = this._dsnObject;
		        return "" + base + dsn.projectId + "/" + target + "/";
		    };
		    /** Returns a URL-encoded string with auth config suitable for a query string. */
		    API.prototype._encodedAuth = function () {
		        var dsn = this._dsnObject;
		        var auth = {
		            // We send only the minimum set of required information. See
		            // https://github.com/getsentry/sentry-javascript/issues/2572.
		            sentry_key: dsn.user,
		            sentry_version: SENTRY_API_VERSION,
		        };
		        return utils_1.urlEncode(auth);
		    };
		    return API;
		}());
		api.API = API;
		
		return api;
	}

	var baseclient = {};

	var integration = {};

	var hasRequiredIntegration;

	function requireIntegration () {
		if (hasRequiredIntegration) return integration;
		hasRequiredIntegration = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			var tslib_1 = require$$0$1;
			var hub_1 = requireDist$2();
			var utils_1 = requireDist$3();
			exports.installedIntegrations = [];
			/** Gets integration to install */
			function getIntegrationsToSetup(options) {
			    var defaultIntegrations = (options.defaultIntegrations && tslib_1.__spread(options.defaultIntegrations)) || [];
			    var userIntegrations = options.integrations;
			    var integrations = [];
			    if (Array.isArray(userIntegrations)) {
			        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
			        var pickedIntegrationsNames_1 = [];
			        // Leave only unique default integrations, that were not overridden with provided user integrations
			        defaultIntegrations.forEach(function (defaultIntegration) {
			            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
			                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
			                integrations.push(defaultIntegration);
			                pickedIntegrationsNames_1.push(defaultIntegration.name);
			            }
			        });
			        // Don't add same user integration twice
			        userIntegrations.forEach(function (userIntegration) {
			            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
			                integrations.push(userIntegration);
			                pickedIntegrationsNames_1.push(userIntegration.name);
			            }
			        });
			    }
			    else if (typeof userIntegrations === 'function') {
			        integrations = userIntegrations(defaultIntegrations);
			        integrations = Array.isArray(integrations) ? integrations : [integrations];
			    }
			    else {
			        integrations = tslib_1.__spread(defaultIntegrations);
			    }
			    // Make sure that if present, `Debug` integration will always run last
			    var integrationsNames = integrations.map(function (i) { return i.name; });
			    var alwaysLastToRun = 'Debug';
			    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
			        integrations.push.apply(integrations, tslib_1.__spread(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
			    }
			    return integrations;
			}
			exports.getIntegrationsToSetup = getIntegrationsToSetup;
			/** Setup given integration */
			function setupIntegration(integration) {
			    if (exports.installedIntegrations.indexOf(integration.name) !== -1) {
			        return;
			    }
			    integration.setupOnce(hub_1.addGlobalEventProcessor, hub_1.getCurrentHub);
			    exports.installedIntegrations.push(integration.name);
			    utils_1.logger.log("Integration installed: " + integration.name);
			}
			exports.setupIntegration = setupIntegration;
			/**
			 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
			 * integrations are added unless they were already provided before.
			 * @param integrations array of integration instances
			 * @param withDefault should enable default integrations
			 */
			function setupIntegrations(options) {
			    var integrations = {};
			    getIntegrationsToSetup(options).forEach(function (integration) {
			        integrations[integration.name] = integration;
			        setupIntegration(integration);
			    });
			    return integrations;
			}
			exports.setupIntegrations = setupIntegrations;
			
	} (integration));
		return integration;
	}

	var hasRequiredBaseclient;

	function requireBaseclient () {
		if (hasRequiredBaseclient) return baseclient;
		hasRequiredBaseclient = 1;
		Object.defineProperty(baseclient, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		/* eslint-disable max-lines */
		var hub_1 = requireDist$2();
		var types_1 = requireDist$4();
		var utils_1 = requireDist$3();
		var integration_1 = requireIntegration();
		/**
		 * Base implementation for all JavaScript SDK clients.
		 *
		 * Call the constructor with the corresponding backend constructor and options
		 * specific to the client subclass. To access these options later, use
		 * {@link Client.getOptions}. Also, the Backend instance is available via
		 * {@link Client.getBackend}.
		 *
		 * If a Dsn is specified in the options, it will be parsed and stored. Use
		 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
		 * invalid, the constructor will throw a {@link SentryException}. Note that
		 * without a valid Dsn, the SDK will not send any events to Sentry.
		 *
		 * Before sending an event via the backend, it is passed through
		 * {@link BaseClient.prepareEvent} to add SDK information and scope data
		 * (breadcrumbs and context). To add more custom information, override this
		 * method and extend the resulting prepared event.
		 *
		 * To issue automatically created events (e.g. via instrumentation), use
		 * {@link Client.captureEvent}. It will prepare the event and pass it through
		 * the callback lifecycle. To issue auto-breadcrumbs, use
		 * {@link Client.addBreadcrumb}.
		 *
		 * @example
		 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
		 *   public constructor(options: NodeOptions) {
		 *     super(NodeBackend, options);
		 *   }
		 *
		 *   // ...
		 * }
		 */
		var BaseClient = /** @class */ (function () {
		    /**
		     * Initializes this client instance.
		     *
		     * @param backendClass A constructor function to create the backend.
		     * @param options Options for the client.
		     */
		    function BaseClient(backendClass, options) {
		        /** Array of used integrations. */
		        this._integrations = {};
		        /** Number of call being processed */
		        this._processing = 0;
		        this._backend = new backendClass(options);
		        this._options = options;
		        if (options.dsn) {
		            this._dsn = new utils_1.Dsn(options.dsn);
		        }
		    }
		    /**
		     * @inheritDoc
		     */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
		    BaseClient.prototype.captureException = function (exception, hint, scope) {
		        var _this = this;
		        var eventId = hint && hint.event_id;
		        this._process(this._getBackend()
		            .eventFromException(exception, hint)
		            .then(function (event) { return _this._captureEvent(event, hint, scope); })
		            .then(function (result) {
		            eventId = result;
		        }));
		        return eventId;
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
		        var _this = this;
		        var eventId = hint && hint.event_id;
		        var promisedEvent = utils_1.isPrimitive(message)
		            ? this._getBackend().eventFromMessage(String(message), level, hint)
		            : this._getBackend().eventFromException(message, hint);
		        this._process(promisedEvent
		            .then(function (event) { return _this._captureEvent(event, hint, scope); })
		            .then(function (result) {
		            eventId = result;
		        }));
		        return eventId;
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseClient.prototype.captureEvent = function (event, hint, scope) {
		        var eventId = hint && hint.event_id;
		        this._process(this._captureEvent(event, hint, scope).then(function (result) {
		            eventId = result;
		        }));
		        return eventId;
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseClient.prototype.captureSession = function (session) {
		        if (!session.release) {
		            utils_1.logger.warn('Discarded session because of missing release');
		        }
		        else {
		            this._sendSession(session);
		        }
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseClient.prototype.getDsn = function () {
		        return this._dsn;
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseClient.prototype.getOptions = function () {
		        return this._options;
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseClient.prototype.flush = function (timeout) {
		        var _this = this;
		        return this._isClientProcessing(timeout).then(function (ready) {
		            return _this._getBackend()
		                .getTransport()
		                .close(timeout)
		                .then(function (transportFlushed) { return ready && transportFlushed; });
		        });
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseClient.prototype.close = function (timeout) {
		        var _this = this;
		        return this.flush(timeout).then(function (result) {
		            _this.getOptions().enabled = false;
		            return result;
		        });
		    };
		    /**
		     * Sets up the integrations
		     */
		    BaseClient.prototype.setupIntegrations = function () {
		        if (this._isEnabled()) {
		            this._integrations = integration_1.setupIntegrations(this._options);
		        }
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseClient.prototype.getIntegration = function (integration) {
		        try {
		            return this._integrations[integration.id] || null;
		        }
		        catch (_oO) {
		            utils_1.logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
		            return null;
		        }
		    };
		    /** Updates existing session based on the provided event */
		    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
		        var e_1, _a;
		        var crashed = false;
		        var errored = false;
		        var userAgent;
		        var exceptions = event.exception && event.exception.values;
		        if (exceptions) {
		            errored = true;
		            try {
		                for (var exceptions_1 = tslib_1.__values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
		                    var ex = exceptions_1_1.value;
		                    var mechanism = ex.mechanism;
		                    if (mechanism && mechanism.handled === false) {
		                        crashed = true;
		                        break;
		                    }
		                }
		            }
		            catch (e_1_1) { e_1 = { error: e_1_1 }; }
		            finally {
		                try {
		                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
		                }
		                finally { if (e_1) throw e_1.error; }
		            }
		        }
		        var user = event.user;
		        if (!session.userAgent) {
		            var headers = event.request ? event.request.headers : {};
		            for (var key in headers) {
		                if (key.toLowerCase() === 'user-agent') {
		                    userAgent = headers[key];
		                    break;
		                }
		            }
		        }
		        session.update(tslib_1.__assign(tslib_1.__assign({}, (crashed && { status: types_1.SessionStatus.Crashed })), { user: user,
		            userAgent: userAgent, errors: session.errors + Number(errored || crashed) }));
		    };
		    /** Deliver captured session to Sentry */
		    BaseClient.prototype._sendSession = function (session) {
		        this._getBackend().sendSession(session);
		    };
		    /** Waits for the client to be done with processing. */
		    BaseClient.prototype._isClientProcessing = function (timeout) {
		        var _this = this;
		        return new utils_1.SyncPromise(function (resolve) {
		            var ticked = 0;
		            var tick = 1;
		            var interval = setInterval(function () {
		                if (_this._processing == 0) {
		                    clearInterval(interval);
		                    resolve(true);
		                }
		                else {
		                    ticked += tick;
		                    if (timeout && ticked >= timeout) {
		                        clearInterval(interval);
		                        resolve(false);
		                    }
		                }
		            }, tick);
		        });
		    };
		    /** Returns the current backend. */
		    BaseClient.prototype._getBackend = function () {
		        return this._backend;
		    };
		    /** Determines whether this SDK is enabled and a valid Dsn is present. */
		    BaseClient.prototype._isEnabled = function () {
		        return this.getOptions().enabled !== false && this._dsn !== undefined;
		    };
		    /**
		     * Adds common information to events.
		     *
		     * The information includes release and environment from `options`,
		     * breadcrumbs and context (extra, tags and user) from the scope.
		     *
		     * Information that is already present in the event is never overwritten. For
		     * nested objects, such as the context, keys are merged.
		     *
		     * @param event The original event.
		     * @param hint May contain additional information about the original exception.
		     * @param scope A scope containing event metadata.
		     * @returns A new event with more information.
		     */
		    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
		        var _this = this;
		        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
		        var prepared = tslib_1.__assign(tslib_1.__assign({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : utils_1.uuid4()), timestamp: event.timestamp || utils_1.dateTimestampInSeconds() });
		        this._applyClientOptions(prepared);
		        this._applyIntegrationsMetadata(prepared);
		        // If we have scope given to us, use it as the base for further modifications.
		        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
		        var finalScope = scope;
		        if (hint && hint.captureContext) {
		            finalScope = hub_1.Scope.clone(finalScope).update(hint.captureContext);
		        }
		        // We prepare the result here with a resolved Event.
		        var result = utils_1.SyncPromise.resolve(prepared);
		        // This should be the last thing called, since we want that
		        // {@link Hub.addEventProcessor} gets the finished prepared event.
		        if (finalScope) {
		            // In case we have a hub we reassign it.
		            result = finalScope.applyToEvent(prepared, hint);
		        }
		        return result.then(function (evt) {
		            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
		                return _this._normalizeEvent(evt, normalizeDepth);
		            }
		            return evt;
		        });
		    };
		    /**
		     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
		     * Normalized keys:
		     * - `breadcrumbs.data`
		     * - `user`
		     * - `contexts`
		     * - `extra`
		     * @param event Event
		     * @returns Normalized event
		     */
		    BaseClient.prototype._normalizeEvent = function (event, depth) {
		        if (!event) {
		            return null;
		        }
		        var normalized = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, event), (event.breadcrumbs && {
		            breadcrumbs: event.breadcrumbs.map(function (b) { return (tslib_1.__assign(tslib_1.__assign({}, b), (b.data && {
		                data: utils_1.normalize(b.data, depth),
		            }))); }),
		        })), (event.user && {
		            user: utils_1.normalize(event.user, depth),
		        })), (event.contexts && {
		            contexts: utils_1.normalize(event.contexts, depth),
		        })), (event.extra && {
		            extra: utils_1.normalize(event.extra, depth),
		        }));
		        // event.contexts.trace stores information about a Transaction. Similarly,
		        // event.spans[] stores information about child Spans. Given that a
		        // Transaction is conceptually a Span, normalization should apply to both
		        // Transactions and Spans consistently.
		        // For now the decision is to skip normalization of Transactions and Spans,
		        // so this block overwrites the normalized event to add back the original
		        // Transaction information prior to normalization.
		        if (event.contexts && event.contexts.trace) {
		            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		            normalized.contexts.trace = event.contexts.trace;
		        }
		        return normalized;
		    };
		    /**
		     *  Enhances event using the client configuration.
		     *  It takes care of all "static" values like environment, release and `dist`,
		     *  as well as truncating overly long values.
		     * @param event event instance to be enhanced
		     */
		    BaseClient.prototype._applyClientOptions = function (event) {
		        var options = this.getOptions();
		        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
		        if (!('environment' in event)) {
		            event.environment = 'environment' in options ? environment : 'production';
		        }
		        if (event.release === undefined && release !== undefined) {
		            event.release = release;
		        }
		        if (event.dist === undefined && dist !== undefined) {
		            event.dist = dist;
		        }
		        if (event.message) {
		            event.message = utils_1.truncate(event.message, maxValueLength);
		        }
		        var exception = event.exception && event.exception.values && event.exception.values[0];
		        if (exception && exception.value) {
		            exception.value = utils_1.truncate(exception.value, maxValueLength);
		        }
		        var request = event.request;
		        if (request && request.url) {
		            request.url = utils_1.truncate(request.url, maxValueLength);
		        }
		    };
		    /**
		     * This function adds all used integrations to the SDK info in the event.
		     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
		     */
		    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
		        var sdkInfo = event.sdk;
		        var integrationsArray = Object.keys(this._integrations);
		        if (sdkInfo && integrationsArray.length > 0) {
		            sdkInfo.integrations = integrationsArray;
		        }
		    };
		    /**
		     * Tells the backend to send this event
		     * @param event The Sentry event to send
		     */
		    BaseClient.prototype._sendEvent = function (event) {
		        this._getBackend().sendEvent(event);
		    };
		    /**
		     * Processes the event and logs an error in case of rejection
		     * @param event
		     * @param hint
		     * @param scope
		     */
		    BaseClient.prototype._captureEvent = function (event, hint, scope) {
		        return this._processEvent(event, hint, scope).then(function (finalEvent) {
		            return finalEvent.event_id;
		        }, function (reason) {
		            utils_1.logger.error(reason);
		            return undefined;
		        });
		    };
		    /**
		     * Processes an event (either error or message) and sends it to Sentry.
		     *
		     * This also adds breadcrumbs and context information to the event. However,
		     * platform specific meta data (such as the User's IP address) must be added
		     * by the SDK implementor.
		     *
		     *
		     * @param event The event to send to Sentry.
		     * @param hint May contain additional information about the original exception.
		     * @param scope A scope containing event metadata.
		     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
		     */
		    BaseClient.prototype._processEvent = function (event, hint, scope) {
		        var _this = this;
		        // eslint-disable-next-line @typescript-eslint/unbound-method
		        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
		        if (!this._isEnabled()) {
		            return utils_1.SyncPromise.reject(new utils_1.SentryError('SDK not enabled, will not send event.'));
		        }
		        var isTransaction = event.type === 'transaction';
		        // 1.0 === 100% events are sent
		        // 0.0 === 0% events are sent
		        // Sampling for transaction happens somewhere else
		        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
		            return utils_1.SyncPromise.reject(new utils_1.SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
		        }
		        return this._prepareEvent(event, scope, hint)
		            .then(function (prepared) {
		            if (prepared === null) {
		                throw new utils_1.SentryError('An event processor returned null, will not send event.');
		            }
		            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
		            if (isInternalException || isTransaction || !beforeSend) {
		                return prepared;
		            }
		            var beforeSendResult = beforeSend(prepared, hint);
		            if (typeof beforeSendResult === 'undefined') {
		                throw new utils_1.SentryError('`beforeSend` method has to return `null` or a valid event.');
		            }
		            else if (utils_1.isThenable(beforeSendResult)) {
		                return beforeSendResult.then(function (event) { return event; }, function (e) {
		                    throw new utils_1.SentryError("beforeSend rejected with " + e);
		                });
		            }
		            return beforeSendResult;
		        })
		            .then(function (processedEvent) {
		            if (processedEvent === null) {
		                throw new utils_1.SentryError('`beforeSend` returned `null`, will not send event.');
		            }
		            var session = scope && scope.getSession && scope.getSession();
		            if (!isTransaction && session) {
		                _this._updateSessionFromEvent(session, processedEvent);
		            }
		            _this._sendEvent(processedEvent);
		            return processedEvent;
		        })
		            .then(null, function (reason) {
		            if (reason instanceof utils_1.SentryError) {
		                throw reason;
		            }
		            _this.captureException(reason, {
		                data: {
		                    __sentry__: true,
		                },
		                originalException: reason,
		            });
		            throw new utils_1.SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
		        });
		    };
		    /**
		     * Occupies the client with processing and event
		     */
		    BaseClient.prototype._process = function (promise) {
		        var _this = this;
		        this._processing += 1;
		        promise.then(function (value) {
		            _this._processing -= 1;
		            return value;
		        }, function (reason) {
		            _this._processing -= 1;
		            return reason;
		        });
		    };
		    return BaseClient;
		}());
		baseclient.BaseClient = BaseClient;
		
		return baseclient;
	}

	var basebackend = {};

	var noop = {};

	var hasRequiredNoop;

	function requireNoop () {
		if (hasRequiredNoop) return noop;
		hasRequiredNoop = 1;
		Object.defineProperty(noop, "__esModule", { value: true });
		var types_1 = requireDist$4();
		var utils_1 = requireDist$3();
		/** Noop transport */
		var NoopTransport = /** @class */ (function () {
		    function NoopTransport() {
		    }
		    /**
		     * @inheritDoc
		     */
		    NoopTransport.prototype.sendEvent = function (_) {
		        return utils_1.SyncPromise.resolve({
		            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
		            status: types_1.Status.Skipped,
		        });
		    };
		    /**
		     * @inheritDoc
		     */
		    NoopTransport.prototype.close = function (_) {
		        return utils_1.SyncPromise.resolve(true);
		    };
		    return NoopTransport;
		}());
		noop.NoopTransport = NoopTransport;
		
		return noop;
	}

	var hasRequiredBasebackend;

	function requireBasebackend () {
		if (hasRequiredBasebackend) return basebackend;
		hasRequiredBasebackend = 1;
		Object.defineProperty(basebackend, "__esModule", { value: true });
		var utils_1 = requireDist$3();
		var noop_1 = requireNoop();
		/**
		 * This is the base implemention of a Backend.
		 * @hidden
		 */
		var BaseBackend = /** @class */ (function () {
		    /** Creates a new backend instance. */
		    function BaseBackend(options) {
		        this._options = options;
		        if (!this._options.dsn) {
		            utils_1.logger.warn('No DSN provided, backend will not do anything.');
		        }
		        this._transport = this._setupTransport();
		    }
		    /**
		     * @inheritDoc
		     */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
		    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
		        throw new utils_1.SentryError('Backend has to implement `eventFromException` method');
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
		        throw new utils_1.SentryError('Backend has to implement `eventFromMessage` method');
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseBackend.prototype.sendEvent = function (event) {
		        this._transport.sendEvent(event).then(null, function (reason) {
		            utils_1.logger.error("Error while sending event: " + reason);
		        });
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseBackend.prototype.sendSession = function (session) {
		        if (!this._transport.sendSession) {
		            utils_1.logger.warn("Dropping session because custom transport doesn't implement sendSession");
		            return;
		        }
		        this._transport.sendSession(session).then(null, function (reason) {
		            utils_1.logger.error("Error while sending session: " + reason);
		        });
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseBackend.prototype.getTransport = function () {
		        return this._transport;
		    };
		    /**
		     * Sets up the transport so it can be used later to send requests.
		     */
		    BaseBackend.prototype._setupTransport = function () {
		        return new noop_1.NoopTransport();
		    };
		    return BaseBackend;
		}());
		basebackend.BaseBackend = BaseBackend;
		
		return basebackend;
	}

	var request = {};

	var hasRequiredRequest;

	function requireRequest () {
		if (hasRequiredRequest) return request;
		hasRequiredRequest = 1;
		Object.defineProperty(request, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		/** Creates a SentryRequest from an event. */
		function sessionToSentryRequest(session, api) {
		    var envelopeHeaders = JSON.stringify({
		        sent_at: new Date().toISOString(),
		    });
		    var itemHeaders = JSON.stringify({
		        type: 'session',
		    });
		    return {
		        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
		        type: 'session',
		        url: api.getEnvelopeEndpointWithUrlEncodedAuth(),
		    };
		}
		request.sessionToSentryRequest = sessionToSentryRequest;
		/** Creates a SentryRequest from an event. */
		function eventToSentryRequest(event, api) {
		    // since JS has no Object.prototype.pop()
		    var _a = event.tags || {}, samplingMethod = _a.__sentry_samplingMethod, sampleRate = _a.__sentry_sampleRate, otherTags = tslib_1.__rest(_a, ["__sentry_samplingMethod", "__sentry_sampleRate"]);
		    event.tags = otherTags;
		    var useEnvelope = event.type === 'transaction';
		    var req = {
		        body: JSON.stringify(event),
		        type: event.type || 'event',
		        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
		    };
		    // https://develop.sentry.dev/sdk/envelopes/
		    // Since we don't need to manipulate envelopes nor store them, there is no
		    // exported concept of an Envelope with operations including serialization and
		    // deserialization. Instead, we only implement a minimal subset of the spec to
		    // serialize events inline here.
		    if (useEnvelope) {
		        var envelopeHeaders = JSON.stringify({
		            event_id: event.event_id,
		            sent_at: new Date().toISOString(),
		        });
		        var itemHeaders = JSON.stringify({
		            type: event.type,
		            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
		            // explicitly-set sampling decisions). Are we good with that?
		            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
		        });
		        // The trailing newline is optional. We intentionally don't send it to avoid
		        // sending unnecessary bytes.
		        //
		        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
		        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
		        req.body = envelope;
		    }
		    return req;
		}
		request.eventToSentryRequest = eventToSentryRequest;
		
		return request;
	}

	var sdk$1 = {};

	var hasRequiredSdk$1;

	function requireSdk$1 () {
		if (hasRequiredSdk$1) return sdk$1;
		hasRequiredSdk$1 = 1;
		Object.defineProperty(sdk$1, "__esModule", { value: true });
		var hub_1 = requireDist$2();
		var utils_1 = requireDist$3();
		/**
		 * Internal function to create a new SDK client instance. The client is
		 * installed and then bound to the current scope.
		 *
		 * @param clientClass The client class to instantiate.
		 * @param options Options to pass to the client.
		 */
		function initAndBind(clientClass, options) {
		    if (options.debug === true) {
		        utils_1.logger.enable();
		    }
		    var hub = hub_1.getCurrentHub();
		    var client = new clientClass(options);
		    hub.bindClient(client);
		}
		sdk$1.initAndBind = initAndBind;
		
		return sdk$1;
	}

	var integrations$1 = {};

	var functiontostring = {};

	var hasRequiredFunctiontostring;

	function requireFunctiontostring () {
		if (hasRequiredFunctiontostring) return functiontostring;
		hasRequiredFunctiontostring = 1;
		Object.defineProperty(functiontostring, "__esModule", { value: true });
		var originalFunctionToString;
		/** Patch toString calls to return proper name for wrapped functions */
		var FunctionToString = /** @class */ (function () {
		    function FunctionToString() {
		        /**
		         * @inheritDoc
		         */
		        this.name = FunctionToString.id;
		    }
		    /**
		     * @inheritDoc
		     */
		    FunctionToString.prototype.setupOnce = function () {
		        // eslint-disable-next-line @typescript-eslint/unbound-method
		        originalFunctionToString = Function.prototype.toString;
		        // eslint-disable-next-line @typescript-eslint/no-explicit-any
		        Function.prototype.toString = function () {
		            var args = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                args[_i] = arguments[_i];
		            }
		            var context = this.__sentry_original__ || this;
		            return originalFunctionToString.apply(context, args);
		        };
		    };
		    /**
		     * @inheritDoc
		     */
		    FunctionToString.id = 'FunctionToString';
		    return FunctionToString;
		}());
		functiontostring.FunctionToString = FunctionToString;
		
		return functiontostring;
	}

	var inboundfilters = {};

	var hasRequiredInboundfilters;

	function requireInboundfilters () {
		if (hasRequiredInboundfilters) return inboundfilters;
		hasRequiredInboundfilters = 1;
		Object.defineProperty(inboundfilters, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var hub_1 = requireDist$2();
		var utils_1 = requireDist$3();
		// "Script error." is hard coded into browsers for errors that it can't read.
		// this is the result of a script being pulled in from an external domain and CORS.
		var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
		/** Inbound filters configurable by the user */
		var InboundFilters = /** @class */ (function () {
		    function InboundFilters(_options) {
		        if (_options === void 0) { _options = {}; }
		        this._options = _options;
		        /**
		         * @inheritDoc
		         */
		        this.name = InboundFilters.id;
		    }
		    /**
		     * @inheritDoc
		     */
		    InboundFilters.prototype.setupOnce = function () {
		        hub_1.addGlobalEventProcessor(function (event) {
		            var hub = hub_1.getCurrentHub();
		            if (!hub) {
		                return event;
		            }
		            var self = hub.getIntegration(InboundFilters);
		            if (self) {
		                var client = hub.getClient();
		                var clientOptions = client ? client.getOptions() : {};
		                var options = self._mergeOptions(clientOptions);
		                if (self._shouldDropEvent(event, options)) {
		                    return null;
		                }
		            }
		            return event;
		        });
		    };
		    /** JSDoc */
		    InboundFilters.prototype._shouldDropEvent = function (event, options) {
		        if (this._isSentryError(event, options)) {
		            utils_1.logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + utils_1.getEventDescription(event));
		            return true;
		        }
		        if (this._isIgnoredError(event, options)) {
		            utils_1.logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + utils_1.getEventDescription(event));
		            return true;
		        }
		        if (this._isDeniedUrl(event, options)) {
		            utils_1.logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
		            return true;
		        }
		        if (!this._isAllowedUrl(event, options)) {
		            utils_1.logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + utils_1.getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
		            return true;
		        }
		        return false;
		    };
		    /** JSDoc */
		    InboundFilters.prototype._isSentryError = function (event, options) {
		        if (!options.ignoreInternal) {
		            return false;
		        }
		        try {
		            return ((event &&
		                event.exception &&
		                event.exception.values &&
		                event.exception.values[0] &&
		                event.exception.values[0].type === 'SentryError') ||
		                false);
		        }
		        catch (_oO) {
		            return false;
		        }
		    };
		    /** JSDoc */
		    InboundFilters.prototype._isIgnoredError = function (event, options) {
		        if (!options.ignoreErrors || !options.ignoreErrors.length) {
		            return false;
		        }
		        return this._getPossibleEventMessages(event).some(function (message) {
		            // Not sure why TypeScript complains here...
		            return options.ignoreErrors.some(function (pattern) { return utils_1.isMatchingPattern(message, pattern); });
		        });
		    };
		    /** JSDoc */
		    InboundFilters.prototype._isDeniedUrl = function (event, options) {
		        // TODO: Use Glob instead?
		        if (!options.denyUrls || !options.denyUrls.length) {
		            return false;
		        }
		        var url = this._getEventFilterUrl(event);
		        return !url ? false : options.denyUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
		    };
		    /** JSDoc */
		    InboundFilters.prototype._isAllowedUrl = function (event, options) {
		        // TODO: Use Glob instead?
		        if (!options.allowUrls || !options.allowUrls.length) {
		            return true;
		        }
		        var url = this._getEventFilterUrl(event);
		        return !url ? true : options.allowUrls.some(function (pattern) { return utils_1.isMatchingPattern(url, pattern); });
		    };
		    /** JSDoc */
		    InboundFilters.prototype._mergeOptions = function (clientOptions) {
		        if (clientOptions === void 0) { clientOptions = {}; }
		        return {
		            allowUrls: tslib_1.__spread((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
		            denyUrls: tslib_1.__spread((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
		            ignoreErrors: tslib_1.__spread((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
		            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
		        };
		    };
		    /** JSDoc */
		    InboundFilters.prototype._getPossibleEventMessages = function (event) {
		        if (event.message) {
		            return [event.message];
		        }
		        if (event.exception) {
		            try {
		                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
		                return ["" + value, type + ": " + value];
		            }
		            catch (oO) {
		                utils_1.logger.error("Cannot extract message for event " + utils_1.getEventDescription(event));
		                return [];
		            }
		        }
		        return [];
		    };
		    /** JSDoc */
		    InboundFilters.prototype._getEventFilterUrl = function (event) {
		        try {
		            if (event.stacktrace) {
		                var frames_1 = event.stacktrace.frames;
		                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
		            }
		            if (event.exception) {
		                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
		                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
		            }
		            return null;
		        }
		        catch (oO) {
		            utils_1.logger.error("Cannot extract url for event " + utils_1.getEventDescription(event));
		            return null;
		        }
		    };
		    /**
		     * @inheritDoc
		     */
		    InboundFilters.id = 'InboundFilters';
		    return InboundFilters;
		}());
		inboundfilters.InboundFilters = InboundFilters;
		
		return inboundfilters;
	}

	var hasRequiredIntegrations$1;

	function requireIntegrations$1 () {
		if (hasRequiredIntegrations$1) return integrations$1;
		hasRequiredIntegrations$1 = 1;
		Object.defineProperty(integrations$1, "__esModule", { value: true });
		var functiontostring_1 = requireFunctiontostring();
		integrations$1.FunctionToString = functiontostring_1.FunctionToString;
		var inboundfilters_1 = requireInboundfilters();
		integrations$1.InboundFilters = inboundfilters_1.InboundFilters;
		
		return integrations$1;
	}

	var hasRequiredDist;

	function requireDist () {
		if (hasRequiredDist) return dist$3;
		hasRequiredDist = 1;
		Object.defineProperty(dist$3, "__esModule", { value: true });
		var minimal_1 = requireDist$1();
		dist$3.addBreadcrumb = minimal_1.addBreadcrumb;
		dist$3.captureException = minimal_1.captureException;
		dist$3.captureEvent = minimal_1.captureEvent;
		dist$3.captureMessage = minimal_1.captureMessage;
		dist$3.configureScope = minimal_1.configureScope;
		dist$3.startTransaction = minimal_1.startTransaction;
		dist$3.setContext = minimal_1.setContext;
		dist$3.setExtra = minimal_1.setExtra;
		dist$3.setExtras = minimal_1.setExtras;
		dist$3.setTag = minimal_1.setTag;
		dist$3.setTags = minimal_1.setTags;
		dist$3.setUser = minimal_1.setUser;
		dist$3.withScope = minimal_1.withScope;
		var hub_1 = requireDist$2();
		dist$3.addGlobalEventProcessor = hub_1.addGlobalEventProcessor;
		dist$3.getCurrentHub = hub_1.getCurrentHub;
		dist$3.getHubFromCarrier = hub_1.getHubFromCarrier;
		dist$3.Hub = hub_1.Hub;
		dist$3.makeMain = hub_1.makeMain;
		dist$3.Scope = hub_1.Scope;
		var api_1 = requireApi();
		dist$3.API = api_1.API;
		var baseclient_1 = requireBaseclient();
		dist$3.BaseClient = baseclient_1.BaseClient;
		var basebackend_1 = requireBasebackend();
		dist$3.BaseBackend = basebackend_1.BaseBackend;
		var request_1 = requireRequest();
		dist$3.eventToSentryRequest = request_1.eventToSentryRequest;
		dist$3.sessionToSentryRequest = request_1.sessionToSentryRequest;
		var sdk_1 = requireSdk$1();
		dist$3.initAndBind = sdk_1.initAndBind;
		var noop_1 = requireNoop();
		dist$3.NoopTransport = noop_1.NoopTransport;
		var Integrations = requireIntegrations$1();
		dist$3.Integrations = Integrations;
		
		return dist$3;
	}

	var client = {};

	var backend = {};

	var eventbuilder = {};

	var parsers = {};

	var tracekit = {};

	/**
	 * This was originally forked from https://github.com/occ/TraceKit, but has since been
	 * largely modified and is now maintained as part of Sentry JS SDK.
	 */

	var hasRequiredTracekit;

	function requireTracekit () {
		if (hasRequiredTracekit) return tracekit;
		hasRequiredTracekit = 1;
		Object.defineProperty(tracekit, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		// global reference to slice
		var UNKNOWN_FUNCTION = '?';
		// Chromium based browsers: Chrome, Brave, new Opera, new Edge
		var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
		// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
		// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
		// We need this specific case for now because we want no other regex to match.
		var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
		var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
		var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
		var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
		// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
		var reactMinifiedRegexp = /Minified React error #\d+;/i;
		/** JSDoc */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
		function computeStackTrace(ex) {
		    var stack = null;
		    var popSize = 0;
		    if (ex) {
		        if (typeof ex.framesToPop === 'number') {
		            popSize = ex.framesToPop;
		        }
		        else if (reactMinifiedRegexp.test(ex.message)) {
		            popSize = 1;
		        }
		    }
		    try {
		        // This must be tried first because Opera 10 *destroys*
		        // its stacktrace property if you try to access the stack
		        // property first!!
		        stack = computeStackTraceFromStacktraceProp(ex);
		        if (stack) {
		            return popFrames(stack, popSize);
		        }
		    }
		    catch (e) {
		        // no-empty
		    }
		    try {
		        stack = computeStackTraceFromStackProp(ex);
		        if (stack) {
		            return popFrames(stack, popSize);
		        }
		    }
		    catch (e) {
		        // no-empty
		    }
		    return {
		        message: extractMessage(ex),
		        name: ex && ex.name,
		        stack: [],
		        failed: true,
		    };
		}
		tracekit.computeStackTrace = computeStackTrace;
		/** JSDoc */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
		function computeStackTraceFromStackProp(ex) {
		    if (!ex || !ex.stack) {
		        return null;
		    }
		    var stack = [];
		    var lines = ex.stack.split('\n');
		    var isEval;
		    var submatch;
		    var parts;
		    var element;
		    for (var i = 0; i < lines.length; ++i) {
		        if ((parts = chrome.exec(lines[i]))) {
		            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
		            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
		            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
		                // throw out eval line/column and use top-most line/column number
		                parts[2] = submatch[1]; // url
		                parts[3] = submatch[2]; // line
		                parts[4] = submatch[3]; // column
		            }
		            element = {
		                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
		                // prefix here seems like the quickest solution for now.
		                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
		                func: parts[1] || UNKNOWN_FUNCTION,
		                args: isNative ? [parts[2]] : [],
		                line: parts[3] ? +parts[3] : null,
		                column: parts[4] ? +parts[4] : null,
		            };
		        }
		        else if ((parts = winjs.exec(lines[i]))) {
		            element = {
		                url: parts[2],
		                func: parts[1] || UNKNOWN_FUNCTION,
		                args: [],
		                line: +parts[3],
		                column: parts[4] ? +parts[4] : null,
		            };
		        }
		        else if ((parts = gecko.exec(lines[i]))) {
		            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
		            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
		                // throw out eval line/column and use top-most line number
		                parts[1] = parts[1] || "eval";
		                parts[3] = submatch[1];
		                parts[4] = submatch[2];
		                parts[5] = ''; // no column when eval
		            }
		            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
		                // FireFox uses this awesome columnNumber property for its top frame
		                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
		                // so adding 1
		                // NOTE: this hack doesn't work if top-most frame is eval
		                stack[0].column = ex.columnNumber + 1;
		            }
		            element = {
		                url: parts[3],
		                func: parts[1] || UNKNOWN_FUNCTION,
		                args: parts[2] ? parts[2].split(',') : [],
		                line: parts[4] ? +parts[4] : null,
		                column: parts[5] ? +parts[5] : null,
		            };
		        }
		        else {
		            continue;
		        }
		        if (!element.func && element.line) {
		            element.func = UNKNOWN_FUNCTION;
		        }
		        stack.push(element);
		    }
		    if (!stack.length) {
		        return null;
		    }
		    return {
		        message: extractMessage(ex),
		        name: ex.name,
		        stack: stack,
		    };
		}
		/** JSDoc */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		function computeStackTraceFromStacktraceProp(ex) {
		    if (!ex || !ex.stacktrace) {
		        return null;
		    }
		    // Access and store the stacktrace property before doing ANYTHING
		    // else to it because Opera is not very good at providing it
		    // reliably in other circumstances.
		    var stacktrace = ex.stacktrace;
		    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
		    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
		    var lines = stacktrace.split('\n');
		    var stack = [];
		    var parts;
		    for (var line = 0; line < lines.length; line += 2) {
		        var element = null;
		        if ((parts = opera10Regex.exec(lines[line]))) {
		            element = {
		                url: parts[2],
		                func: parts[3],
		                args: [],
		                line: +parts[1],
		                column: null,
		            };
		        }
		        else if ((parts = opera11Regex.exec(lines[line]))) {
		            element = {
		                url: parts[6],
		                func: parts[3] || parts[4],
		                args: parts[5] ? parts[5].split(',') : [],
		                line: +parts[1],
		                column: +parts[2],
		            };
		        }
		        if (element) {
		            if (!element.func && element.line) {
		                element.func = UNKNOWN_FUNCTION;
		            }
		            stack.push(element);
		        }
		    }
		    if (!stack.length) {
		        return null;
		    }
		    return {
		        message: extractMessage(ex),
		        name: ex.name,
		        stack: stack,
		    };
		}
		/** Remove N number of frames from the stack */
		function popFrames(stacktrace, popSize) {
		    try {
		        return tslib_1.__assign(tslib_1.__assign({}, stacktrace), { stack: stacktrace.stack.slice(popSize) });
		    }
		    catch (e) {
		        return stacktrace;
		    }
		}
		/**
		 * There are cases where stacktrace.message is an Event object
		 * https://github.com/getsentry/sentry-javascript/issues/1949
		 * In this specific case we try to extract stacktrace.message.error.message
		 */
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		function extractMessage(ex) {
		    var message = ex && ex.message;
		    if (!message) {
		        return 'No error message';
		    }
		    if (message.error && typeof message.error.message === 'string') {
		        return message.error.message;
		    }
		    return message;
		}
		
		return tracekit;
	}

	var hasRequiredParsers;

	function requireParsers () {
		if (hasRequiredParsers) return parsers;
		hasRequiredParsers = 1;
		Object.defineProperty(parsers, "__esModule", { value: true });
		var utils_1 = requireDist$3();
		var tracekit_1 = requireTracekit();
		var STACKTRACE_LIMIT = 50;
		/**
		 * This function creates an exception from an TraceKitStackTrace
		 * @param stacktrace TraceKitStackTrace that will be converted to an exception
		 * @hidden
		 */
		function exceptionFromStacktrace(stacktrace) {
		    var frames = prepareFramesForEvent(stacktrace.stack);
		    var exception = {
		        type: stacktrace.name,
		        value: stacktrace.message,
		    };
		    if (frames && frames.length) {
		        exception.stacktrace = { frames: frames };
		    }
		    if (exception.type === undefined && exception.value === '') {
		        exception.value = 'Unrecoverable error caught';
		    }
		    return exception;
		}
		parsers.exceptionFromStacktrace = exceptionFromStacktrace;
		/**
		 * @hidden
		 */
		function eventFromPlainObject(exception, syntheticException, rejection) {
		    var event = {
		        exception: {
		            values: [
		                {
		                    type: utils_1.isEvent(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
		                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + utils_1.extractExceptionKeysForMessage(exception),
		                },
		            ],
		        },
		        extra: {
		            __serialized__: utils_1.normalizeToSize(exception),
		        },
		    };
		    if (syntheticException) {
		        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
		        var frames_1 = prepareFramesForEvent(stacktrace.stack);
		        event.stacktrace = {
		            frames: frames_1,
		        };
		    }
		    return event;
		}
		parsers.eventFromPlainObject = eventFromPlainObject;
		/**
		 * @hidden
		 */
		function eventFromStacktrace(stacktrace) {
		    var exception = exceptionFromStacktrace(stacktrace);
		    return {
		        exception: {
		            values: [exception],
		        },
		    };
		}
		parsers.eventFromStacktrace = eventFromStacktrace;
		/**
		 * @hidden
		 */
		function prepareFramesForEvent(stack) {
		    if (!stack || !stack.length) {
		        return [];
		    }
		    var localStack = stack;
		    var firstFrameFunction = localStack[0].func || '';
		    var lastFrameFunction = localStack[localStack.length - 1].func || '';
		    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
		    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
		        localStack = localStack.slice(1);
		    }
		    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
		    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
		        localStack = localStack.slice(0, -1);
		    }
		    // The frame where the crash happened, should be the last entry in the array
		    return localStack
		        .slice(0, STACKTRACE_LIMIT)
		        .map(function (frame) { return ({
		        colno: frame.column === null ? undefined : frame.column,
		        filename: frame.url || localStack[0].url,
		        function: frame.func || '?',
		        in_app: true,
		        lineno: frame.line === null ? undefined : frame.line,
		    }); })
		        .reverse();
		}
		parsers.prepareFramesForEvent = prepareFramesForEvent;
		
		return parsers;
	}

	var hasRequiredEventbuilder;

	function requireEventbuilder () {
		if (hasRequiredEventbuilder) return eventbuilder;
		hasRequiredEventbuilder = 1;
		Object.defineProperty(eventbuilder, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var types_1 = requireDist$4();
		var utils_1 = requireDist$3();
		var parsers_1 = requireParsers();
		var tracekit_1 = requireTracekit();
		/**
		 * Builds and Event from a Exception
		 * @hidden
		 */
		function eventFromException(options, exception, hint) {
		    var syntheticException = (hint && hint.syntheticException) || undefined;
		    var event = eventFromUnknownInput(exception, syntheticException, {
		        attachStacktrace: options.attachStacktrace,
		    });
		    utils_1.addExceptionMechanism(event, {
		        handled: true,
		        type: 'generic',
		    });
		    event.level = types_1.Severity.Error;
		    if (hint && hint.event_id) {
		        event.event_id = hint.event_id;
		    }
		    return utils_1.SyncPromise.resolve(event);
		}
		eventbuilder.eventFromException = eventFromException;
		/**
		 * Builds and Event from a Message
		 * @hidden
		 */
		function eventFromMessage(options, message, level, hint) {
		    if (level === void 0) { level = types_1.Severity.Info; }
		    var syntheticException = (hint && hint.syntheticException) || undefined;
		    var event = eventFromString(message, syntheticException, {
		        attachStacktrace: options.attachStacktrace,
		    });
		    event.level = level;
		    if (hint && hint.event_id) {
		        event.event_id = hint.event_id;
		    }
		    return utils_1.SyncPromise.resolve(event);
		}
		eventbuilder.eventFromMessage = eventFromMessage;
		/**
		 * @hidden
		 */
		function eventFromUnknownInput(exception, syntheticException, options) {
		    if (options === void 0) { options = {}; }
		    var event;
		    if (utils_1.isErrorEvent(exception) && exception.error) {
		        // If it is an ErrorEvent with `error` property, extract it to get actual Error
		        var errorEvent = exception;
		        // eslint-disable-next-line no-param-reassign
		        exception = errorEvent.error;
		        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
		        return event;
		    }
		    if (utils_1.isDOMError(exception) || utils_1.isDOMException(exception)) {
		        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
		        // then we just extract the name, code, and message, as they don't provide anything else
		        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
		        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
		        var domException = exception;
		        var name_1 = domException.name || (utils_1.isDOMError(domException) ? 'DOMError' : 'DOMException');
		        var message = domException.message ? name_1 + ": " + domException.message : name_1;
		        event = eventFromString(message, syntheticException, options);
		        utils_1.addExceptionTypeValue(event, message);
		        if ('code' in domException) {
		            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { 'DOMException.code': "" + domException.code });
		        }
		        return event;
		    }
		    if (utils_1.isError(exception)) {
		        // we have a real Error object, do nothing
		        event = parsers_1.eventFromStacktrace(tracekit_1.computeStackTrace(exception));
		        return event;
		    }
		    if (utils_1.isPlainObject(exception) || utils_1.isEvent(exception)) {
		        // If it is plain Object or Event, serialize it manually and extract options
		        // This will allow us to group events based on top-level keys
		        // which is much better than creating new group when any key/value change
		        var objectException = exception;
		        event = parsers_1.eventFromPlainObject(objectException, syntheticException, options.rejection);
		        utils_1.addExceptionMechanism(event, {
		            synthetic: true,
		        });
		        return event;
		    }
		    // If none of previous checks were valid, then it means that it's not:
		    // - an instance of DOMError
		    // - an instance of DOMException
		    // - an instance of Event
		    // - an instance of Error
		    // - a valid ErrorEvent (one with an error property)
		    // - a plain Object
		    //
		    // So bail out and capture it as a simple message:
		    event = eventFromString(exception, syntheticException, options);
		    utils_1.addExceptionTypeValue(event, "" + exception, undefined);
		    utils_1.addExceptionMechanism(event, {
		        synthetic: true,
		    });
		    return event;
		}
		eventbuilder.eventFromUnknownInput = eventFromUnknownInput;
		/**
		 * @hidden
		 */
		function eventFromString(input, syntheticException, options) {
		    if (options === void 0) { options = {}; }
		    var event = {
		        message: input,
		    };
		    if (options.attachStacktrace && syntheticException) {
		        var stacktrace = tracekit_1.computeStackTrace(syntheticException);
		        var frames_1 = parsers_1.prepareFramesForEvent(stacktrace.stack);
		        event.stacktrace = {
		            frames: frames_1,
		        };
		    }
		    return event;
		}
		eventbuilder.eventFromString = eventFromString;
		
		return eventbuilder;
	}

	var transports = {};

	var base = {};

	var hasRequiredBase;

	function requireBase () {
		if (hasRequiredBase) return base;
		hasRequiredBase = 1;
		Object.defineProperty(base, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var core_1 = requireDist();
		var types_1 = requireDist$4();
		var utils_1 = requireDist$3();
		/** Base Transport class implementation */
		var BaseTransport = /** @class */ (function () {
		    function BaseTransport(options) {
		        this.options = options;
		        /** A simple buffer holding all requests. */
		        this._buffer = new utils_1.PromiseBuffer(30);
		        /** Locks transport after receiving rate limits in a response */
		        this._rateLimits = {};
		        this._api = new core_1.API(this.options.dsn);
		        // eslint-disable-next-line deprecation/deprecation
		        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
		    }
		    /**
		     * @inheritDoc
		     */
		    BaseTransport.prototype.sendEvent = function (_) {
		        throw new utils_1.SentryError('Transport Class has to implement `sendEvent` method');
		    };
		    /**
		     * @inheritDoc
		     */
		    BaseTransport.prototype.close = function (timeout) {
		        return this._buffer.drain(timeout);
		    };
		    /**
		     * Handle Sentry repsonse for promise-based transports.
		     */
		    BaseTransport.prototype._handleResponse = function (_a) {
		        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
		        var status = types_1.Status.fromHttpCode(response.status);
		        /**
		         * "The name is case-insensitive."
		         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
		         */
		        var limited = this._handleRateLimit(headers);
		        if (limited)
		            utils_1.logger.warn("Too many requests, backing off until: " + this._disabledUntil(requestType));
		        if (status === types_1.Status.Success) {
		            resolve({ status: status });
		            return;
		        }
		        reject(response);
		    };
		    /**
		     * Gets the time that given category is disabled until for rate limiting
		     */
		    BaseTransport.prototype._disabledUntil = function (category) {
		        return this._rateLimits[category] || this._rateLimits.all;
		    };
		    /**
		     * Checks if a category is rate limited
		     */
		    BaseTransport.prototype._isRateLimited = function (category) {
		        return this._disabledUntil(category) > new Date(Date.now());
		    };
		    /**
		     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
		     */
		    BaseTransport.prototype._handleRateLimit = function (headers) {
		        var e_1, _a, e_2, _b;
		        var now = Date.now();
		        var rlHeader = headers['x-sentry-rate-limits'];
		        var raHeader = headers['retry-after'];
		        if (rlHeader) {
		            try {
		                // rate limit headers are of the form
		                //     <header>,<header>,..
		                // where each <header> is of the form
		                //     <retry_after>: <categories>: <scope>: <reason_code>
		                // where
		                //     <retry_after> is a delay in ms
		                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
		                //         <category>;<category>;...
		                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
		                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
		                for (var _c = tslib_1.__values(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
		                    var limit = _d.value;
		                    var parameters = limit.split(':', 2);
		                    var headerDelay = parseInt(parameters[0], 10);
		                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
		                    try {
		                        for (var _e = (e_2 = void 0, tslib_1.__values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
		                            var category = _f.value;
		                            this._rateLimits[category || 'all'] = new Date(now + delay);
		                        }
		                    }
		                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
		                    finally {
		                        try {
		                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
		                        }
		                        finally { if (e_2) throw e_2.error; }
		                    }
		                }
		            }
		            catch (e_1_1) { e_1 = { error: e_1_1 }; }
		            finally {
		                try {
		                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
		                }
		                finally { if (e_1) throw e_1.error; }
		            }
		            return true;
		        }
		        else if (raHeader) {
		            this._rateLimits.all = new Date(now + utils_1.parseRetryAfterHeader(now, raHeader));
		            return true;
		        }
		        return false;
		    };
		    return BaseTransport;
		}());
		base.BaseTransport = BaseTransport;
		
		return base;
	}

	var fetch = {};

	var hasRequiredFetch;

	function requireFetch () {
		if (hasRequiredFetch) return fetch;
		hasRequiredFetch = 1;
		Object.defineProperty(fetch, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var core_1 = requireDist();
		var utils_1 = requireDist$3();
		var base_1 = requireBase();
		var global = utils_1.getGlobalObject();
		/** `fetch` based transport */
		var FetchTransport = /** @class */ (function (_super) {
		    tslib_1.__extends(FetchTransport, _super);
		    function FetchTransport() {
		        return _super !== null && _super.apply(this, arguments) || this;
		    }
		    /**
		     * @inheritDoc
		     */
		    FetchTransport.prototype.sendEvent = function (event) {
		        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
		    };
		    /**
		     * @inheritDoc
		     */
		    FetchTransport.prototype.sendSession = function (session) {
		        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
		    };
		    /**
		     * @param sentryRequest Prepared SentryRequest to be delivered
		     * @param originalPayload Original payload used to create SentryRequest
		     */
		    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
		        var _this = this;
		        if (this._isRateLimited(sentryRequest.type)) {
		            return Promise.reject({
		                event: originalPayload,
		                type: sentryRequest.type,
		                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
		                status: 429,
		            });
		        }
		        var options = {
		            body: sentryRequest.body,
		            method: 'POST',
		            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
		            // https://caniuse.com/#feat=referrer-policy
		            // It doesn't. And it throw exception instead of ignoring this parameter...
		            // REF: https://github.com/getsentry/raven-js/issues/1233
		            referrerPolicy: (utils_1.supportsReferrerPolicy() ? 'origin' : ''),
		        };
		        if (this.options.fetchParameters !== undefined) {
		            Object.assign(options, this.options.fetchParameters);
		        }
		        if (this.options.headers !== undefined) {
		            options.headers = this.options.headers;
		        }
		        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
		            global
		                .fetch(sentryRequest.url, options)
		                .then(function (response) {
		                var headers = {
		                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
		                    'retry-after': response.headers.get('Retry-After'),
		                };
		                _this._handleResponse({
		                    requestType: sentryRequest.type,
		                    response: response,
		                    headers: headers,
		                    resolve: resolve,
		                    reject: reject,
		                });
		            })
		                .catch(reject);
		        }));
		    };
		    return FetchTransport;
		}(base_1.BaseTransport));
		fetch.FetchTransport = FetchTransport;
		
		return fetch;
	}

	var xhr = {};

	var hasRequiredXhr;

	function requireXhr () {
		if (hasRequiredXhr) return xhr;
		hasRequiredXhr = 1;
		Object.defineProperty(xhr, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var core_1 = requireDist();
		var utils_1 = requireDist$3();
		var base_1 = requireBase();
		/** `XHR` based transport */
		var XHRTransport = /** @class */ (function (_super) {
		    tslib_1.__extends(XHRTransport, _super);
		    function XHRTransport() {
		        return _super !== null && _super.apply(this, arguments) || this;
		    }
		    /**
		     * @inheritDoc
		     */
		    XHRTransport.prototype.sendEvent = function (event) {
		        return this._sendRequest(core_1.eventToSentryRequest(event, this._api), event);
		    };
		    /**
		     * @inheritDoc
		     */
		    XHRTransport.prototype.sendSession = function (session) {
		        return this._sendRequest(core_1.sessionToSentryRequest(session, this._api), session);
		    };
		    /**
		     * @param sentryRequest Prepared SentryRequest to be delivered
		     * @param originalPayload Original payload used to create SentryRequest
		     */
		    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
		        var _this = this;
		        if (this._isRateLimited(sentryRequest.type)) {
		            return Promise.reject({
		                event: originalPayload,
		                type: sentryRequest.type,
		                reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
		                status: 429,
		            });
		        }
		        return this._buffer.add(new utils_1.SyncPromise(function (resolve, reject) {
		            var request = new XMLHttpRequest();
		            request.onreadystatechange = function () {
		                if (request.readyState === 4) {
		                    var headers = {
		                        'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
		                        'retry-after': request.getResponseHeader('Retry-After'),
		                    };
		                    _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
		                }
		            };
		            request.open('POST', sentryRequest.url);
		            for (var header in _this.options.headers) {
		                if (_this.options.headers.hasOwnProperty(header)) {
		                    request.setRequestHeader(header, _this.options.headers[header]);
		                }
		            }
		            request.send(sentryRequest.body);
		        }));
		    };
		    return XHRTransport;
		}(base_1.BaseTransport));
		xhr.XHRTransport = XHRTransport;
		
		return xhr;
	}

	var hasRequiredTransports;

	function requireTransports () {
		if (hasRequiredTransports) return transports;
		hasRequiredTransports = 1;
		Object.defineProperty(transports, "__esModule", { value: true });
		var base_1 = requireBase();
		transports.BaseTransport = base_1.BaseTransport;
		var fetch_1 = requireFetch();
		transports.FetchTransport = fetch_1.FetchTransport;
		var xhr_1 = requireXhr();
		transports.XHRTransport = xhr_1.XHRTransport;
		
		return transports;
	}

	var hasRequiredBackend;

	function requireBackend () {
		if (hasRequiredBackend) return backend;
		hasRequiredBackend = 1;
		Object.defineProperty(backend, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var core_1 = requireDist();
		var types_1 = requireDist$4();
		var utils_1 = requireDist$3();
		var eventbuilder_1 = requireEventbuilder();
		var transports_1 = requireTransports();
		/**
		 * The Sentry Browser SDK Backend.
		 * @hidden
		 */
		var BrowserBackend = /** @class */ (function (_super) {
		    tslib_1.__extends(BrowserBackend, _super);
		    function BrowserBackend() {
		        return _super !== null && _super.apply(this, arguments) || this;
		    }
		    /**
		     * @inheritDoc
		     */
		    BrowserBackend.prototype.eventFromException = function (exception, hint) {
		        return eventbuilder_1.eventFromException(this._options, exception, hint);
		    };
		    /**
		     * @inheritDoc
		     */
		    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
		        if (level === void 0) { level = types_1.Severity.Info; }
		        return eventbuilder_1.eventFromMessage(this._options, message, level, hint);
		    };
		    /**
		     * @inheritDoc
		     */
		    BrowserBackend.prototype._setupTransport = function () {
		        if (!this._options.dsn) {
		            // We return the noop transport here in case there is no Dsn.
		            return _super.prototype._setupTransport.call(this);
		        }
		        var transportOptions = tslib_1.__assign(tslib_1.__assign({}, this._options.transportOptions), { dsn: this._options.dsn });
		        if (this._options.transport) {
		            return new this._options.transport(transportOptions);
		        }
		        if (utils_1.supportsFetch()) {
		            return new transports_1.FetchTransport(transportOptions);
		        }
		        return new transports_1.XHRTransport(transportOptions);
		    };
		    return BrowserBackend;
		}(core_1.BaseBackend));
		backend.BrowserBackend = BrowserBackend;
		
		return backend;
	}

	var helpers = {};

	var hasRequiredHelpers;

	function requireHelpers () {
		if (hasRequiredHelpers) return helpers;
		hasRequiredHelpers = 1;
		Object.defineProperty(helpers, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var core_1 = requireDist();
		var utils_1 = requireDist$3();
		var ignoreOnError = 0;
		/**
		 * @hidden
		 */
		function shouldIgnoreOnError() {
		    return ignoreOnError > 0;
		}
		helpers.shouldIgnoreOnError = shouldIgnoreOnError;
		/**
		 * @hidden
		 */
		function ignoreNextOnError() {
		    // onerror should trigger before setTimeout
		    ignoreOnError += 1;
		    setTimeout(function () {
		        ignoreOnError -= 1;
		    });
		}
		helpers.ignoreNextOnError = ignoreNextOnError;
		/**
		 * Instruments the given function and sends an event to Sentry every time the
		 * function throws an exception.
		 *
		 * @param fn A function to wrap.
		 * @returns The wrapped function.
		 * @hidden
		 */
		function wrap(fn, options, before) {
		    if (options === void 0) { options = {}; }
		    if (typeof fn !== 'function') {
		        return fn;
		    }
		    try {
		        // We don't wanna wrap it twice
		        if (fn.__sentry__) {
		            return fn;
		        }
		        // If this has already been wrapped in the past, return that wrapped function
		        if (fn.__sentry_wrapped__) {
		            return fn.__sentry_wrapped__;
		        }
		    }
		    catch (e) {
		        // Just accessing custom props in some Selenium environments
		        // can cause a "Permission denied" exception (see raven-js#495).
		        // Bail on wrapping and return the function as-is (defers to window.onerror).
		        return fn;
		    }
		    /* eslint-disable prefer-rest-params */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    var sentryWrapped = function () {
		        var args = Array.prototype.slice.call(arguments);
		        try {
		            if (before && typeof before === 'function') {
		                before.apply(this, arguments);
		            }
		            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
		            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
		            if (fn.handleEvent) {
		                // Attempt to invoke user-land function
		                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
		                //       means the sentry.javascript SDK caught an error invoking your application code. This
		                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
		                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		                return fn.handleEvent.apply(this, wrappedArguments);
		            }
		            // Attempt to invoke user-land function
		            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
		            //       means the sentry.javascript SDK caught an error invoking your application code. This
		            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
		            return fn.apply(this, wrappedArguments);
		        }
		        catch (ex) {
		            ignoreNextOnError();
		            core_1.withScope(function (scope) {
		                scope.addEventProcessor(function (event) {
		                    var processedEvent = tslib_1.__assign({}, event);
		                    if (options.mechanism) {
		                        utils_1.addExceptionTypeValue(processedEvent, undefined, undefined);
		                        utils_1.addExceptionMechanism(processedEvent, options.mechanism);
		                    }
		                    processedEvent.extra = tslib_1.__assign(tslib_1.__assign({}, processedEvent.extra), { arguments: args });
		                    return processedEvent;
		                });
		                core_1.captureException(ex);
		            });
		            throw ex;
		        }
		    };
		    /* eslint-enable prefer-rest-params */
		    // Accessing some objects may throw
		    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
		    try {
		        for (var property in fn) {
		            if (Object.prototype.hasOwnProperty.call(fn, property)) {
		                sentryWrapped[property] = fn[property];
		            }
		        }
		    }
		    catch (_oO) { } // eslint-disable-line no-empty
		    fn.prototype = fn.prototype || {};
		    sentryWrapped.prototype = fn.prototype;
		    Object.defineProperty(fn, '__sentry_wrapped__', {
		        enumerable: false,
		        value: sentryWrapped,
		    });
		    // Signal that this function has been wrapped/filled already
		    // for both debugging and to prevent it to being wrapped/filled twice
		    Object.defineProperties(sentryWrapped, {
		        __sentry__: {
		            enumerable: false,
		            value: true,
		        },
		        __sentry_original__: {
		            enumerable: false,
		            value: fn,
		        },
		    });
		    // Restore original function name (not all browsers allow that)
		    try {
		        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
		        if (descriptor.configurable) {
		            Object.defineProperty(sentryWrapped, 'name', {
		                get: function () {
		                    return fn.name;
		                },
		            });
		        }
		        // eslint-disable-next-line no-empty
		    }
		    catch (_oO) { }
		    return sentryWrapped;
		}
		helpers.wrap = wrap;
		/**
		 * Injects the Report Dialog script
		 * @hidden
		 */
		function injectReportDialog(options) {
		    if (options === void 0) { options = {}; }
		    if (!options.eventId) {
		        utils_1.logger.error("Missing eventId option in showReportDialog call");
		        return;
		    }
		    if (!options.dsn) {
		        utils_1.logger.error("Missing dsn option in showReportDialog call");
		        return;
		    }
		    var script = document.createElement('script');
		    script.async = true;
		    script.src = new core_1.API(options.dsn).getReportDialogEndpoint(options);
		    if (options.onLoad) {
		        // eslint-disable-next-line @typescript-eslint/unbound-method
		        script.onload = options.onLoad;
		    }
		    (document.head || document.body).appendChild(script);
		}
		helpers.injectReportDialog = injectReportDialog;
		
		return helpers;
	}

	var integrations = {};

	var globalhandlers = {};

	var hasRequiredGlobalhandlers;

	function requireGlobalhandlers () {
		if (hasRequiredGlobalhandlers) return globalhandlers;
		hasRequiredGlobalhandlers = 1;
		Object.defineProperty(globalhandlers, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		/* eslint-disable @typescript-eslint/no-unsafe-member-access */
		var core_1 = requireDist();
		var types_1 = requireDist$4();
		var utils_1 = requireDist$3();
		var eventbuilder_1 = requireEventbuilder();
		var helpers_1 = requireHelpers();
		/** Global handlers */
		var GlobalHandlers = /** @class */ (function () {
		    /** JSDoc */
		    function GlobalHandlers(options) {
		        /**
		         * @inheritDoc
		         */
		        this.name = GlobalHandlers.id;
		        /** JSDoc */
		        this._onErrorHandlerInstalled = false;
		        /** JSDoc */
		        this._onUnhandledRejectionHandlerInstalled = false;
		        this._options = tslib_1.__assign({ onerror: true, onunhandledrejection: true }, options);
		    }
		    /**
		     * @inheritDoc
		     */
		    GlobalHandlers.prototype.setupOnce = function () {
		        Error.stackTraceLimit = 50;
		        if (this._options.onerror) {
		            utils_1.logger.log('Global Handler attached: onerror');
		            this._installGlobalOnErrorHandler();
		        }
		        if (this._options.onunhandledrejection) {
		            utils_1.logger.log('Global Handler attached: onunhandledrejection');
		            this._installGlobalOnUnhandledRejectionHandler();
		        }
		    };
		    /** JSDoc */
		    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
		        var _this = this;
		        if (this._onErrorHandlerInstalled) {
		            return;
		        }
		        utils_1.addInstrumentationHandler({
		            // eslint-disable-next-line @typescript-eslint/no-explicit-any
		            callback: function (data) {
		                var error = data.error;
		                var currentHub = core_1.getCurrentHub();
		                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
		                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
		                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
		                    return;
		                }
		                var client = currentHub.getClient();
		                var event = utils_1.isPrimitive(error)
		                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
		                    : _this._enhanceEventWithInitialFrame(eventbuilder_1.eventFromUnknownInput(error, undefined, {
		                        attachStacktrace: client && client.getOptions().attachStacktrace,
		                        rejection: false,
		                    }), data.url, data.line, data.column);
		                utils_1.addExceptionMechanism(event, {
		                    handled: false,
		                    type: 'onerror',
		                });
		                currentHub.captureEvent(event, {
		                    originalException: error,
		                });
		            },
		            type: 'error',
		        });
		        this._onErrorHandlerInstalled = true;
		    };
		    /** JSDoc */
		    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
		        var _this = this;
		        if (this._onUnhandledRejectionHandlerInstalled) {
		            return;
		        }
		        utils_1.addInstrumentationHandler({
		            // eslint-disable-next-line @typescript-eslint/no-explicit-any
		            callback: function (e) {
		                var error = e;
		                // dig the object of the rejection out of known event types
		                try {
		                    // PromiseRejectionEvents store the object of the rejection under 'reason'
		                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
		                    if ('reason' in e) {
		                        error = e.reason;
		                    }
		                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
		                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
		                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
		                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
		                    // https://github.com/getsentry/sentry-javascript/issues/2380
		                    else if ('detail' in e && 'reason' in e.detail) {
		                        error = e.detail.reason;
		                    }
		                }
		                catch (_oO) {
		                    // no-empty
		                }
		                var currentHub = core_1.getCurrentHub();
		                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
		                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
		                if (!hasIntegration || helpers_1.shouldIgnoreOnError() || isFailedOwnDelivery) {
		                    return true;
		                }
		                var client = currentHub.getClient();
		                var event = utils_1.isPrimitive(error)
		                    ? _this._eventFromRejectionWithPrimitive(error)
		                    : eventbuilder_1.eventFromUnknownInput(error, undefined, {
		                        attachStacktrace: client && client.getOptions().attachStacktrace,
		                        rejection: true,
		                    });
		                event.level = types_1.Severity.Error;
		                utils_1.addExceptionMechanism(event, {
		                    handled: false,
		                    type: 'onunhandledrejection',
		                });
		                currentHub.captureEvent(event, {
		                    originalException: error,
		                });
		                return;
		            },
		            type: 'unhandledrejection',
		        });
		        this._onUnhandledRejectionHandlerInstalled = true;
		    };
		    /**
		     * This function creates a stack from an old, error-less onerror handler.
		     */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
		        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
		        // If 'message' is ErrorEvent, get real message from inside
		        var message = utils_1.isErrorEvent(msg) ? msg.message : msg;
		        var name;
		        if (utils_1.isString(message)) {
		            var groups = message.match(ERROR_TYPES_RE);
		            if (groups) {
		                name = groups[1];
		                message = groups[2];
		            }
		        }
		        var event = {
		            exception: {
		                values: [
		                    {
		                        type: name || 'Error',
		                        value: message,
		                    },
		                ],
		            },
		        };
		        return this._enhanceEventWithInitialFrame(event, url, line, column);
		    };
		    /**
		     * Create an event from a promise rejection where the `reason` is a primitive.
		     *
		     * @param reason: The `reason` property of the promise rejection
		     * @returns An Event object with an appropriate `exception` value
		     */
		    GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function (reason) {
		        return {
		            exception: {
		                values: [
		                    {
		                        type: 'UnhandledRejection',
		                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
		                        value: "Non-Error promise rejection captured with value: " + String(reason),
		                    },
		                ],
		            },
		        };
		    };
		    /** JSDoc */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
		        event.exception = event.exception || {};
		        event.exception.values = event.exception.values || [];
		        event.exception.values[0] = event.exception.values[0] || {};
		        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
		        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
		        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
		        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
		        var filename = utils_1.isString(url) && url.length > 0 ? url : utils_1.getLocationHref();
		        if (event.exception.values[0].stacktrace.frames.length === 0) {
		            event.exception.values[0].stacktrace.frames.push({
		                colno: colno,
		                filename: filename,
		                function: '?',
		                in_app: true,
		                lineno: lineno,
		            });
		        }
		        return event;
		    };
		    /**
		     * @inheritDoc
		     */
		    GlobalHandlers.id = 'GlobalHandlers';
		    return GlobalHandlers;
		}());
		globalhandlers.GlobalHandlers = GlobalHandlers;
		
		return globalhandlers;
	}

	var trycatch = {};

	var hasRequiredTrycatch;

	function requireTrycatch () {
		if (hasRequiredTrycatch) return trycatch;
		hasRequiredTrycatch = 1;
		Object.defineProperty(trycatch, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var utils_1 = requireDist$3();
		var helpers_1 = requireHelpers();
		var DEFAULT_EVENT_TARGET = [
		    'EventTarget',
		    'Window',
		    'Node',
		    'ApplicationCache',
		    'AudioTrackList',
		    'ChannelMergerNode',
		    'CryptoOperation',
		    'EventSource',
		    'FileReader',
		    'HTMLUnknownElement',
		    'IDBDatabase',
		    'IDBRequest',
		    'IDBTransaction',
		    'KeyOperation',
		    'MediaController',
		    'MessagePort',
		    'ModalWindow',
		    'Notification',
		    'SVGElementInstance',
		    'Screen',
		    'TextTrack',
		    'TextTrackCue',
		    'TextTrackList',
		    'WebSocket',
		    'WebSocketWorker',
		    'Worker',
		    'XMLHttpRequest',
		    'XMLHttpRequestEventTarget',
		    'XMLHttpRequestUpload',
		];
		/** Wrap timer functions and event targets to catch errors and provide better meta data */
		var TryCatch = /** @class */ (function () {
		    /**
		     * @inheritDoc
		     */
		    function TryCatch(options) {
		        /**
		         * @inheritDoc
		         */
		        this.name = TryCatch.id;
		        this._options = tslib_1.__assign({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
		    }
		    /**
		     * Wrap timer functions and event targets to catch errors
		     * and provide better metadata.
		     */
		    TryCatch.prototype.setupOnce = function () {
		        var global = utils_1.getGlobalObject();
		        if (this._options.setTimeout) {
		            utils_1.fill(global, 'setTimeout', this._wrapTimeFunction.bind(this));
		        }
		        if (this._options.setInterval) {
		            utils_1.fill(global, 'setInterval', this._wrapTimeFunction.bind(this));
		        }
		        if (this._options.requestAnimationFrame) {
		            utils_1.fill(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
		        }
		        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
		            utils_1.fill(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
		        }
		        if (this._options.eventTarget) {
		            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
		            eventTarget.forEach(this._wrapEventTarget.bind(this));
		        }
		    };
		    /** JSDoc */
		    TryCatch.prototype._wrapTimeFunction = function (original) {
		        // eslint-disable-next-line @typescript-eslint/no-explicit-any
		        return function () {
		            var args = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                args[_i] = arguments[_i];
		            }
		            var originalCallback = args[0];
		            args[0] = helpers_1.wrap(originalCallback, {
		                mechanism: {
		                    data: { function: utils_1.getFunctionName(original) },
		                    handled: true,
		                    type: 'instrument',
		                },
		            });
		            return original.apply(this, args);
		        };
		    };
		    /** JSDoc */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    TryCatch.prototype._wrapRAF = function (original) {
		        // eslint-disable-next-line @typescript-eslint/no-explicit-any
		        return function (callback) {
		            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		            return original.call(this, helpers_1.wrap(callback, {
		                mechanism: {
		                    data: {
		                        function: 'requestAnimationFrame',
		                        handler: utils_1.getFunctionName(original),
		                    },
		                    handled: true,
		                    type: 'instrument',
		                },
		            }));
		        };
		    };
		    /** JSDoc */
		    TryCatch.prototype._wrapEventTarget = function (target) {
		        // eslint-disable-next-line @typescript-eslint/no-explicit-any
		        var global = utils_1.getGlobalObject();
		        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		        var proto = global[target] && global[target].prototype;
		        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
		            return;
		        }
		        utils_1.fill(proto, 'addEventListener', function (original) {
		            return function (eventName, fn, options) {
		                try {
		                    if (typeof fn.handleEvent === 'function') {
		                        fn.handleEvent = helpers_1.wrap(fn.handleEvent.bind(fn), {
		                            mechanism: {
		                                data: {
		                                    function: 'handleEvent',
		                                    handler: utils_1.getFunctionName(fn),
		                                    target: target,
		                                },
		                                handled: true,
		                                type: 'instrument',
		                            },
		                        });
		                    }
		                }
		                catch (err) {
		                    // can sometimes get 'Permission denied to access property "handle Event'
		                }
		                return original.call(this, eventName, 
		                // eslint-disable-next-line @typescript-eslint/no-explicit-any
		                helpers_1.wrap(fn, {
		                    mechanism: {
		                        data: {
		                            function: 'addEventListener',
		                            handler: utils_1.getFunctionName(fn),
		                            target: target,
		                        },
		                        handled: true,
		                        type: 'instrument',
		                    },
		                }), options);
		            };
		        });
		        utils_1.fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
		            return function (eventName, fn, options) {
		                var _a;
		                /**
		                 * There are 2 possible scenarios here:
		                 *
		                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
		                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
		                 * as a pass-through, and call original `removeEventListener` with it.
		                 *
		                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
		                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
		                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
		                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
		                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
		                 *
		                 * When someone adds a handler prior to initialization, and then do it again, but after,
		                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
		                 * to get rid of the initial handler and it'd stick there forever.
		                 */
		                var wrappedEventHandler = fn;
		                try {
		                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
		                    if (originalEventHandler) {
		                        originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
		                    }
		                }
		                catch (e) {
		                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
		                }
		                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
		            };
		        });
		    };
		    /** JSDoc */
		    TryCatch.prototype._wrapXHR = function (originalSend) {
		        // eslint-disable-next-line @typescript-eslint/no-explicit-any
		        return function () {
		            var args = [];
		            for (var _i = 0; _i < arguments.length; _i++) {
		                args[_i] = arguments[_i];
		            }
		            // eslint-disable-next-line @typescript-eslint/no-this-alias
		            var xhr = this;
		            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
		            xmlHttpRequestProps.forEach(function (prop) {
		                if (prop in xhr && typeof xhr[prop] === 'function') {
		                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		                    utils_1.fill(xhr, prop, function (original) {
		                        var wrapOptions = {
		                            mechanism: {
		                                data: {
		                                    function: prop,
		                                    handler: utils_1.getFunctionName(original),
		                                },
		                                handled: true,
		                                type: 'instrument',
		                            },
		                        };
		                        // If Instrument integration has been called before TryCatch, get the name of original function
		                        if (original.__sentry_original__) {
		                            wrapOptions.mechanism.data.handler = utils_1.getFunctionName(original.__sentry_original__);
		                        }
		                        // Otherwise wrap directly
		                        return helpers_1.wrap(original, wrapOptions);
		                    });
		                }
		            });
		            return originalSend.apply(this, args);
		        };
		    };
		    /**
		     * @inheritDoc
		     */
		    TryCatch.id = 'TryCatch';
		    return TryCatch;
		}());
		trycatch.TryCatch = TryCatch;
		
		return trycatch;
	}

	var breadcrumbs = {};

	var hasRequiredBreadcrumbs;

	function requireBreadcrumbs () {
		if (hasRequiredBreadcrumbs) return breadcrumbs;
		hasRequiredBreadcrumbs = 1;
		Object.defineProperty(breadcrumbs, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		/* eslint-disable @typescript-eslint/no-unsafe-member-access */
		/* eslint-disable max-lines */
		var core_1 = requireDist();
		var types_1 = requireDist$4();
		var utils_1 = requireDist$3();
		/**
		 * Default Breadcrumbs instrumentations
		 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
		 */
		var Breadcrumbs = /** @class */ (function () {
		    /**
		     * @inheritDoc
		     */
		    function Breadcrumbs(options) {
		        /**
		         * @inheritDoc
		         */
		        this.name = Breadcrumbs.id;
		        this._options = tslib_1.__assign({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
		    }
		    /**
		     * Create a breadcrumb of `sentry` from the events themselves
		     */
		    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
		        if (!this._options.sentry) {
		            return;
		        }
		        core_1.getCurrentHub().addBreadcrumb({
		            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
		            event_id: event.event_id,
		            level: event.level,
		            message: utils_1.getEventDescription(event),
		        }, {
		            event: event,
		        });
		    };
		    /**
		     * Instrument browser built-ins w/ breadcrumb capturing
		     *  - Console API
		     *  - DOM API (click/typing)
		     *  - XMLHttpRequest API
		     *  - Fetch API
		     *  - History API
		     */
		    Breadcrumbs.prototype.setupOnce = function () {
		        var _this = this;
		        if (this._options.console) {
		            utils_1.addInstrumentationHandler({
		                callback: function () {
		                    var args = [];
		                    for (var _i = 0; _i < arguments.length; _i++) {
		                        args[_i] = arguments[_i];
		                    }
		                    _this._consoleBreadcrumb.apply(_this, tslib_1.__spread(args));
		                },
		                type: 'console',
		            });
		        }
		        if (this._options.dom) {
		            utils_1.addInstrumentationHandler({
		                callback: function () {
		                    var args = [];
		                    for (var _i = 0; _i < arguments.length; _i++) {
		                        args[_i] = arguments[_i];
		                    }
		                    _this._domBreadcrumb.apply(_this, tslib_1.__spread(args));
		                },
		                type: 'dom',
		            });
		        }
		        if (this._options.xhr) {
		            utils_1.addInstrumentationHandler({
		                callback: function () {
		                    var args = [];
		                    for (var _i = 0; _i < arguments.length; _i++) {
		                        args[_i] = arguments[_i];
		                    }
		                    _this._xhrBreadcrumb.apply(_this, tslib_1.__spread(args));
		                },
		                type: 'xhr',
		            });
		        }
		        if (this._options.fetch) {
		            utils_1.addInstrumentationHandler({
		                callback: function () {
		                    var args = [];
		                    for (var _i = 0; _i < arguments.length; _i++) {
		                        args[_i] = arguments[_i];
		                    }
		                    _this._fetchBreadcrumb.apply(_this, tslib_1.__spread(args));
		                },
		                type: 'fetch',
		            });
		        }
		        if (this._options.history) {
		            utils_1.addInstrumentationHandler({
		                callback: function () {
		                    var args = [];
		                    for (var _i = 0; _i < arguments.length; _i++) {
		                        args[_i] = arguments[_i];
		                    }
		                    _this._historyBreadcrumb.apply(_this, tslib_1.__spread(args));
		                },
		                type: 'history',
		            });
		        }
		    };
		    /**
		     * Creates breadcrumbs from console API calls
		     */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
		        var breadcrumb = {
		            category: 'console',
		            data: {
		                arguments: handlerData.args,
		                logger: 'console',
		            },
		            level: types_1.Severity.fromString(handlerData.level),
		            message: utils_1.safeJoin(handlerData.args, ' '),
		        };
		        if (handlerData.level === 'assert') {
		            if (handlerData.args[0] === false) {
		                breadcrumb.message = "Assertion failed: " + (utils_1.safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
		                breadcrumb.data.arguments = handlerData.args.slice(1);
		            }
		            else {
		                // Don't capture a breadcrumb for passed assertions
		                return;
		            }
		        }
		        core_1.getCurrentHub().addBreadcrumb(breadcrumb, {
		            input: handlerData.args,
		            level: handlerData.level,
		        });
		    };
		    /**
		     * Creates breadcrumbs from DOM API calls
		     */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
		        var target;
		        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
		        try {
		            target = handlerData.event.target
		                ? utils_1.htmlTreeAsString(handlerData.event.target)
		                : utils_1.htmlTreeAsString(handlerData.event);
		        }
		        catch (e) {
		            target = '<unknown>';
		        }
		        if (target.length === 0) {
		            return;
		        }
		        core_1.getCurrentHub().addBreadcrumb({
		            category: "ui." + handlerData.name,
		            message: target,
		        }, {
		            event: handlerData.event,
		            name: handlerData.name,
		        });
		    };
		    /**
		     * Creates breadcrumbs from XHR API calls
		     */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
		        if (handlerData.endTimestamp) {
		            // We only capture complete, non-sentry requests
		            if (handlerData.xhr.__sentry_own_request__) {
		                return;
		            }
		            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
		            core_1.getCurrentHub().addBreadcrumb({
		                category: 'xhr',
		                data: {
		                    method: method,
		                    url: url,
		                    status_code: status_code,
		                },
		                type: 'http',
		            }, {
		                xhr: handlerData.xhr,
		                input: body,
		            });
		            return;
		        }
		    };
		    /**
		     * Creates breadcrumbs from fetch API calls
		     */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
		        // We only capture complete fetch requests
		        if (!handlerData.endTimestamp) {
		            return;
		        }
		        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
		            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
		            return;
		        }
		        if (handlerData.error) {
		            core_1.getCurrentHub().addBreadcrumb({
		                category: 'fetch',
		                data: handlerData.fetchData,
		                level: types_1.Severity.Error,
		                type: 'http',
		            }, {
		                data: handlerData.error,
		                input: handlerData.args,
		            });
		        }
		        else {
		            core_1.getCurrentHub().addBreadcrumb({
		                category: 'fetch',
		                data: tslib_1.__assign(tslib_1.__assign({}, handlerData.fetchData), { status_code: handlerData.response.status }),
		                type: 'http',
		            }, {
		                input: handlerData.args,
		                response: handlerData.response,
		            });
		        }
		    };
		    /**
		     * Creates breadcrumbs from history API calls
		     */
		    // eslint-disable-next-line @typescript-eslint/no-explicit-any
		    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
		        var global = utils_1.getGlobalObject();
		        var from = handlerData.from;
		        var to = handlerData.to;
		        var parsedLoc = utils_1.parseUrl(global.location.href);
		        var parsedFrom = utils_1.parseUrl(from);
		        var parsedTo = utils_1.parseUrl(to);
		        // Initial pushState doesn't provide `from` information
		        if (!parsedFrom.path) {
		            parsedFrom = parsedLoc;
		        }
		        // Use only the path component of the URL if the URL matches the current
		        // document (almost all the time when using pushState)
		        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
		            to = parsedTo.relative;
		        }
		        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
		            from = parsedFrom.relative;
		        }
		        core_1.getCurrentHub().addBreadcrumb({
		            category: 'navigation',
		            data: {
		                from: from,
		                to: to,
		            },
		        });
		    };
		    /**
		     * @inheritDoc
		     */
		    Breadcrumbs.id = 'Breadcrumbs';
		    return Breadcrumbs;
		}());
		breadcrumbs.Breadcrumbs = Breadcrumbs;
		
		return breadcrumbs;
	}

	var linkederrors = {};

	var hasRequiredLinkederrors;

	function requireLinkederrors () {
		if (hasRequiredLinkederrors) return linkederrors;
		hasRequiredLinkederrors = 1;
		Object.defineProperty(linkederrors, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var core_1 = requireDist();
		var utils_1 = requireDist$3();
		var parsers_1 = requireParsers();
		var tracekit_1 = requireTracekit();
		var DEFAULT_KEY = 'cause';
		var DEFAULT_LIMIT = 5;
		/** Adds SDK info to an event. */
		var LinkedErrors = /** @class */ (function () {
		    /**
		     * @inheritDoc
		     */
		    function LinkedErrors(options) {
		        if (options === void 0) { options = {}; }
		        /**
		         * @inheritDoc
		         */
		        this.name = LinkedErrors.id;
		        this._key = options.key || DEFAULT_KEY;
		        this._limit = options.limit || DEFAULT_LIMIT;
		    }
		    /**
		     * @inheritDoc
		     */
		    LinkedErrors.prototype.setupOnce = function () {
		        core_1.addGlobalEventProcessor(function (event, hint) {
		            var self = core_1.getCurrentHub().getIntegration(LinkedErrors);
		            if (self) {
		                return self._handler(event, hint);
		            }
		            return event;
		        });
		    };
		    /**
		     * @inheritDoc
		     */
		    LinkedErrors.prototype._handler = function (event, hint) {
		        if (!event.exception || !event.exception.values || !hint || !utils_1.isInstanceOf(hint.originalException, Error)) {
		            return event;
		        }
		        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
		        event.exception.values = tslib_1.__spread(linkedErrors, event.exception.values);
		        return event;
		    };
		    /**
		     * @inheritDoc
		     */
		    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
		        if (stack === void 0) { stack = []; }
		        if (!utils_1.isInstanceOf(error[key], Error) || stack.length + 1 >= this._limit) {
		            return stack;
		        }
		        var stacktrace = tracekit_1.computeStackTrace(error[key]);
		        var exception = parsers_1.exceptionFromStacktrace(stacktrace);
		        return this._walkErrorTree(error[key], key, tslib_1.__spread([exception], stack));
		    };
		    /**
		     * @inheritDoc
		     */
		    LinkedErrors.id = 'LinkedErrors';
		    return LinkedErrors;
		}());
		linkederrors.LinkedErrors = LinkedErrors;
		
		return linkederrors;
	}

	var useragent = {};

	var hasRequiredUseragent;

	function requireUseragent () {
		if (hasRequiredUseragent) return useragent;
		hasRequiredUseragent = 1;
		Object.defineProperty(useragent, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var core_1 = requireDist();
		var utils_1 = requireDist$3();
		var global = utils_1.getGlobalObject();
		/** UserAgent */
		var UserAgent = /** @class */ (function () {
		    function UserAgent() {
		        /**
		         * @inheritDoc
		         */
		        this.name = UserAgent.id;
		    }
		    /**
		     * @inheritDoc
		     */
		    UserAgent.prototype.setupOnce = function () {
		        core_1.addGlobalEventProcessor(function (event) {
		            var _a, _b, _c;
		            if (core_1.getCurrentHub().getIntegration(UserAgent)) {
		                // if none of the information we want exists, don't bother
		                if (!global.navigator && !global.location && !global.document) {
		                    return event;
		                }
		                // grab as much info as exists and add it to the event
		                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = global.location) === null || _b === void 0 ? void 0 : _b.href);
		                var referrer = (global.document || {}).referrer;
		                var userAgent = (global.navigator || {}).userAgent;
		                var headers = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
		                var request = tslib_1.__assign(tslib_1.__assign({}, (url && { url: url })), { headers: headers });
		                return tslib_1.__assign(tslib_1.__assign({}, event), { request: request });
		            }
		            return event;
		        });
		    };
		    /**
		     * @inheritDoc
		     */
		    UserAgent.id = 'UserAgent';
		    return UserAgent;
		}());
		useragent.UserAgent = UserAgent;
		
		return useragent;
	}

	var hasRequiredIntegrations;

	function requireIntegrations () {
		if (hasRequiredIntegrations) return integrations;
		hasRequiredIntegrations = 1;
		Object.defineProperty(integrations, "__esModule", { value: true });
		var globalhandlers_1 = requireGlobalhandlers();
		integrations.GlobalHandlers = globalhandlers_1.GlobalHandlers;
		var trycatch_1 = requireTrycatch();
		integrations.TryCatch = trycatch_1.TryCatch;
		var breadcrumbs_1 = requireBreadcrumbs();
		integrations.Breadcrumbs = breadcrumbs_1.Breadcrumbs;
		var linkederrors_1 = requireLinkederrors();
		integrations.LinkedErrors = linkederrors_1.LinkedErrors;
		var useragent_1 = requireUseragent();
		integrations.UserAgent = useragent_1.UserAgent;
		
		return integrations;
	}

	var version = {};

	var hasRequiredVersion;

	function requireVersion () {
		if (hasRequiredVersion) return version;
		hasRequiredVersion = 1;
		Object.defineProperty(version, "__esModule", { value: true });
		version.SDK_NAME = 'sentry.javascript.browser';
		version.SDK_VERSION = '5.30.0';
		
		return version;
	}

	var hasRequiredClient;

	function requireClient () {
		if (hasRequiredClient) return client;
		hasRequiredClient = 1;
		Object.defineProperty(client, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		var core_1 = requireDist();
		var utils_1 = requireDist$3();
		var backend_1 = requireBackend();
		var helpers_1 = requireHelpers();
		var integrations_1 = requireIntegrations();
		var version_1 = requireVersion();
		/**
		 * The Sentry Browser SDK Client.
		 *
		 * @see BrowserOptions for documentation on configuration options.
		 * @see SentryClient for usage documentation.
		 */
		var BrowserClient = /** @class */ (function (_super) {
		    tslib_1.__extends(BrowserClient, _super);
		    /**
		     * Creates a new Browser SDK instance.
		     *
		     * @param options Configuration options for this SDK.
		     */
		    function BrowserClient(options) {
		        if (options === void 0) { options = {}; }
		        return _super.call(this, backend_1.BrowserBackend, options) || this;
		    }
		    /**
		     * Show a report dialog to the user to send feedback to a specific event.
		     *
		     * @param options Set individual options for the dialog
		     */
		    BrowserClient.prototype.showReportDialog = function (options) {
		        if (options === void 0) { options = {}; }
		        // doesn't work without a document (React Native)
		        var document = utils_1.getGlobalObject().document;
		        if (!document) {
		            return;
		        }
		        if (!this._isEnabled()) {
		            utils_1.logger.error('Trying to call showReportDialog with Sentry Client disabled');
		            return;
		        }
		        helpers_1.injectReportDialog(tslib_1.__assign(tslib_1.__assign({}, options), { dsn: options.dsn || this.getDsn() }));
		    };
		    /**
		     * @inheritDoc
		     */
		    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
		        event.platform = event.platform || 'javascript';
		        event.sdk = tslib_1.__assign(tslib_1.__assign({}, event.sdk), { name: version_1.SDK_NAME, packages: tslib_1.__spread(((event.sdk && event.sdk.packages) || []), [
		                {
		                    name: 'npm:@sentry/browser',
		                    version: version_1.SDK_VERSION,
		                },
		            ]), version: version_1.SDK_VERSION });
		        return _super.prototype._prepareEvent.call(this, event, scope, hint);
		    };
		    /**
		     * @inheritDoc
		     */
		    BrowserClient.prototype._sendEvent = function (event) {
		        var integration = this.getIntegration(integrations_1.Breadcrumbs);
		        if (integration) {
		            integration.addSentryBreadcrumb(event);
		        }
		        _super.prototype._sendEvent.call(this, event);
		    };
		    return BrowserClient;
		}(core_1.BaseClient));
		client.BrowserClient = BrowserClient;
		
		return client;
	}

	var sdk = {};

	var hasRequiredSdk;

	function requireSdk () {
		if (hasRequiredSdk) return sdk;
		hasRequiredSdk = 1;
		(function (exports) {
			Object.defineProperty(exports, "__esModule", { value: true });
			var core_1 = requireDist();
			var utils_1 = requireDist$3();
			var client_1 = requireClient();
			var helpers_1 = requireHelpers();
			var integrations_1 = requireIntegrations();
			exports.defaultIntegrations = [
			    new core_1.Integrations.InboundFilters(),
			    new core_1.Integrations.FunctionToString(),
			    new integrations_1.TryCatch(),
			    new integrations_1.Breadcrumbs(),
			    new integrations_1.GlobalHandlers(),
			    new integrations_1.LinkedErrors(),
			    new integrations_1.UserAgent(),
			];
			/**
			 * The Sentry Browser SDK Client.
			 *
			 * To use this SDK, call the {@link init} function as early as possible when
			 * loading the web page. To set context information or send manual events, use
			 * the provided methods.
			 *
			 * @example
			 *
			 * ```
			 *
			 * import { init } from '@sentry/browser';
			 *
			 * init({
			 *   dsn: '__DSN__',
			 *   // ...
			 * });
			 * ```
			 *
			 * @example
			 * ```
			 *
			 * import { configureScope } from '@sentry/browser';
			 * configureScope((scope: Scope) => {
			 *   scope.setExtra({ battery: 0.7 });
			 *   scope.setTag({ user_mode: 'admin' });
			 *   scope.setUser({ id: '4711' });
			 * });
			 * ```
			 *
			 * @example
			 * ```
			 *
			 * import { addBreadcrumb } from '@sentry/browser';
			 * addBreadcrumb({
			 *   message: 'My Breadcrumb',
			 *   // ...
			 * });
			 * ```
			 *
			 * @example
			 *
			 * ```
			 *
			 * import * as Sentry from '@sentry/browser';
			 * Sentry.captureMessage('Hello, world!');
			 * Sentry.captureException(new Error('Good bye'));
			 * Sentry.captureEvent({
			 *   message: 'Manual',
			 *   stacktrace: [
			 *     // ...
			 *   ],
			 * });
			 * ```
			 *
			 * @see {@link BrowserOptions} for documentation on configuration options.
			 */
			function init(options) {
			    if (options === void 0) { options = {}; }
			    if (options.defaultIntegrations === undefined) {
			        options.defaultIntegrations = exports.defaultIntegrations;
			    }
			    if (options.release === undefined) {
			        var window_1 = utils_1.getGlobalObject();
			        // This supports the variable that sentry-webpack-plugin injects
			        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
			            options.release = window_1.SENTRY_RELEASE.id;
			        }
			    }
			    if (options.autoSessionTracking === undefined) {
			        options.autoSessionTracking = false;
			    }
			    core_1.initAndBind(client_1.BrowserClient, options);
			    if (options.autoSessionTracking) {
			        startSessionTracking();
			    }
			}
			exports.init = init;
			/**
			 * Present the user with a report dialog.
			 *
			 * @param options Everything is optional, we try to fetch all info need from the global scope.
			 */
			function showReportDialog(options) {
			    if (options === void 0) { options = {}; }
			    if (!options.eventId) {
			        options.eventId = core_1.getCurrentHub().lastEventId();
			    }
			    var client = core_1.getCurrentHub().getClient();
			    if (client) {
			        client.showReportDialog(options);
			    }
			}
			exports.showReportDialog = showReportDialog;
			/**
			 * This is the getter for lastEventId.
			 *
			 * @returns The last event id of a captured event.
			 */
			function lastEventId() {
			    return core_1.getCurrentHub().lastEventId();
			}
			exports.lastEventId = lastEventId;
			/**
			 * This function is here to be API compatible with the loader.
			 * @hidden
			 */
			function forceLoad() {
			    // Noop
			}
			exports.forceLoad = forceLoad;
			/**
			 * This function is here to be API compatible with the loader.
			 * @hidden
			 */
			function onLoad(callback) {
			    callback();
			}
			exports.onLoad = onLoad;
			/**
			 * A promise that resolves when all current events have been sent.
			 * If you provide a timeout and the queue takes longer to drain the promise returns false.
			 *
			 * @param timeout Maximum time in ms the client should wait.
			 */
			function flush(timeout) {
			    var client = core_1.getCurrentHub().getClient();
			    if (client) {
			        return client.flush(timeout);
			    }
			    return utils_1.SyncPromise.reject(false);
			}
			exports.flush = flush;
			/**
			 * A promise that resolves when all current events have been sent.
			 * If you provide a timeout and the queue takes longer to drain the promise returns false.
			 *
			 * @param timeout Maximum time in ms the client should wait.
			 */
			function close(timeout) {
			    var client = core_1.getCurrentHub().getClient();
			    if (client) {
			        return client.close(timeout);
			    }
			    return utils_1.SyncPromise.reject(false);
			}
			exports.close = close;
			/**
			 * Wrap code within a try/catch block so the SDK is able to capture errors.
			 *
			 * @param fn A function to wrap.
			 *
			 * @returns The result of wrapped function call.
			 */
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			function wrap(fn) {
			    return helpers_1.wrap(fn)();
			}
			exports.wrap = wrap;
			/**
			 * Enable automatic Session Tracking for the initial page load.
			 */
			function startSessionTracking() {
			    var window = utils_1.getGlobalObject();
			    var hub = core_1.getCurrentHub();
			    /**
			     * We should be using `Promise.all([windowLoaded, firstContentfulPaint])` here,
			     * but, as always, it's not available in the IE10-11. Thanks IE.
			     */
			    var loadResolved = document.readyState === 'complete';
			    var fcpResolved = false;
			    var possiblyEndSession = function () {
			        if (fcpResolved && loadResolved) {
			            hub.endSession();
			        }
			    };
			    var resolveWindowLoaded = function () {
			        loadResolved = true;
			        possiblyEndSession();
			        window.removeEventListener('load', resolveWindowLoaded);
			    };
			    hub.startSession();
			    if (!loadResolved) {
			        // IE doesn't support `{ once: true }` for event listeners, so we have to manually
			        // attach and then detach it once completed.
			        window.addEventListener('load', resolveWindowLoaded);
			    }
			    try {
			        var po = new PerformanceObserver(function (entryList, po) {
			            entryList.getEntries().forEach(function (entry) {
			                if (entry.name === 'first-contentful-paint' && entry.startTime < firstHiddenTime_1) {
			                    po.disconnect();
			                    fcpResolved = true;
			                    possiblyEndSession();
			                }
			            });
			        });
			        // There's no need to even attach this listener if `PerformanceObserver` constructor will fail,
			        // so we do it below here.
			        var firstHiddenTime_1 = document.visibilityState === 'hidden' ? 0 : Infinity;
			        document.addEventListener('visibilitychange', function (event) {
			            firstHiddenTime_1 = Math.min(firstHiddenTime_1, event.timeStamp);
			        }, { once: true });
			        po.observe({
			            type: 'paint',
			            buffered: true,
			        });
			    }
			    catch (e) {
			        fcpResolved = true;
			        possiblyEndSession();
			    }
			}
			
	} (sdk));
		return sdk;
	}

	var hasRequiredExports;

	function requireExports () {
		if (hasRequiredExports) return exports$1;
		hasRequiredExports = 1;
		Object.defineProperty(exports$1, "__esModule", { value: true });
		var types_1 = requireDist$4();
		exports$1.Severity = types_1.Severity;
		exports$1.Status = types_1.Status;
		var core_1 = requireDist();
		exports$1.addGlobalEventProcessor = core_1.addGlobalEventProcessor;
		exports$1.addBreadcrumb = core_1.addBreadcrumb;
		exports$1.captureException = core_1.captureException;
		exports$1.captureEvent = core_1.captureEvent;
		exports$1.captureMessage = core_1.captureMessage;
		exports$1.configureScope = core_1.configureScope;
		exports$1.getHubFromCarrier = core_1.getHubFromCarrier;
		exports$1.getCurrentHub = core_1.getCurrentHub;
		exports$1.Hub = core_1.Hub;
		exports$1.makeMain = core_1.makeMain;
		exports$1.Scope = core_1.Scope;
		exports$1.startTransaction = core_1.startTransaction;
		exports$1.setContext = core_1.setContext;
		exports$1.setExtra = core_1.setExtra;
		exports$1.setExtras = core_1.setExtras;
		exports$1.setTag = core_1.setTag;
		exports$1.setTags = core_1.setTags;
		exports$1.setUser = core_1.setUser;
		exports$1.withScope = core_1.withScope;
		var client_1 = requireClient();
		exports$1.BrowserClient = client_1.BrowserClient;
		var helpers_1 = requireHelpers();
		exports$1.injectReportDialog = helpers_1.injectReportDialog;
		var eventbuilder_1 = requireEventbuilder();
		exports$1.eventFromException = eventbuilder_1.eventFromException;
		exports$1.eventFromMessage = eventbuilder_1.eventFromMessage;
		var sdk_1 = requireSdk();
		exports$1.defaultIntegrations = sdk_1.defaultIntegrations;
		exports$1.forceLoad = sdk_1.forceLoad;
		exports$1.init = sdk_1.init;
		exports$1.lastEventId = sdk_1.lastEventId;
		exports$1.onLoad = sdk_1.onLoad;
		exports$1.showReportDialog = sdk_1.showReportDialog;
		exports$1.flush = sdk_1.flush;
		exports$1.close = sdk_1.close;
		exports$1.wrap = sdk_1.wrap;
		var version_1 = requireVersion();
		exports$1.SDK_NAME = version_1.SDK_NAME;
		exports$1.SDK_VERSION = version_1.SDK_VERSION;
		
		return exports$1;
	}

	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		var tslib_1 = require$$0$1;
		tslib_1.__exportStar(requireExports(), exports);
		var core_1 = requireDist();
		var utils_1 = requireDist$3();
		var BrowserIntegrations = requireIntegrations();
		var Transports = requireTransports();
		exports.Transports = Transports;
		var windowIntegrations = {};
		// This block is needed to add compatibility with the integrations packages when used with a CDN
		var _window = utils_1.getGlobalObject();
		if (_window.Sentry && _window.Sentry.Integrations) {
		    windowIntegrations = _window.Sentry.Integrations;
		}
		var INTEGRATIONS = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, windowIntegrations), core_1.Integrations), BrowserIntegrations);
		exports.Integrations = INTEGRATIONS;
		
	} (dist$5));

	var operationInfo = function operationInfo(operation) {
	  return {
	    type: operation.query.definitions.find(function (defn) {
	      return defn.operation;
	    }).operation,
	    name: operation.operationName,
	    fragments: operation.query.definitions.filter(function (defn) {
	      return defn.kind === 'FragmentDefinition';
	    }).map(function (defn) {
	      return defn.name.value;
	    }).join(', ')
	  };
	};

	var sentryLink = new lib$1.ApolloLink(function (operation, forward) {
	  if (process.env.NODE_ENV === 'development') {
	    console.table(operationInfo(operation));
	  } else {
	    dist$5.addBreadcrumb({
	      category: 'graphql',
	      data: operationInfo(operation),
	      level: 'debug'
	    });
	  }

	  return forward(operation);
	});

	return sentryLink;

}));
